var _keyboardActions;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Matrix4, Box3, MathUtils, Texture, LinearMipmapLinearFilter, LinearFilter, Vector3, Vector2, ColorManagement, Quaternion, SphereGeometry, Mesh, MeshBasicMaterial, Cache as Cache$1, SplineCurve, WebGLRenderer, LinearSRGBColorSpace, Scene, PerspectiveCamera, Group, Raycaster, Frustum, WebGLRenderTarget, FileLoader, ImageLoader, Euler } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer 5.6.0
 * @copyright 2014-2015 Jérémy Heleine
 * @copyright 2024 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/data/constants.ts
var constants_exports = {};
__export(constants_exports, {
  ACTIONS: function ACTIONS() {
    return _ACTIONS;
  },
  ANIMATION_MIN_DURATION: function ANIMATION_MIN_DURATION() {
    return _ANIMATION_MIN_DURATION;
  },
  CAPTURE_EVENTS_CLASS: function CAPTURE_EVENTS_CLASS() {
    return _CAPTURE_EVENTS_CLASS;
  },
  CTRLZOOM_TIMEOUT: function CTRLZOOM_TIMEOUT() {
    return _CTRLZOOM_TIMEOUT;
  },
  DBLCLICK_DELAY: function DBLCLICK_DELAY() {
    return _DBLCLICK_DELAY;
  },
  DEFAULT_TRANSITION: function DEFAULT_TRANSITION() {
    return _DEFAULT_TRANSITION;
  },
  EASINGS: function EASINGS() {
    return _EASINGS;
  },
  ICONS: function ICONS() {
    return _ICONS;
  },
  IDS: function IDS() {
    return _IDS;
  },
  INERTIA_WINDOW: function INERTIA_WINDOW() {
    return _INERTIA_WINDOW;
  },
  KEY_CODES: function KEY_CODES() {
    return _KEY_CODES;
  },
  LONGTOUCH_DELAY: function LONGTOUCH_DELAY() {
    return _LONGTOUCH_DELAY;
  },
  MOVE_THRESHOLD: function MOVE_THRESHOLD() {
    return _MOVE_THRESHOLD;
  },
  SPHERE_RADIUS: function SPHERE_RADIUS() {
    return _SPHERE_RADIUS;
  },
  TWOFINGERSOVERLAY_DELAY: function TWOFINGERSOVERLAY_DELAY() {
    return _TWOFINGERSOVERLAY_DELAY;
  },
  VIEWER_DATA: function VIEWER_DATA() {
    return _VIEWER_DATA;
  }
});

// src/icons/arrow.svg
var arrow_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g><!-- Created by Flatart from the Noun Project --></svg>\n';

// src/icons/close.svg
var close_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="currentColor" transform=" translate(50, 50) rotate(45)"><rect x="-5" y="-65" width="10" height="130"/><rect x="-65" y="-5" width="130" height="10"/></g></svg>';

// src/icons/download.svg
var download_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/><!--Created by Michael Zenaty from the Noun Project--></svg>\n';

// src/icons/fullscreen-in.svg
var fullscreen_in_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/><!--Created by Garrett Knoll from the Noun Project--></svg>\n';

// src/icons/fullscreen-out.svg
var fullscreen_out_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/><!--Created by Garrett Knoll from the Noun Project--></svg>\n';

// src/icons/info.svg
var info_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/><!--Created by Arafat Uddin from the Noun Project--></svg>\n';

// src/icons/menu.svg
var menu_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g><!-- Created by Richard Kun\xE1k from the Noun Project--></svg>\n';

// src/icons/zoom-in.svg
var zoom_in_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/><!--Created by Ryan Canning from the Noun Project--></svg>\n';

// src/icons/zoom-out.svg
var zoom_out_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/><!--Created by Ryan Canning from the Noun Project--></svg>\n';

// src/data/constants.ts
var _DEFAULT_TRANSITION = 1500;
var _ANIMATION_MIN_DURATION = 500;
var _MOVE_THRESHOLD = 4;
var _DBLCLICK_DELAY = 300;
var _LONGTOUCH_DELAY = 500;
var _TWOFINGERSOVERLAY_DELAY = 100;
var _CTRLZOOM_TIMEOUT = 2e3;
var _INERTIA_WINDOW = 300;
var _SPHERE_RADIUS = 10;
var _VIEWER_DATA = "photoSphereViewer";
var _CAPTURE_EVENTS_CLASS = "psv--capture-event";
var _ACTIONS = /* @__PURE__ */function (ACTIONS2) {
  ACTIONS2["ROTATE_UP"] = "ROTATE_UP";
  ACTIONS2["ROTATE_DOWN"] = "ROTATE_DOWN";
  ACTIONS2["ROTATE_RIGHT"] = "ROTATE_RIGHT";
  ACTIONS2["ROTATE_LEFT"] = "ROTATE_LEFT";
  ACTIONS2["ZOOM_IN"] = "ZOOM_IN";
  ACTIONS2["ZOOM_OUT"] = "ZOOM_OUT";
  return ACTIONS2;
}(_ACTIONS || {});
var _IDS = {
  MENU: "menu",
  TWO_FINGERS: "twoFingers",
  CTRL_ZOOM: "ctrlZoom",
  ERROR: "error",
  DESCRIPTION: "description"
};
var _KEY_CODES = {
  Enter: "Enter",
  Control: "Control",
  Escape: "Escape",
  Space: " ",
  PageUp: "PageUp",
  PageDown: "PageDown",
  ArrowLeft: "ArrowLeft",
  ArrowUp: "ArrowUp",
  ArrowRight: "ArrowRight",
  ArrowDown: "ArrowDown",
  Delete: "Delete",
  Plus: "+",
  Minus: "-"
};
var _ICONS = {
  arrow: arrow_default,
  close: close_default,
  download: download_default,
  fullscreenIn: fullscreen_in_default,
  fullscreenOut: fullscreen_out_default,
  info: info_default,
  menu: menu_default,
  zoomIn: zoom_in_default,
  zoomOut: zoom_out_default
};
var _EASINGS = {
  linear: function linear(t) {
    return t;
  },
  inQuad: function inQuad(t) {
    return t * t;
  },
  outQuad: function outQuad(t) {
    return t * (2 - t);
  },
  inOutQuad: function inOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  inCubic: function inCubic(t) {
    return t * t * t;
  },
  outCubic: function outCubic(t) {
    return --t * t * t + 1;
  },
  inOutCubic: function inOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  inQuart: function inQuart(t) {
    return t * t * t * t;
  },
  outQuart: function outQuart(t) {
    return 1 - --t * t * t * t;
  },
  inOutQuart: function inOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  inQuint: function inQuint(t) {
    return t * t * t * t * t;
  },
  outQuint: function outQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  inOutQuint: function inOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  },
  inSine: function inSine(t) {
    return 1 - Math.cos(t * (Math.PI / 2));
  },
  outSine: function outSine(t) {
    return Math.sin(t * (Math.PI / 2));
  },
  inOutSine: function inOutSine(t) {
    return 0.5 - 0.5 * Math.cos(Math.PI * t);
  },
  inExpo: function inExpo(t) {
    return Math.pow(2, 10 * (t - 1));
  },
  outExpo: function outExpo(t) {
    return 1 - Math.pow(2, -10 * t);
  },
  inOutExpo: function inOutExpo(t) {
    return (t = t * 2 - 1) < 0 ? 0.5 * Math.pow(2, 10 * t) : 1 - 0.5 * Math.pow(2, -10 * t);
  },
  inCirc: function inCirc(t) {
    return 1 - Math.sqrt(1 - t * t);
  },
  outCirc: function outCirc(t) {
    return Math.sqrt(1 - (t - 1) * (t - 1));
  },
  inOutCirc: function inOutCirc(t) {
    return (t *= 2) < 1 ? 0.5 - 0.5 * Math.sqrt(1 - t * t) : 0.5 + 0.5 * Math.sqrt(1 - (t -= 2) * t);
  }
};

// src/utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  Animation: function Animation() {
    return _Animation;
  },
  Dynamic: function Dynamic() {
    return _Dynamic;
  },
  MultiDynamic: function MultiDynamic() {
    return _MultiDynamic;
  },
  PressHandler: function PressHandler() {
    return _PressHandler;
  },
  Slider: function Slider() {
    return _Slider;
  },
  SliderDirection: function SliderDirection() {
    return _SliderDirection;
  },
  addClasses: function addClasses() {
    return _addClasses;
  },
  angle: function angle() {
    return _angle;
  },
  applyEulerInverse: function applyEulerInverse() {
    return _applyEulerInverse;
  },
  checkStylesheet: function checkStylesheet() {
    return _checkStylesheet;
  },
  checkVersion: function checkVersion() {
    return _checkVersion;
  },
  cleanCssPosition: function cleanCssPosition() {
    return _cleanCssPosition;
  },
  clone: function clone() {
    return _clone;
  },
  createTexture: function createTexture() {
    return _createTexture;
  },
  cssPositionIsOrdered: function cssPositionIsOrdered() {
    return _cssPositionIsOrdered;
  },
  dasherize: function dasherize() {
    return _dasherize;
  },
  deepEqual: function deepEqual() {
    return _deepEqual;
  },
  deepmerge: function deepmerge() {
    return _deepmerge;
  },
  distance: function distance() {
    return _distance;
  },
  exitFullscreen: function exitFullscreen() {
    return _exitFullscreen;
  },
  firstNonNull: function firstNonNull() {
    return _firstNonNull;
  },
  getAbortError: function getAbortError() {
    return _getAbortError;
  },
  getAngle: function getAngle() {
    return _getAngle;
  },
  getClosest: function getClosest() {
    return _getClosest;
  },
  getConfigParser: function getConfigParser() {
    return _getConfigParser;
  },
  getElement: function getElement() {
    return _getElement;
  },
  getPosition: function getPosition() {
    return _getPosition;
  },
  getShortestArc: function getShortestArc() {
    return _getShortestArc;
  },
  getStyleProperty: function getStyleProperty() {
    return _getStyleProperty;
  },
  getTouchData: function getTouchData() {
    return _getTouchData;
  },
  getXMPValue: function getXMPValue() {
    return _getXMPValue;
  },
  greatArcDistance: function greatArcDistance() {
    return _greatArcDistance;
  },
  hasParent: function hasParent() {
    return _hasParent;
  },
  invertResolvableBoolean: function invertResolvableBoolean() {
    return _invertResolvableBoolean;
  },
  isAbortError: function isAbortError() {
    return _isAbortError;
  },
  isEmpty: function isEmpty() {
    return _isEmpty;
  },
  isExtendedPosition: function isExtendedPosition() {
    return _isExtendedPosition;
  },
  isFullscreenEnabled: function isFullscreenEnabled() {
    return _isFullscreenEnabled;
  },
  isNil: function isNil() {
    return _isNil;
  },
  isPlainObject: function isPlainObject() {
    return _isPlainObject;
  },
  logWarn: function logWarn() {
    return _logWarn;
  },
  parseAngle: function parseAngle() {
    return _parseAngle;
  },
  parsePoint: function parsePoint() {
    return _parsePoint;
  },
  parseSpeed: function parseSpeed() {
    return _parseSpeed;
  },
  removeClasses: function removeClasses() {
    return _removeClasses;
  },
  requestFullscreen: function requestFullscreen() {
    return _requestFullscreen;
  },
  resolveBoolean: function resolveBoolean() {
    return _resolveBoolean;
  },
  speedToDuration: function speedToDuration() {
    return _speedToDuration;
  },
  sum: function sum() {
    return _sum;
  },
  throttle: function throttle() {
    return _throttle;
  },
  toggleClass: function toggleClass() {
    return _toggleClass;
  },
  wrap: function wrap() {
    return _wrap;
  }
});

// src/utils/math.ts
function _wrap(value, max) {
  var result = value % max;
  if (result < 0) {
    result += max;
  }
  return result;
}
function _sum(array) {
  return array.reduce(function (a, b) {
    return a + b;
  }, 0);
}
function _distance(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function _angle(p1, p2) {
  return Math.atan2(p2.y - p1.y, p2.x - p1.x);
}
function _getShortestArc(from, to) {
  var candidates = [0,
  // direct
  Math.PI * 2,
  // clock-wise cross zero
  -Math.PI * 2
  // counter-clock-wise cross zero
  ];

  return candidates.reduce(function (value, candidate) {
    var newCandidate = to - from + candidate;
    return Math.abs(newCandidate) < Math.abs(value) ? newCandidate : value;
  }, Infinity);
}
function _getAngle(position1, position2) {
  return Math.acos(Math.cos(position1.pitch) * Math.cos(position2.pitch) * Math.cos(position1.yaw - position2.yaw) + Math.sin(position1.pitch) * Math.sin(position2.pitch));
}
function _greatArcDistance(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
    yaw1 = _ref3[0],
    pitch1 = _ref3[1];
  var _ref4 = _slicedToArray(_ref2, 2),
    yaw2 = _ref4[0],
    pitch2 = _ref4[1];
  if (yaw1 - yaw2 > Math.PI) {
    yaw1 -= 2 * Math.PI;
  } else if (yaw1 - yaw2 < -Math.PI) {
    yaw1 += 2 * Math.PI;
  }
  var x = (yaw2 - yaw1) * Math.cos((pitch1 + pitch2) / 2);
  var y = pitch2 - pitch1;
  return Math.sqrt(x * x + y * y);
}

// src/utils/browser.ts
function _getElement(selector) {
  if (typeof selector === "string") {
    return selector.match(/^[a-z]/i) ? document.getElementById(selector) : document.querySelector(selector);
  } else {
    return selector;
  }
}
function _toggleClass(element, className, active) {
  if (active === void 0) {
    element.classList.toggle(className);
  } else if (active) {
    element.classList.add(className);
  } else if (!active) {
    element.classList.remove(className);
  }
}
function _addClasses(element, className) {
  var _element$classList;
  (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(className.split(" ")));
}
function _removeClasses(element, className) {
  var _element$classList2;
  (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(className.split(" ")));
}
function _hasParent(el, parent) {
  var test = el;
  do {
    if (test === parent) {
      return true;
    }
    test = test.parentElement;
  } while (test);
  return false;
}
function _getClosest(el, selector) {
  if (!(el !== null && el !== void 0 && el.matches)) {
    return null;
  }
  var test = el;
  do {
    if (test.matches(selector)) {
      return test;
    }
    test = test.parentElement;
  } while (test);
  return null;
}
function _getPosition(el) {
  var x = 0;
  var y = 0;
  var test = el;
  while (test) {
    x += test.offsetLeft - test.scrollLeft + test.clientLeft;
    y += test.offsetTop - test.scrollTop + test.clientTop;
    test = test.offsetParent;
  }
  return {
    x: x,
    y: y
  };
}
function _getStyleProperty(elt, varname) {
  return window.getComputedStyle(elt).getPropertyValue(varname);
}
function _getTouchData(e) {
  if (e.touches.length < 2) {
    return null;
  }
  var p1 = {
    x: e.touches[0].clientX,
    y: e.touches[0].clientY
  };
  var p2 = {
    x: e.touches[1].clientX,
    y: e.touches[1].clientY
  };
  return {
    distance: _distance(p1, p2),
    angle: _angle(p1, p2),
    center: {
      x: (p1.x + p2.x) / 2,
      y: (p1.y + p2.y) / 2
    }
  };
}
function _isFullscreenEnabled(elt) {
  return (document.fullscreenElement || document.webkitFullscreenElement) === elt;
}
function _requestFullscreen(elt) {
  (elt.requestFullscreen || elt.webkitRequestFullscreen).call(elt);
}
function _exitFullscreen() {
  (document.exitFullscreen || document.webkitExitFullscreen).call(document);
}

// src/utils/misc.ts
function _dasherize(str) {
  return str.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, function (s, i) {
    return (i > 0 ? "-" : "") + s.toLowerCase();
  });
}
function _throttle(callback, wait) {
  var paused = false;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!paused) {
      paused = true;
      setTimeout(function () {
        callback.apply(_this, args);
        paused = false;
      }, wait);
    }
  };
}
function _isPlainObject(value) {
  if (_typeof(value) !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  var proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(value) === proto;
}
function _deepmerge(target, src) {
  var first = src;
  return function merge(target2, src2) {
    if (Array.isArray(src2)) {
      if (!target2 || !Array.isArray(target2)) {
        target2 = [];
      } else {
        target2.length = 0;
      }
      src2.forEach(function (e, i) {
        target2[i] = merge(null, e);
      });
    } else if (_typeof(src2) === "object") {
      if (!target2 || Array.isArray(target2)) {
        target2 = {};
      }
      Object.keys(src2).forEach(function (key) {
        if (_typeof(src2[key]) !== "object" || !src2[key] || !_isPlainObject(src2[key])) {
          target2[key] = src2[key];
        } else if (src2[key] !== first) {
          if (!target2[key]) {
            target2[key] = merge(null, src2[key]);
          } else {
            merge(target2[key], src2[key]);
          }
        }
      });
    } else {
      target2 = src2;
    }
    return target2;
  }(target, src);
}
function _clone(src) {
  return _deepmerge(null, src);
}
function _isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0 && obj.constructor === Object;
}
function _isNil(val) {
  return val === null || val === void 0;
}
function _firstNonNull() {
  for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    values[_key2] = arguments[_key2];
  }
  for (var _i2 = 0, _values = values; _i2 < _values.length; _i2++) {
    var val = _values[_i2];
    if (!_isNil(val)) {
      return val;
    }
  }
  return null;
}
function _deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  } else if (isObject(obj1) && isObject(obj2)) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }
    for (var _i3 = 0, _Object$keys = Object.keys(obj1); _i3 < _Object$keys.length; _i3++) {
      var prop = _Object$keys[_i3];
      if (!_deepEqual(obj1[prop], obj2[prop])) {
        return false;
      }
    }
    return true;
  } else {
    return false;
  }
}
function isObject(obj) {
  return _typeof(obj) === "object" && obj !== null;
}

// src/PSVError.ts
var PSVError = /*#__PURE__*/function (_Error) {
  _inherits(_PSVError, _Error);
  var _super = _createSuper(_PSVError);
  function _PSVError(message) {
    var _Error$captureStackTr;
    var _this2;
    _classCallCheck(this, _PSVError);
    _this2 = _super.call(this, message);
    _this2.name = "PSVError";
    (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 ? void 0 : _Error$captureStackTr.call(Error, _assertThisInitialized(_this2), _PSVError);
    return _this2;
  }
  return _createClass(_PSVError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// src/utils/psv.ts
function _resolveBoolean(value, cb) {
  if (_isPlainObject(value)) {
    cb(value.initial, true);
    value.promise.then(function (res) {
      return cb(res, false);
    });
  } else {
    cb(value, true);
  }
}
function _invertResolvableBoolean(value) {
  return {
    initial: !value.initial,
    promise: value.promise.then(function (res) {
      return !res;
    })
  };
}
function _getAbortError() {
  var error = new Error("Loading was aborted.");
  error.name = "AbortError";
  return error;
}
function _isAbortError(err) {
  return (err === null || err === void 0 ? void 0 : err.name) === "AbortError";
}
function _logWarn(message) {
  console.warn("PhotoSphereViewer: ".concat(message));
}
function _isExtendedPosition(object) {
  if (!object) {
    return false;
  }
  return [["textureX", "textureY"], ["yaw", "pitch"]].some(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key1 = _ref6[0],
      key2 = _ref6[1];
    return object[key1] !== void 0 && object[key2] !== void 0;
  });
}
function _getXMPValue(data, attr) {
  var result = data.match("<GPano:" + attr + ">(.*)</GPano:" + attr + ">");
  if (result !== null) {
    var val = parseInt(result[1], 10);
    return isNaN(val) ? null : val;
  }
  result = data.match("GPano:" + attr + '="(.*?)"');
  if (result !== null) {
    var _val = parseInt(result[1], 10);
    return isNaN(_val) ? null : _val;
  }
  return null;
}
var CSS_POSITIONS = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
};
var X_VALUES = ["left", "center", "right"];
var Y_VALUES = ["top", "center", "bottom"];
var POS_VALUES = [].concat(X_VALUES, Y_VALUES);
var CENTER = "center";
function _parsePoint(value) {
  if (!value) {
    return {
      x: 0.5,
      y: 0.5
    };
  }
  if (_typeof(value) === "object") {
    return value;
  }
  var tokens = value.toLocaleLowerCase().split(" ").slice(0, 2);
  if (tokens.length === 1) {
    if (CSS_POSITIONS[tokens[0]]) {
      tokens = [tokens[0], CENTER];
    } else {
      tokens = [tokens[0], tokens[0]];
    }
  }
  var xFirst = tokens[1] !== "left" && tokens[1] !== "right" && tokens[0] !== "top" && tokens[0] !== "bottom";
  tokens = tokens.map(function (token) {
    return CSS_POSITIONS[token] || token;
  });
  if (!xFirst) {
    tokens.reverse();
  }
  var parsed = tokens.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);
  if (parsed) {
    return {
      x: parseFloat(parsed[1]) / 100,
      y: parseFloat(parsed[2]) / 100
    };
  } else {
    return {
      x: 0.5,
      y: 0.5
    };
  }
}
function _cleanCssPosition(value) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      allowCenter: true,
      cssOrder: true
    },
    allowCenter = _ref7.allowCenter,
    cssOrder = _ref7.cssOrder;
  if (!value) {
    return null;
  }
  if (typeof value === "string") {
    value = value.split(" ");
  }
  if (value.length === 1) {
    if (value[0] === CENTER) {
      value = [CENTER, CENTER];
    } else if (X_VALUES.indexOf(value[0]) !== -1) {
      value = [CENTER, value[0]];
    } else if (Y_VALUES.indexOf(value[0]) !== -1) {
      value = [value[0], CENTER];
    }
  }
  if (value.length !== 2 || POS_VALUES.indexOf(value[0]) === -1 || POS_VALUES.indexOf(value[1]) === -1) {
    _logWarn("Unparsable position ".concat(value));
    return null;
  }
  if (!allowCenter && value[0] === CENTER && value[1] === CENTER) {
    _logWarn("Invalid position center center");
    return null;
  }
  if (cssOrder && !_cssPositionIsOrdered(value)) {
    value = [value[1], value[0]];
  }
  if (value[1] === CENTER && X_VALUES.indexOf(value[0]) !== -1) {
    value = [CENTER, value[0]];
  }
  if (value[0] === CENTER && Y_VALUES.indexOf(value[1]) !== -1) {
    value = [value[1], CENTER];
  }
  return value;
}
function _cssPositionIsOrdered(value) {
  return Y_VALUES.indexOf(value[0]) !== -1 && X_VALUES.indexOf(value[1]) !== -1;
}
function _parseSpeed(speed) {
  var parsed;
  if (typeof speed === "string") {
    var speedStr = speed.toString().trim();
    var speedValue = parseFloat(speedStr.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
    var speedUnit = speedStr.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();
    if (speedUnit.match(/(pm|per minute)$/)) {
      speedValue /= 60;
    }
    switch (speedUnit) {
      case "dpm":
      case "degrees per minute":
      case "dps":
      case "degrees per second":
        parsed = MathUtils.degToRad(speedValue);
        break;
      case "rdpm":
      case "radians per minute":
      case "rdps":
      case "radians per second":
        parsed = speedValue;
        break;
      case "rpm":
      case "revolutions per minute":
      case "rps":
      case "revolutions per second":
        parsed = speedValue * Math.PI * 2;
        break;
      default:
        throw new PSVError("Unknown speed unit \"".concat(speedUnit, "\""));
    }
  } else {
    parsed = speed;
  }
  return parsed;
}
function _speedToDuration(value, angle2) {
  if (typeof value !== "number") {
    var speed = _parseSpeed(value);
    return angle2 / Math.abs(speed) * 1e3;
  } else {
    return Math.abs(value);
  }
}
function _parseAngle(angle2) {
  var zeroCenter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var halfCircle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : zeroCenter;
  var parsed;
  if (typeof angle2 === "string") {
    var match = angle2.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);
    if (!match) {
      throw new PSVError("Unknown angle \"".concat(angle2, "\""));
    }
    var value = parseFloat(match[1]);
    var unit = match[2];
    if (unit) {
      switch (unit) {
        case "deg":
        case "degs":
          parsed = MathUtils.degToRad(value);
          break;
        case "rad":
        case "rads":
          parsed = value;
          break;
        default:
          throw new PSVError("Unknown angle unit \"".concat(unit, "\""));
      }
    } else {
      parsed = value;
    }
  } else if (typeof angle2 === "number" && !isNaN(angle2)) {
    parsed = angle2;
  } else {
    throw new PSVError("Unknown angle \"".concat(angle2, "\""));
  }
  parsed = _wrap(zeroCenter ? parsed + Math.PI : parsed, Math.PI * 2);
  return zeroCenter ? MathUtils.clamp(parsed - Math.PI, -Math.PI / (halfCircle ? 2 : 1), Math.PI / (halfCircle ? 2 : 1)) : parsed;
}
function _createTexture(img) {
  var mimaps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var texture = new Texture(img);
  texture.needsUpdate = true;
  texture.minFilter = mimaps ? LinearMipmapLinearFilter : LinearFilter;
  texture.generateMipmaps = mimaps;
  texture.anisotropy = mimaps ? 2 : 1;
  return texture;
}
var quaternion = new Quaternion();
function _applyEulerInverse(vector, euler) {
  quaternion.setFromEuler(euler).invert();
  vector.applyQuaternion(quaternion);
}
function _getConfigParser(defaults, parsers) {
  var parser = function parser(userConfig) {
    if (!userConfig) {
      return _clone(defaults);
    }
    var rawConfig = _clone(_objectSpread(_objectSpread({}, defaults), userConfig));
    var config = {};
    for (var _i4 = 0, _Object$entries = Object.entries(rawConfig); _i4 < _Object$entries.length; _i4++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i4], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (parsers && key in parsers) {
        value = parsers[key](value, {
          rawConfig: rawConfig,
          defValue: defaults[key]
        });
      } else if (!(key in defaults)) {
        _logWarn("Unknown option ".concat(key));
        continue;
      }
      config[key] = value;
    }
    return config;
  };
  parser.defaults = defaults;
  parser.parsers = parsers || {};
  return parser;
}
function _checkStylesheet(element, name) {
  if (_getStyleProperty(element, "--psv-".concat(name, "-loaded")) !== "true") {
    console.error("PhotoSphereViewer: stylesheet \"@photo-sphere-viewer/".concat(name, "/index.css\" is not loaded"));
  }
}
function _checkVersion(name, version, coreVersion) {
  if (version && version !== coreVersion) {
    console.error("PhotoSphereViewer: @photo-sphere-viewer/".concat(name, " is in version ").concat(version, " but @photo-sphere-viewer/core is in version ").concat(coreVersion));
  }
}

// src/utils/Animation.ts
var _Animation = /*#__PURE__*/function () {
  function _Animation(options) {
    var _this3 = this;
    _classCallCheck(this, _Animation);
    this.easing = _EASINGS["linear"];
    this.callbacks = [];
    this.resolved = false;
    this.cancelled = false;
    this.options = options;
    if (options) {
      if (options.easing) {
        this.easing = typeof options.easing === "function" ? options.easing : _EASINGS[options.easing] || _EASINGS["linear"];
      }
      this.delayTimeout = setTimeout(function () {
        _this3.delayTimeout = void 0;
        _this3.animationFrame = window.requestAnimationFrame(function (t) {
          return _this3.__run(t);
        });
      }, options.delay || 0);
    } else {
      this.resolved = true;
    }
  }
  _createClass(_Animation, [{
    key: "__run",
    value: function __run(timestamp) {
      var _this4 = this;
      if (this.cancelled) {
        return;
      }
      if (!this.start) {
        this.start = timestamp;
      }
      var progress = (timestamp - this.start) / this.options.duration;
      var current = {};
      if (progress < 1) {
        for (var _i5 = 0, _Object$entries2 = Object.entries(this.options.properties); _i5 < _Object$entries2.length; _i5++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i5], 2),
            name = _Object$entries2$_i[0],
            prop = _Object$entries2$_i[1];
          if (prop) {
            var value = prop.start + (prop.end - prop.start) * this.easing(progress);
            current[name] = value;
          }
        }
        this.options.onTick(current, progress);
        this.animationFrame = window.requestAnimationFrame(function (t) {
          return _this4.__run(t);
        });
      } else {
        for (var _i6 = 0, _Object$entries3 = Object.entries(this.options.properties); _i6 < _Object$entries3.length; _i6++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i6], 2),
            _name = _Object$entries3$_i[0],
            _prop = _Object$entries3$_i[1];
          if (_prop) {
            current[_name] = _prop.end;
          }
        }
        this.options.onTick(current, 1);
        this.__resolve(true);
        this.animationFrame = void 0;
      }
    }
  }, {
    key: "__resolve",
    value: function __resolve(value) {
      if (value) {
        this.resolved = true;
      } else {
        this.cancelled = true;
      }
      this.callbacks.forEach(function (cb) {
        return cb(value);
      });
      this.callbacks.length = 0;
    }
    /**
     * Promise chaining
     * @param [onFulfilled] - Called when the animation is complete (true) or cancelled (false)
     */
  }, {
    key: "then",
    value: function then(onFulfilled) {
      var _this5 = this;
      if (this.resolved || this.cancelled) {
        return Promise.resolve(this.resolved).then(onFulfilled);
      }
      return new Promise(function (resolve) {
        _this5.callbacks.push(resolve);
      }).then(onFulfilled);
    }
    /**
     * Cancels the animation
     */
  }, {
    key: "cancel",
    value: function cancel() {
      if (!this.cancelled && !this.resolved) {
        this.__resolve(false);
        if (this.delayTimeout) {
          window.clearTimeout(this.delayTimeout);
          this.delayTimeout = void 0;
        }
        if (this.animationFrame) {
          window.cancelAnimationFrame(this.animationFrame);
          this.animationFrame = void 0;
        }
      }
    }
  }]);
  return _Animation;
}();
var _Dynamic = /*#__PURE__*/function () {
  function _Dynamic(fn, config) {
    _classCallCheck(this, _Dynamic);
    this.fn = fn;
    this.mode = 0 /* STOP */;
    this.speed = 0;
    this.speedMult = 0;
    this.currentSpeed = 0;
    this.target = 0;
    this.__current = 0;
    this.min = config.min;
    this.max = config.max;
    this.wrap = config.wrap;
    this.current = config.defaultValue;
    if (this.wrap && this.min !== 0) {
      throw new PSVError("invalid config");
    }
    if (this.fn) {
      this.fn(this.current);
    }
  }
  _createClass(_Dynamic, [{
    key: "current",
    get: function get() {
      return this.__current;
    },
    set: function set(current) {
      this.__current = current;
    }
    /**
     * Changes base speed
     */
  }, {
    key: "setSpeed",
    value: function setSpeed(speed) {
      this.speed = speed;
    }
    /**
     * Defines the target position
     */
  }, {
    key: "goto",
    value: function goto(position) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.mode = 2 /* POSITION */;
      this.target = this.wrap ? _wrap(position, this.max) : MathUtils.clamp(position, this.min, this.max);
      this.speedMult = speedMult;
    }
    /**
     * Increases/decreases the target position
     */
  }, {
    key: "step",
    value: function step(_step) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (speedMult === 0) {
        this.setValue(this.current + _step);
      } else {
        if (this.mode !== 2 /* POSITION */) {
          this.target = this.current;
        }
        this["goto"](this.target + _step, speedMult);
      }
    }
    /**
     * Starts infinite movement
     */
  }, {
    key: "roll",
    value: function roll() {
      var invert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.mode = 1 /* INFINITE */;
      this.target = invert ? -Infinity : Infinity;
      this.speedMult = speedMult;
    }
    /**
     * Stops movement
     */
  }, {
    key: "stop",
    value: function stop() {
      this.mode = 0 /* STOP */;
    }
    /**
     * Defines the current position and immediately stops movement
     * @param {number} value
     */
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.target = this.wrap ? _wrap(value, this.max) : MathUtils.clamp(value, this.min, this.max);
      this.mode = 0 /* STOP */;
      this.currentSpeed = 0;
      if (this.target !== this.current) {
        this.current = this.target;
        if (this.fn) {
          this.fn(this.current);
        }
        return true;
      }
      return false;
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function update(elapsed) {
      if (this.mode === 2 /* POSITION */) {
        if (this.wrap && Math.abs(this.target - this.current) > this.max / 2) {
          this.current = this.current < this.target ? this.current + this.max : this.current - this.max;
        }
        var dstStop = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);
        if (Math.abs(this.target - this.current) <= dstStop) {
          this.mode = 0 /* STOP */;
        }
      }

      var targetSpeed = this.mode === 0 /* STOP */ ? 0 : this.speed * this.speedMult;
      if (this.target < this.current) {
        targetSpeed = -targetSpeed;
      }
      if (this.currentSpeed < targetSpeed) {
        this.currentSpeed = Math.min(targetSpeed, this.currentSpeed + elapsed / 1e3 * this.speed * this.speedMult * 2);
      } else if (this.currentSpeed > targetSpeed) {
        this.currentSpeed = Math.max(targetSpeed, this.currentSpeed - elapsed / 1e3 * this.speed * this.speedMult * 2);
      }
      var next = null;
      if (this.current > this.target && this.currentSpeed) {
        next = Math.max(this.target, this.current + this.currentSpeed * elapsed / 1e3);
      } else if (this.current < this.target && this.currentSpeed) {
        next = Math.min(this.target, this.current + this.currentSpeed * elapsed / 1e3);
      }
      if (next !== null) {
        next = this.wrap ? _wrap(next, this.max) : MathUtils.clamp(next, this.min, this.max);
        if (next !== this.current) {
          this.current = next;
          if (this.fn) {
            this.fn(this.current);
          }
          return true;
        }
      }
      return false;
    }
  }]);
  return _Dynamic;
}();

// src/utils/MultiDynamic.ts
var _MultiDynamic = /*#__PURE__*/function () {
  function _MultiDynamic(fn, dynamics) {
    _classCallCheck(this, _MultiDynamic);
    this.fn = fn;
    this.dynamics = dynamics;
    if (this.fn) {
      this.fn(this.current);
    }
  }
  _createClass(_MultiDynamic, [{
    key: "current",
    get: function get() {
      return Object.entries(this.dynamics).reduce(function (values, _ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          name = _ref9[0],
          dynamic = _ref9[1];
        values[name] = dynamic.current;
        return values;
      }, {});
    }
    /**
     * Changes base speed
     */
  }, {
    key: "setSpeed",
    value: function setSpeed(speed) {
      for (var _i7 = 0, _Object$values = Object.values(this.dynamics); _i7 < _Object$values.length; _i7++) {
        var d = _Object$values[_i7];
        d.setSpeed(speed);
      }
    }
    /**
     * Defines the target positions
     */
  }, {
    key: "goto",
    value: function goto(positions) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      for (var _i8 = 0, _Object$entries4 = Object.entries(positions); _i8 < _Object$entries4.length; _i8++) {
        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i8], 2),
          name = _Object$entries4$_i[0],
          position = _Object$entries4$_i[1];
        this.dynamics[name]["goto"](position, speedMult);
      }
    }
    /**
     * Increase/decrease the target positions
     */
  }, {
    key: "step",
    value: function step(steps) {
      var _this6 = this;
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (speedMult === 0) {
        this.setValue(Object.keys(steps).reduce(function (values, name) {
          values[name] = steps[name] + _this6.dynamics[name].current;
          return values;
        }, {}));
      } else {
        for (var _i9 = 0, _Object$entries5 = Object.entries(steps); _i9 < _Object$entries5.length; _i9++) {
          var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i9], 2),
            name = _Object$entries5$_i[0],
            step = _Object$entries5$_i[1];
          this.dynamics[name].step(step, speedMult);
        }
      }
    }
    /**
     * Starts infinite movements
     */
  }, {
    key: "roll",
    value: function roll(rolls) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      for (var _i10 = 0, _Object$entries6 = Object.entries(rolls); _i10 < _Object$entries6.length; _i10++) {
        var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i10], 2),
          name = _Object$entries6$_i[0],
          roll = _Object$entries6$_i[1];
        this.dynamics[name].roll(roll, speedMult);
      }
    }
    /**
     * Stops movements
     */
  }, {
    key: "stop",
    value: function stop() {
      for (var _i11 = 0, _Object$values2 = Object.values(this.dynamics); _i11 < _Object$values2.length; _i11++) {
        var d = _Object$values2[_i11];
        d.stop();
      }
    }
    /**
     * Defines the current positions and immediately stops movements
     */
  }, {
    key: "setValue",
    value: function setValue(values) {
      var hasUpdates = false;
      for (var _i12 = 0, _Object$entries7 = Object.entries(values); _i12 < _Object$entries7.length; _i12++) {
        var _Object$entries7$_i = _slicedToArray(_Object$entries7[_i12], 2),
          name = _Object$entries7$_i[0],
          value = _Object$entries7$_i[1];
        hasUpdates = this.dynamics[name].setValue(value) || hasUpdates;
      }
      if (hasUpdates && this.fn) {
        this.fn(this.current);
      }
      return hasUpdates;
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function update(elapsed) {
      var hasUpdates = false;
      for (var _i13 = 0, _Object$values3 = Object.values(this.dynamics); _i13 < _Object$values3.length; _i13++) {
        var d = _Object$values3[_i13];
        hasUpdates = d.update(elapsed) || hasUpdates;
      }
      if (hasUpdates && this.fn) {
        this.fn(this.current);
      }
      return hasUpdates;
    }
  }]);
  return _MultiDynamic;
}();

// src/utils/PressHandler.ts
var _PressHandler = /*#__PURE__*/function () {
  function _PressHandler() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
    _classCallCheck(this, _PressHandler);
    this.delay = delay;
    this.time = 0;
    this.delay = delay;
  }
  _createClass(_PressHandler, [{
    key: "pending",
    get: function get() {
      return this.time !== 0;
    }
  }, {
    key: "down",
    value: function down() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = void 0;
      }
      this.time = /* @__PURE__ */new Date().getTime();
    }
  }, {
    key: "up",
    value: function up(cb) {
      var _this7 = this;
      if (!this.time) {
        return;
      }
      var elapsed = Date.now() - this.time;
      if (elapsed < this.delay) {
        this.timeout = setTimeout(function () {
          cb();
          _this7.timeout = void 0;
          _this7.time = 0;
        }, this.delay);
      } else {
        cb();
        this.time = 0;
      }
    }
  }]);
  return _PressHandler;
}();

// src/utils/Slider.ts
var _SliderDirection = /* @__PURE__ */function (SliderDirection2) {
  SliderDirection2["VERTICAL"] = "VERTICAL";
  SliderDirection2["HORIZONTAL"] = "HORIZONTAL";
  return SliderDirection2;
}(_SliderDirection || {});
var _Slider = /*#__PURE__*/function () {
  function _Slider(container, direction, listener) {
    _classCallCheck(this, _Slider);
    this.container = container;
    this.direction = direction;
    this.listener = listener;
    this.mousedown = false;
    this.mouseover = false;
    this.container.addEventListener("click", this);
    this.container.addEventListener("mousedown", this);
    this.container.addEventListener("mouseenter", this);
    this.container.addEventListener("mouseleave", this);
    this.container.addEventListener("touchstart", this);
    this.container.addEventListener("mousemove", this, true);
    this.container.addEventListener("touchmove", this, true);
    window.addEventListener("mouseup", this);
    window.addEventListener("touchend", this);
  }
  _createClass(_Slider, [{
    key: "isVertical",
    get: function get() {
      return this.direction === "VERTICAL" /* VERTICAL */;
    }
  }, {
    key: "isHorizontal",
    get: function get() {
      return this.direction === "HORIZONTAL" /* HORIZONTAL */;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("mouseup", this);
      window.removeEventListener("touchend", this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "click":
          e.stopPropagation();
          break;
        case "mousedown":
          this.__onMouseDown(e);
          break;
        case "mouseenter":
          this.__onMouseEnter(e);
          break;
        case "mouseleave":
          this.__onMouseLeave(e);
          break;
        case "touchstart":
          this.__onTouchStart(e);
          break;
        case "mousemove":
          this.__onMouseMove(e);
          break;
        case "touchmove":
          this.__onTouchMove(e);
          break;
        case "mouseup":
          this.__onMouseUp(e);
          break;
        case "touchend":
          this.__onTouchEnd(e);
          break;
      }
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown(evt) {
      this.mousedown = true;
      this.__update(evt.clientX, evt.clientY, true);
    }
  }, {
    key: "__onMouseEnter",
    value: function __onMouseEnter(evt) {
      this.mouseover = true;
      this.__update(evt.clientX, evt.clientY, true);
    }
  }, {
    key: "__onTouchStart",
    value: function __onTouchStart(evt) {
      this.mouseover = true;
      this.mousedown = true;
      var touch = evt.changedTouches[0];
      this.__update(touch.clientX, touch.clientY, true);
    }
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(evt) {
      if (this.mousedown || this.mouseover) {
        evt.stopPropagation();
        this.__update(evt.clientX, evt.clientY, true);
      }
    }
  }, {
    key: "__onTouchMove",
    value: function __onTouchMove(evt) {
      if (this.mousedown || this.mouseover) {
        evt.stopPropagation();
        var touch = evt.changedTouches[0];
        this.__update(touch.clientX, touch.clientY, true);
      }
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp(evt) {
      if (this.mousedown) {
        this.mousedown = false;
        this.__update(evt.clientX, evt.clientY, false);
      }
    }
  }, {
    key: "__onMouseLeave",
    value: function __onMouseLeave(evt) {
      if (this.mouseover) {
        this.mouseover = false;
        this.__update(evt.clientX, evt.clientY, true);
      }
    }
  }, {
    key: "__onTouchEnd",
    value: function __onTouchEnd(evt) {
      if (this.mousedown) {
        this.mouseover = false;
        this.mousedown = false;
        var touch = evt.changedTouches[0];
        this.__update(touch.clientX, touch.clientY, false);
      }
    }
  }, {
    key: "__update",
    value: function __update(clientX, clientY, moving) {
      var boundingClientRect = this.container.getBoundingClientRect();
      var cursor = this.isVertical ? clientY : clientX;
      var pos = boundingClientRect[this.isVertical ? "bottom" : "left"];
      var size = boundingClientRect[this.isVertical ? "height" : "width"];
      var val = Math.abs((pos - cursor) / size);
      this.listener({
        value: val,
        click: !moving,
        mousedown: this.mousedown,
        mouseover: this.mouseover,
        cursor: {
          clientX: clientX,
          clientY: clientY
        }
      });
    }
  }]);
  return _Slider;
}();

// src/events.ts
var events_exports = {};
__export(events_exports, {
  BeforeAnimateEvent: function BeforeAnimateEvent() {
    return _BeforeAnimateEvent2;
  },
  BeforeRenderEvent: function BeforeRenderEvent() {
    return _BeforeRenderEvent2;
  },
  BeforeRotateEvent: function BeforeRotateEvent() {
    return _BeforeRotateEvent2;
  },
  ClickEvent: function ClickEvent() {
    return _ClickEvent2;
  },
  ConfigChangedEvent: function ConfigChangedEvent() {
    return _ConfigChangedEvent2;
  },
  DoubleClickEvent: function DoubleClickEvent() {
    return _DoubleClickEvent2;
  },
  FullscreenEvent: function FullscreenEvent() {
    return _FullscreenEvent2;
  },
  HideNotificationEvent: function HideNotificationEvent() {
    return _HideNotificationEvent2;
  },
  HideOverlayEvent: function HideOverlayEvent() {
    return _HideOverlayEvent2;
  },
  HidePanelEvent: function HidePanelEvent() {
    return _HidePanelEvent2;
  },
  HideTooltipEvent: function HideTooltipEvent() {
    return _HideTooltipEvent2;
  },
  KeypressEvent: function KeypressEvent() {
    return _KeypressEvent2;
  },
  LoadProgressEvent: function LoadProgressEvent() {
    return _LoadProgressEvent2;
  },
  ObjectEnterEvent: function ObjectEnterEvent() {
    return _ObjectEnterEvent2;
  },
  ObjectEvent: function ObjectEvent() {
    return _ObjectEvent;
  },
  ObjectHoverEvent: function ObjectHoverEvent() {
    return _ObjectHoverEvent2;
  },
  ObjectLeaveEvent: function ObjectLeaveEvent() {
    return _ObjectLeaveEvent2;
  },
  PanoramaErrorEvent: function PanoramaErrorEvent() {
    return _PanoramaErrorEvent2;
  },
  PanoramaLoadEvent: function PanoramaLoadEvent() {
    return _PanoramaLoadEvent2;
  },
  PanoramaLoadedEvent: function PanoramaLoadedEvent() {
    return _PanoramaLoadedEvent2;
  },
  PositionUpdatedEvent: function PositionUpdatedEvent() {
    return _PositionUpdatedEvent2;
  },
  ReadyEvent: function ReadyEvent() {
    return _ReadyEvent2;
  },
  RenderEvent: function RenderEvent() {
    return _RenderEvent2;
  },
  ShowNotificationEvent: function ShowNotificationEvent() {
    return _ShowNotificationEvent2;
  },
  ShowOverlayEvent: function ShowOverlayEvent() {
    return _ShowOverlayEvent2;
  },
  ShowPanelEvent: function ShowPanelEvent() {
    return _ShowPanelEvent2;
  },
  ShowTooltipEvent: function ShowTooltipEvent() {
    return _ShowTooltipEvent2;
  },
  SizeUpdatedEvent: function SizeUpdatedEvent() {
    return _SizeUpdatedEvent2;
  },
  StopAllEvent: function StopAllEvent() {
    return _StopAllEvent2;
  },
  ViewerEvent: function ViewerEvent() {
    return _ViewerEvent;
  },
  ZoomUpdatedEvent: function ZoomUpdatedEvent() {
    return _ZoomUpdatedEvent2;
  }
});

// src/lib/TypedEventTarget.ts
var TypedEvent = /*#__PURE__*/function (_Event) {
  _inherits(TypedEvent, _Event);
  var _super2 = _createSuper(TypedEvent);
  function TypedEvent(type) {
    var cancelable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, TypedEvent);
    return _super2.call(this, type, {
      cancelable: cancelable
    });
  }
  return _createClass(TypedEvent);
}( /*#__PURE__*/_wrapNativeSuper(Event));
var TypedEventTarget = /*#__PURE__*/function (_EventTarget) {
  _inherits(TypedEventTarget, _EventTarget);
  var _super3 = _createSuper(TypedEventTarget);
  function TypedEventTarget() {
    _classCallCheck(this, TypedEventTarget);
    return _super3.apply(this, arguments);
  }
  _createClass(TypedEventTarget, [{
    key: "dispatchEvent",
    value: function dispatchEvent(e) {
      return _get(_getPrototypeOf(TypedEventTarget.prototype), "dispatchEvent", this).call(this, e);
    }
    /**
     * @template T the name of event
     * @template E the class of the event
     */
  }, {
    key: "addEventListener",
    value: function addEventListener(type, callback, options) {
      _get(_getPrototypeOf(TypedEventTarget.prototype), "addEventListener", this).call(this, type, callback, options);
    }
    /**
     * @template T the name of event
     * @template E the class of the event
     */
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback, options) {
      _get(_getPrototypeOf(TypedEventTarget.prototype), "removeEventListener", this).call(this, type, callback, options);
    }
  }]);
  return TypedEventTarget;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

// src/events.ts
var _ViewerEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_ViewerEvent, _TypedEvent);
  var _super4 = _createSuper(_ViewerEvent);
  function _ViewerEvent() {
    _classCallCheck(this, _ViewerEvent);
    return _super4.apply(this, arguments);
  }
  return _createClass(_ViewerEvent);
}(TypedEvent);
var _BeforeAnimateEvent = /*#__PURE__*/function (_ViewerEvent2) {
  _inherits(_BeforeAnimateEvent, _ViewerEvent2);
  var _super5 = _createSuper(_BeforeAnimateEvent);
  /** @internal */
  function _BeforeAnimateEvent(position, zoomLevel) {
    var _this8;
    _classCallCheck(this, _BeforeAnimateEvent);
    _this8 = _super5.call(this, _BeforeAnimateEvent.type, true);
    _this8.position = position;
    _this8.zoomLevel = zoomLevel;
    return _this8;
  }
  return _createClass(_BeforeAnimateEvent);
}(_ViewerEvent);
_BeforeAnimateEvent.type = "before-animate";
var _BeforeAnimateEvent2 = _BeforeAnimateEvent;
var _BeforeRenderEvent = /*#__PURE__*/function (_ViewerEvent3) {
  _inherits(_BeforeRenderEvent, _ViewerEvent3);
  var _super6 = _createSuper(_BeforeRenderEvent);
  /** @internal */
  function _BeforeRenderEvent(timestamp, elapsed) {
    var _this9;
    _classCallCheck(this, _BeforeRenderEvent);
    _this9 = _super6.call(this, _BeforeRenderEvent.type);
    _this9.timestamp = timestamp;
    _this9.elapsed = elapsed;
    return _this9;
  }
  return _createClass(_BeforeRenderEvent);
}(_ViewerEvent);
_BeforeRenderEvent.type = "before-render";
var _BeforeRenderEvent2 = _BeforeRenderEvent;
var _BeforeRotateEvent = /*#__PURE__*/function (_ViewerEvent4) {
  _inherits(_BeforeRotateEvent, _ViewerEvent4);
  var _super7 = _createSuper(_BeforeRotateEvent);
  /** @internal */
  function _BeforeRotateEvent(position) {
    var _this10;
    _classCallCheck(this, _BeforeRotateEvent);
    _this10 = _super7.call(this, _BeforeRotateEvent.type, true);
    _this10.position = position;
    return _this10;
  }
  return _createClass(_BeforeRotateEvent);
}(_ViewerEvent);
_BeforeRotateEvent.type = "before-rotate";
var _BeforeRotateEvent2 = _BeforeRotateEvent;
var _ClickEvent = /*#__PURE__*/function (_ViewerEvent5) {
  _inherits(_ClickEvent, _ViewerEvent5);
  var _super8 = _createSuper(_ClickEvent);
  /** @internal */
  function _ClickEvent(data) {
    var _this11;
    _classCallCheck(this, _ClickEvent);
    _this11 = _super8.call(this, _ClickEvent.type);
    _this11.data = data;
    return _this11;
  }
  return _createClass(_ClickEvent);
}(_ViewerEvent);
_ClickEvent.type = "click";
var _ClickEvent2 = _ClickEvent;
var _ConfigChangedEvent = /*#__PURE__*/function (_ViewerEvent6) {
  _inherits(_ConfigChangedEvent, _ViewerEvent6);
  var _super9 = _createSuper(_ConfigChangedEvent);
  /** @internal */
  function _ConfigChangedEvent(options) {
    var _this12;
    _classCallCheck(this, _ConfigChangedEvent);
    _this12 = _super9.call(this, _ConfigChangedEvent.type);
    _this12.options = options;
    return _this12;
  }
  /**
   * Checks if at least one of the `options` has been modified
   */
  _createClass(_ConfigChangedEvent, [{
    key: "containsOptions",
    value: function containsOptions() {
      var _this13 = this;
      for (var _len3 = arguments.length, options = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        options[_key3] = arguments[_key3];
      }
      return options.some(function (option) {
        return _this13.options.includes(option);
      });
    }
  }]);
  return _ConfigChangedEvent;
}(_ViewerEvent);
_ConfigChangedEvent.type = "config-changed";
var _ConfigChangedEvent2 = _ConfigChangedEvent;
var _DoubleClickEvent = /*#__PURE__*/function (_ViewerEvent7) {
  _inherits(_DoubleClickEvent, _ViewerEvent7);
  var _super10 = _createSuper(_DoubleClickEvent);
  /** @internal */
  function _DoubleClickEvent(data) {
    var _this14;
    _classCallCheck(this, _DoubleClickEvent);
    _this14 = _super10.call(this, _DoubleClickEvent.type);
    _this14.data = data;
    return _this14;
  }
  return _createClass(_DoubleClickEvent);
}(_ViewerEvent);
_DoubleClickEvent.type = "dblclick";
var _DoubleClickEvent2 = _DoubleClickEvent;
var _FullscreenEvent = /*#__PURE__*/function (_ViewerEvent8) {
  _inherits(_FullscreenEvent, _ViewerEvent8);
  var _super11 = _createSuper(_FullscreenEvent);
  /** @internal */
  function _FullscreenEvent(fullscreenEnabled) {
    var _this15;
    _classCallCheck(this, _FullscreenEvent);
    _this15 = _super11.call(this, _FullscreenEvent.type);
    _this15.fullscreenEnabled = fullscreenEnabled;
    return _this15;
  }
  return _createClass(_FullscreenEvent);
}(_ViewerEvent);
_FullscreenEvent.type = "fullscreen";
var _FullscreenEvent2 = _FullscreenEvent;
var _HideNotificationEvent = /*#__PURE__*/function (_ViewerEvent9) {
  _inherits(_HideNotificationEvent, _ViewerEvent9);
  var _super12 = _createSuper(_HideNotificationEvent);
  /** @internal */
  function _HideNotificationEvent(notificationId) {
    var _this16;
    _classCallCheck(this, _HideNotificationEvent);
    _this16 = _super12.call(this, _HideNotificationEvent.type);
    _this16.notificationId = notificationId;
    return _this16;
  }
  return _createClass(_HideNotificationEvent);
}(_ViewerEvent);
_HideNotificationEvent.type = "hide-notification";
var _HideNotificationEvent2 = _HideNotificationEvent;
var _HideOverlayEvent = /*#__PURE__*/function (_ViewerEvent10) {
  _inherits(_HideOverlayEvent, _ViewerEvent10);
  var _super13 = _createSuper(_HideOverlayEvent);
  /** @internal */
  function _HideOverlayEvent(overlayId) {
    var _this17;
    _classCallCheck(this, _HideOverlayEvent);
    _this17 = _super13.call(this, _HideOverlayEvent.type);
    _this17.overlayId = overlayId;
    return _this17;
  }
  return _createClass(_HideOverlayEvent);
}(_ViewerEvent);
_HideOverlayEvent.type = "hide-overlay";
var _HideOverlayEvent2 = _HideOverlayEvent;
var _HidePanelEvent = /*#__PURE__*/function (_ViewerEvent11) {
  _inherits(_HidePanelEvent, _ViewerEvent11);
  var _super14 = _createSuper(_HidePanelEvent);
  /** @internal */
  function _HidePanelEvent(panelId) {
    var _this18;
    _classCallCheck(this, _HidePanelEvent);
    _this18 = _super14.call(this, _HidePanelEvent.type);
    _this18.panelId = panelId;
    return _this18;
  }
  return _createClass(_HidePanelEvent);
}(_ViewerEvent);
_HidePanelEvent.type = "hide-panel";
var _HidePanelEvent2 = _HidePanelEvent;
var _HideTooltipEvent = /*#__PURE__*/function (_ViewerEvent12) {
  _inherits(_HideTooltipEvent, _ViewerEvent12);
  var _super15 = _createSuper(_HideTooltipEvent);
  /** @internal */
  function _HideTooltipEvent(tooltipData) {
    var _this19;
    _classCallCheck(this, _HideTooltipEvent);
    _this19 = _super15.call(this, _HideTooltipEvent.type);
    _this19.tooltipData = tooltipData;
    return _this19;
  }
  return _createClass(_HideTooltipEvent);
}(_ViewerEvent);
_HideTooltipEvent.type = "hide-tooltip";
var _HideTooltipEvent2 = _HideTooltipEvent;
var _KeypressEvent = /*#__PURE__*/function (_ViewerEvent13) {
  _inherits(_KeypressEvent, _ViewerEvent13);
  var _super16 = _createSuper(_KeypressEvent);
  /** @internal */
  function _KeypressEvent(key) {
    var _this20;
    _classCallCheck(this, _KeypressEvent);
    _this20 = _super16.call(this, _KeypressEvent.type, true);
    _this20.key = key;
    return _this20;
  }
  return _createClass(_KeypressEvent);
}(_ViewerEvent);
_KeypressEvent.type = "key-press";
var _KeypressEvent2 = _KeypressEvent;
var _LoadProgressEvent = /*#__PURE__*/function (_ViewerEvent14) {
  _inherits(_LoadProgressEvent, _ViewerEvent14);
  var _super17 = _createSuper(_LoadProgressEvent);
  /** @internal */
  function _LoadProgressEvent(progress) {
    var _this21;
    _classCallCheck(this, _LoadProgressEvent);
    _this21 = _super17.call(this, _LoadProgressEvent.type);
    _this21.progress = progress;
    return _this21;
  }
  return _createClass(_LoadProgressEvent);
}(_ViewerEvent);
_LoadProgressEvent.type = "load-progress";
var _LoadProgressEvent2 = _LoadProgressEvent;
var _PanoramaLoadEvent = /*#__PURE__*/function (_ViewerEvent15) {
  _inherits(_PanoramaLoadEvent, _ViewerEvent15);
  var _super18 = _createSuper(_PanoramaLoadEvent);
  /** @internal */
  function _PanoramaLoadEvent(panorama) {
    var _this22;
    _classCallCheck(this, _PanoramaLoadEvent);
    _this22 = _super18.call(this, _PanoramaLoadEvent.type);
    _this22.panorama = panorama;
    return _this22;
  }
  return _createClass(_PanoramaLoadEvent);
}(_ViewerEvent);
_PanoramaLoadEvent.type = "panorama-load";
var _PanoramaLoadEvent2 = _PanoramaLoadEvent;
var _PanoramaLoadedEvent = /*#__PURE__*/function (_ViewerEvent16) {
  _inherits(_PanoramaLoadedEvent, _ViewerEvent16);
  var _super19 = _createSuper(_PanoramaLoadedEvent);
  /** @internal */
  function _PanoramaLoadedEvent(data) {
    var _this23;
    _classCallCheck(this, _PanoramaLoadedEvent);
    _this23 = _super19.call(this, _PanoramaLoadedEvent.type);
    _this23.data = data;
    return _this23;
  }
  return _createClass(_PanoramaLoadedEvent);
}(_ViewerEvent);
_PanoramaLoadedEvent.type = "panorama-loaded";
var _PanoramaLoadedEvent2 = _PanoramaLoadedEvent;
var _PanoramaErrorEvent = /*#__PURE__*/function (_ViewerEvent17) {
  _inherits(_PanoramaErrorEvent, _ViewerEvent17);
  var _super20 = _createSuper(_PanoramaErrorEvent);
  /** @internal */
  function _PanoramaErrorEvent(panorama, error) {
    var _this24;
    _classCallCheck(this, _PanoramaErrorEvent);
    _this24 = _super20.call(this, _PanoramaErrorEvent.type);
    _this24.panorama = panorama;
    _this24.error = error;
    return _this24;
  }
  return _createClass(_PanoramaErrorEvent);
}(_ViewerEvent);
_PanoramaErrorEvent.type = "panorama-error";
var _PanoramaErrorEvent2 = _PanoramaErrorEvent;
var _PositionUpdatedEvent = /*#__PURE__*/function (_ViewerEvent18) {
  _inherits(_PositionUpdatedEvent, _ViewerEvent18);
  var _super21 = _createSuper(_PositionUpdatedEvent);
  /** @internal */
  function _PositionUpdatedEvent(position) {
    var _this25;
    _classCallCheck(this, _PositionUpdatedEvent);
    _this25 = _super21.call(this, _PositionUpdatedEvent.type);
    _this25.position = position;
    return _this25;
  }
  return _createClass(_PositionUpdatedEvent);
}(_ViewerEvent);
_PositionUpdatedEvent.type = "position-updated";
var _PositionUpdatedEvent2 = _PositionUpdatedEvent;
var _ReadyEvent = /*#__PURE__*/function (_ViewerEvent19) {
  _inherits(_ReadyEvent, _ViewerEvent19);
  var _super22 = _createSuper(_ReadyEvent);
  /** @internal */
  function _ReadyEvent() {
    _classCallCheck(this, _ReadyEvent);
    return _super22.call(this, _ReadyEvent.type);
  }
  return _createClass(_ReadyEvent);
}(_ViewerEvent);
_ReadyEvent.type = "ready";
var _ReadyEvent2 = _ReadyEvent;
var _RenderEvent = /*#__PURE__*/function (_ViewerEvent20) {
  _inherits(_RenderEvent, _ViewerEvent20);
  var _super23 = _createSuper(_RenderEvent);
  /** @internal */
  function _RenderEvent() {
    _classCallCheck(this, _RenderEvent);
    return _super23.call(this, _RenderEvent.type);
  }
  return _createClass(_RenderEvent);
}(_ViewerEvent);
_RenderEvent.type = "render";
var _RenderEvent2 = _RenderEvent;
var _ShowNotificationEvent = /*#__PURE__*/function (_ViewerEvent21) {
  _inherits(_ShowNotificationEvent, _ViewerEvent21);
  var _super24 = _createSuper(_ShowNotificationEvent);
  /** @internal */
  function _ShowNotificationEvent(notificationId) {
    var _this26;
    _classCallCheck(this, _ShowNotificationEvent);
    _this26 = _super24.call(this, _ShowNotificationEvent.type);
    _this26.notificationId = notificationId;
    return _this26;
  }
  return _createClass(_ShowNotificationEvent);
}(_ViewerEvent);
_ShowNotificationEvent.type = "show-notification";
var _ShowNotificationEvent2 = _ShowNotificationEvent;
var _ShowOverlayEvent = /*#__PURE__*/function (_ViewerEvent22) {
  _inherits(_ShowOverlayEvent, _ViewerEvent22);
  var _super25 = _createSuper(_ShowOverlayEvent);
  /** @internal */
  function _ShowOverlayEvent(overlayId) {
    var _this27;
    _classCallCheck(this, _ShowOverlayEvent);
    _this27 = _super25.call(this, _ShowOverlayEvent.type);
    _this27.overlayId = overlayId;
    return _this27;
  }
  return _createClass(_ShowOverlayEvent);
}(_ViewerEvent);
_ShowOverlayEvent.type = "show-overlay";
var _ShowOverlayEvent2 = _ShowOverlayEvent;
var _ShowPanelEvent = /*#__PURE__*/function (_ViewerEvent23) {
  _inherits(_ShowPanelEvent, _ViewerEvent23);
  var _super26 = _createSuper(_ShowPanelEvent);
  /** @internal */
  function _ShowPanelEvent(panelId) {
    var _this28;
    _classCallCheck(this, _ShowPanelEvent);
    _this28 = _super26.call(this, _ShowPanelEvent.type);
    _this28.panelId = panelId;
    return _this28;
  }
  return _createClass(_ShowPanelEvent);
}(_ViewerEvent);
_ShowPanelEvent.type = "show-panel";
var _ShowPanelEvent2 = _ShowPanelEvent;
var _ShowTooltipEvent = /*#__PURE__*/function (_ViewerEvent24) {
  _inherits(_ShowTooltipEvent, _ViewerEvent24);
  var _super27 = _createSuper(_ShowTooltipEvent);
  /** @internal */
  function _ShowTooltipEvent(tooltip, tooltipData) {
    var _this29;
    _classCallCheck(this, _ShowTooltipEvent);
    _this29 = _super27.call(this, _ShowTooltipEvent.type);
    _this29.tooltip = tooltip;
    _this29.tooltipData = tooltipData;
    return _this29;
  }
  return _createClass(_ShowTooltipEvent);
}(_ViewerEvent);
_ShowTooltipEvent.type = "show-tooltip";
var _ShowTooltipEvent2 = _ShowTooltipEvent;
var _SizeUpdatedEvent = /*#__PURE__*/function (_ViewerEvent25) {
  _inherits(_SizeUpdatedEvent, _ViewerEvent25);
  var _super28 = _createSuper(_SizeUpdatedEvent);
  /** @internal */
  function _SizeUpdatedEvent(size) {
    var _this30;
    _classCallCheck(this, _SizeUpdatedEvent);
    _this30 = _super28.call(this, _SizeUpdatedEvent.type);
    _this30.size = size;
    return _this30;
  }
  return _createClass(_SizeUpdatedEvent);
}(_ViewerEvent);
_SizeUpdatedEvent.type = "size-updated";
var _SizeUpdatedEvent2 = _SizeUpdatedEvent;
var _StopAllEvent = /*#__PURE__*/function (_ViewerEvent26) {
  _inherits(_StopAllEvent, _ViewerEvent26);
  var _super29 = _createSuper(_StopAllEvent);
  /** @internal */
  function _StopAllEvent() {
    _classCallCheck(this, _StopAllEvent);
    return _super29.call(this, _StopAllEvent.type);
  }
  return _createClass(_StopAllEvent);
}(_ViewerEvent);
_StopAllEvent.type = "stop-all";
var _StopAllEvent2 = _StopAllEvent;
var _ZoomUpdatedEvent = /*#__PURE__*/function (_ViewerEvent27) {
  _inherits(_ZoomUpdatedEvent, _ViewerEvent27);
  var _super30 = _createSuper(_ZoomUpdatedEvent);
  /** @internal */
  function _ZoomUpdatedEvent(zoomLevel) {
    var _this31;
    _classCallCheck(this, _ZoomUpdatedEvent);
    _this31 = _super30.call(this, _ZoomUpdatedEvent.type);
    _this31.zoomLevel = zoomLevel;
    return _this31;
  }
  return _createClass(_ZoomUpdatedEvent);
}(_ViewerEvent);
_ZoomUpdatedEvent.type = "zoom-updated";
var _ZoomUpdatedEvent2 = _ZoomUpdatedEvent;
var _ObjectEvent = /*#__PURE__*/function (_ViewerEvent28) {
  _inherits(_ObjectEvent, _ViewerEvent28);
  var _super31 = _createSuper(_ObjectEvent);
  /** @internal */
  function _ObjectEvent(type, originalEvent, object, viewerPoint, userDataKey) {
    var _this32;
    _classCallCheck(this, _ObjectEvent);
    _this32 = _super31.call(this, type);
    _this32.originalEvent = originalEvent;
    _this32.object = object;
    _this32.viewerPoint = viewerPoint;
    _this32.userDataKey = userDataKey;
    return _this32;
  }
  return _createClass(_ObjectEvent);
}(_ViewerEvent);
var _ObjectEnterEvent = /*#__PURE__*/function (_ObjectEvent2) {
  _inherits(_ObjectEnterEvent, _ObjectEvent2);
  var _super32 = _createSuper(_ObjectEnterEvent);
  /** @internal */
  function _ObjectEnterEvent(originalEvent, object, viewerPoint, userDataKey) {
    _classCallCheck(this, _ObjectEnterEvent);
    return _super32.call(this, _ObjectEnterEvent.type, originalEvent, object, viewerPoint, userDataKey);
  }
  return _createClass(_ObjectEnterEvent);
}(_ObjectEvent);
_ObjectEnterEvent.type = "enter-object";
var _ObjectEnterEvent2 = _ObjectEnterEvent;
var _ObjectLeaveEvent = /*#__PURE__*/function (_ObjectEvent3) {
  _inherits(_ObjectLeaveEvent, _ObjectEvent3);
  var _super33 = _createSuper(_ObjectLeaveEvent);
  /** @internal */
  function _ObjectLeaveEvent(originalEvent, object, viewerPoint, userDataKey) {
    _classCallCheck(this, _ObjectLeaveEvent);
    return _super33.call(this, _ObjectLeaveEvent.type, originalEvent, object, viewerPoint, userDataKey);
  }
  return _createClass(_ObjectLeaveEvent);
}(_ObjectEvent);
_ObjectLeaveEvent.type = "leave-object";
var _ObjectLeaveEvent2 = _ObjectLeaveEvent;
var _ObjectHoverEvent = /*#__PURE__*/function (_ObjectEvent4) {
  _inherits(_ObjectHoverEvent, _ObjectEvent4);
  var _super34 = _createSuper(_ObjectHoverEvent);
  /** @internal */
  function _ObjectHoverEvent(originalEvent, object, viewerPoint, userDataKey) {
    _classCallCheck(this, _ObjectHoverEvent);
    return _super34.call(this, _ObjectHoverEvent.type, originalEvent, object, viewerPoint, userDataKey);
  }
  return _createClass(_ObjectHoverEvent);
}(_ObjectEvent);
_ObjectHoverEvent.type = "hover-object";
var _ObjectHoverEvent2 = _ObjectHoverEvent;

// src/adapters/AbstractAdapter.ts
var AbstractAdapter = /*#__PURE__*/function () {
  function AbstractAdapter(viewer) {
    _classCallCheck(this, AbstractAdapter);
    this.viewer = viewer;
  }
  /**
   * Initializes the adapter
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  _createClass(AbstractAdapter, [{
    key: "init",
    value: function init() {}
    /**
     * Destroys the adapter
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }, {
    key: "destroy",
    value: function destroy() {}
    /**
     * Indicates if the adapter supports transitions between panoramas
     */
    // @ts-ignore unused parameter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "supportsTransition",
    value: function supportsTransition(panorama) {
      return false;
    }
    /**
     * Indicates if the adapter supports preload of a panorama
     */
    // @ts-ignore unused parameter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "supportsPreload",
    value: function supportsPreload(panorama) {
      return false;
    }
    /**
     * Converts pixel texture coordinates to spherical radians coordinates
     * @throws {@link PSVError} when the current adapter does not support texture coordinates
     */
    // @ts-ignore unused parameter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "textureCoordsToSphericalCoords",
    value: function textureCoordsToSphericalCoords(point, data) {
      throw new PSVError("Current adapter does not support texture coordinates.");
    }
    /**
     * Converts spherical radians coordinates to pixel texture coordinates
     * @throws {@link PSVError} when the current adapter does not support texture coordinates
     */
    // @ts-ignore unused parameter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "sphericalCoordsToTextureCoords",
    value: function sphericalCoordsToTextureCoords(position, data) {
      throw new PSVError("Current adapter does not support texture coordinates.");
    }
  }]);
  return AbstractAdapter;
}();
/**
 * Indicates if the adapter supports panorama download natively
 */
AbstractAdapter.supportsDownload = false;
function adapterInterop(adapter) {
  if (adapter) {
    for (var _i14 = 0, _arr2 = [["_", adapter]].concat(_toConsumableArray(Object.entries(adapter))); _i14 < _arr2.length; _i14++) {
      var _arr2$_i = _slicedToArray(_arr2[_i14], 2),
        p = _arr2$_i[1];
      if (p.prototype instanceof AbstractAdapter) {
        _checkVersion(p.id, p.VERSION, "5.6.0");
        return p;
      }
    }
  }
  return null;
}

// src/data/system.ts
var LOCALSTORAGE_TOUCH_SUPPORT = "".concat(_VIEWER_DATA, "_touchSupport");
var SYSTEM = {
  /**
   * Indicates if the system data has been loaded
   */
  loaded: false,
  /**
   * Device screen pixel ratio
   */
  pixelRatio: 1,
  /**
   * Device supports WebGL
   */
  isWebGLSupported: false,
  /**
   * Maximum WebGL texture width
   */
  maxTextureWidth: 0,
  /**
   * Device supports touch events
   */
  isTouchEnabled: null,
  /**
   * Name of the fullscreen event
   */
  fullscreenEvent: null,
  /**
   * @internal
   */
  __maxCanvasWidth: null,
  /**
   * Maximum canvas width
   */
  get maxCanvasWidth() {
    if (this.__maxCanvasWidth === null) {
      this.__maxCanvasWidth = getMaxCanvasWidth(this.maxTextureWidth);
    }
    return this.__maxCanvasWidth;
  },
  /**
   * Loads the system if not already loaded
   * @internal
   */
  load: function load() {
    if (!this.loaded) {
      var ctx = getWebGLCtx();
      this.pixelRatio = window.devicePixelRatio || 1;
      this.isWebGLSupported = ctx !== null;
      this.maxTextureWidth = ctx ? ctx.getParameter(ctx.MAX_TEXTURE_SIZE) : 0;
      this.isTouchEnabled = isTouchEnabled();
      this.fullscreenEvent = getFullscreenEvent();
      this.loaded = true;
    }
    if (!SYSTEM.isWebGLSupported) {
      throw new PSVError("WebGL is not supported.");
    }
    if (SYSTEM.maxTextureWidth === 0) {
      throw new PSVError("Unable to detect system capabilities");
    }
  }
};
function getWebGLCtx() {
  var canvas = document.createElement("canvas");
  var names = ["webgl2", "webgl", "experimental-webgl", "moz-webgl", "webkit-3d"];
  var context = null;
  if (!canvas.getContext) {
    return null;
  }
  if (names.some(function (name) {
    try {
      context = canvas.getContext(name);
      return context !== null;
    } catch (e) {
      return false;
    }
  })) {
    return context;
  } else {
    return null;
  }
}
function isTouchEnabled() {
  var initial = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  if (LOCALSTORAGE_TOUCH_SUPPORT in localStorage) {
    initial = localStorage[LOCALSTORAGE_TOUCH_SUPPORT] === "true";
  }
  var promise = new Promise(function (resolve) {
    var clear = function clear() {
      window.removeEventListener("mousedown", listenerMouse);
      window.removeEventListener("touchstart", listenerTouch);
      clearTimeout(listenerTimeoutId);
    };
    var listenerMouse = function listenerMouse() {
      clear();
      localStorage[LOCALSTORAGE_TOUCH_SUPPORT] = false;
      resolve(false);
    };
    var listenerTouch = function listenerTouch() {
      clear();
      localStorage[LOCALSTORAGE_TOUCH_SUPPORT] = true;
      resolve(true);
    };
    var listenerTimeout = function listenerTimeout() {
      clear();
      localStorage[LOCALSTORAGE_TOUCH_SUPPORT] = initial;
      resolve(initial);
    };
    window.addEventListener("mousedown", listenerMouse, false);
    window.addEventListener("touchstart", listenerTouch, false);
    var listenerTimeoutId = setTimeout(listenerTimeout, 1e4);
  });
  return {
    initial: initial,
    promise: promise
  };
}
function getMaxCanvasWidth(maxWidth) {
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  canvas.width = maxWidth;
  canvas.height = maxWidth / 2;
  while (canvas.width > 1024) {
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, 1, 1);
    try {
      if (ctx.getImageData(0, 0, 1, 1).data[0] > 0) {
        return canvas.width;
      }
    } catch (e) {}
    canvas.width /= 2;
    canvas.height /= 2;
  }
  throw new PSVError("Unable to detect system capabilities");
}
function getFullscreenEvent() {
  if ("exitFullscreen" in document) {
    return "fullscreenchange";
  }
  if ("webkitExitFullscreen" in document) {
    return "webkitfullscreenchange";
  }
  return null;
}

// src/adapters/interpolationWorker.ts
function interpolationWorker() {
  self.onmessage = function (e) {
    var panoData = e.data.panoData;
    var buffer = new OffscreenCanvas(panoData.fullWidth, panoData.fullHeight);
    var ctx = buffer.getContext("2d");
    var img = new OffscreenCanvas(panoData.croppedWidth, panoData.croppedHeight);
    var ctxImg = img.getContext("2d");
    ctxImg.putImageData(e.data.image, 0, 0);
    autoBackground(buffer, img, panoData);
    postMessage(ctx.getImageData(0, 0, buffer.width, buffer.height));
  };
  function autoBackground(buffer, img, panoData) {
    var croppedY2 = panoData.fullHeight - panoData.croppedHeight - panoData.croppedY;
    var croppedX2 = panoData.fullWidth - panoData.croppedWidth - panoData.croppedX;
    var middleY = panoData.croppedY + panoData.croppedHeight / 2;
    var blurSize = buffer.width / 32;
    var padding = blurSize;
    var edge = 10;
    var filter = "blur(".concat(blurSize, "px)");
    var ctx = buffer.getContext("2d");
    ctx.drawImage(img, panoData.croppedX, panoData.croppedY, panoData.croppedWidth, panoData.croppedHeight);
    if (panoData.croppedY > 0) {
      if (panoData.croppedX > 0 || croppedX2 > 0) {
        ctx.filter = "none";
        var colorLeft = getAverageColor(ctx, panoData.croppedX, panoData.croppedY, edge, edge, 2);
        var colorRight = getAverageColor(ctx, buffer.width - croppedX2 - 11, panoData.croppedY, edge, edge, 2);
        var colorCenter = averageRgb(colorLeft, colorRight);
        if (panoData.croppedX > 0) {
          ctx.fillStyle = createHorizontalGradient(ctx, 0, panoData.croppedX, colorCenter, colorLeft);
          ctx.fillRect(-padding, -padding, panoData.croppedX + padding * 2, middleY + padding);
        }
        if (croppedX2 > 0) {
          ctx.fillStyle = createHorizontalGradient(ctx, buffer.width - croppedX2, buffer.width, colorRight, colorCenter);
          ctx.fillRect(buffer.width - croppedX2 - padding, -padding, croppedX2 + padding * 2, middleY + padding);
        }
      }
      ctx.filter = filter;
      ctx.drawImage(img, 0, 0, img.width, edge, panoData.croppedX, -padding, panoData.croppedWidth, panoData.croppedY + padding * 2);
      ctx.fillStyle = rgbCss(getAverageColor(ctx, 0, 0, buffer.width, edge, edge));
      ctx.fillRect(-padding, -padding, buffer.width + padding * 2, padding * 2);
    }
    if (croppedY2 > 0) {
      if (panoData.croppedX > 0 || croppedX2 > 0) {
        ctx.filter = "none";
        var _colorLeft = getAverageColor(ctx, panoData.croppedX, buffer.height - croppedY2 - 1 - edge, edge, edge, 2);
        var _colorRight = getAverageColor(ctx, buffer.width - croppedX2 - 1 - edge, buffer.height - croppedY2 - 1 - edge, edge, edge, 2);
        var _colorCenter = averageRgb(_colorLeft, _colorRight);
        if (panoData.croppedX > 0) {
          ctx.fillStyle = createHorizontalGradient(ctx, 0, panoData.croppedX, _colorCenter, _colorLeft);
          ctx.fillRect(-padding, middleY, panoData.croppedX + padding * 2, buffer.height - middleY + padding);
        }
        if (croppedX2 > 0) {
          ctx.fillStyle = createHorizontalGradient(ctx, buffer.width - croppedX2, buffer.width, _colorRight, _colorCenter);
          ctx.fillRect(buffer.width - croppedX2 - padding, middleY, croppedX2 + padding * 2, buffer.height - middleY + padding);
        }
      }
      ctx.filter = filter;
      ctx.drawImage(img, 0, img.height - edge, img.width, edge, panoData.croppedX, buffer.height - croppedY2 - padding, panoData.croppedWidth, croppedY2 + padding * 2);
      ctx.fillStyle = rgbCss(getAverageColor(ctx, 0, buffer.height - 1 - edge, buffer.width, edge, edge));
      ctx.fillRect(-padding, buffer.height - padding, buffer.width + padding * 2, padding * 2);
    }
    if (panoData.croppedX > 0) {
      ctx.filter = filter;
      ctx.drawImage(img, img.width - edge, 0, edge, img.height, -padding, panoData.croppedY, padding * 2, panoData.croppedHeight);
      ctx.drawImage(img, 0, 0, edge, img.height, 0, panoData.croppedY, panoData.croppedX + padding, panoData.croppedHeight);
    }
    if (croppedX2 > 0) {
      ctx.filter = filter;
      ctx.drawImage(img, 0, 0, edge, img.height, buffer.width - padding, panoData.croppedY, padding * 2, panoData.croppedHeight);
      ctx.drawImage(img, img.width - edge, 0, edge, img.height, buffer.width - croppedX2 - padding, panoData.croppedY, croppedX2 + padding, panoData.croppedHeight);
    }
    ctx.filter = "none";
    ctx.drawImage(img, panoData.croppedX, panoData.croppedY, panoData.croppedWidth, panoData.croppedHeight);
  }
  function rgbCss(color) {
    return "rgb(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ")");
  }
  function averageRgb(c1, c2) {
    return {
      r: Math.round(c1.r / 2 + c2.r / 2),
      g: Math.round(c1.g / 2 + c2.g / 2),
      b: Math.round(c1.b / 2 + c2.b / 2)
    };
  }
  function createHorizontalGradient(ctx, x1, x2, c1, c2) {
    var grad = ctx.createLinearGradient(x1, 0, x2, 0);
    grad.addColorStop(0, rgbCss(c1));
    grad.addColorStop(1, rgbCss(c2));
    return grad;
  }
  function getAverageColor(ctx, x, y, w, h, every) {
    every = Math.round(every);
    var r = 0;
    var g = 0;
    var b = 0;
    var count = 0;
    var data = ctx.getImageData(x, y, w, h);
    for (var row = 0; row < h; row += every) {
      for (var col = 0; col < w; col += every) {
        var i = 4 * (row * w + col);
        r += data.data[i];
        g += data.data[i + 1];
        b += data.data[i + 2];
        count++;
      }
    }
    r = Math.round(r / count);
    g = Math.round(g / count);
    b = Math.round(b / count);
    return {
      r: r,
      g: g,
      b: b
    };
  }
}
var interpolationWorkerSrc = URL.createObjectURL(new Blob(["(", interpolationWorker.toString(), ")()"], {
  type: "application/javascript"
}));

// src/adapters/EquirectangularAdapter.ts
var getConfig = _getConfigParser({
  backgroundColor: "#000",
  interpolateBackground: false,
  resolution: 64,
  useXmpData: true,
  blur: false
}, {
  resolution: function resolution(_resolution) {
    if (!_resolution || !MathUtils.isPowerOfTwo(_resolution)) {
      throw new PSVError("EquirectangularAdapter resolution must be power of two");
    }
    return _resolution;
  }
});
var EquirectangularAdapter = /*#__PURE__*/function (_AbstractAdapter) {
  _inherits(EquirectangularAdapter, _AbstractAdapter);
  var _super35 = _createSuper(EquirectangularAdapter);
  function EquirectangularAdapter(viewer, config) {
    var _this33;
    _classCallCheck(this, EquirectangularAdapter);
    _this33 = _super35.call(this, viewer);
    _this33.config = getConfig(config);
    if (_this33.config.interpolateBackground) {
      if (!window.Worker) {
        _logWarn("Web Worker API not available");
        _this33.config.interpolateBackground = false;
      } else {
        _this33.interpolationWorker = new Worker(interpolationWorkerSrc);
      }
    }
    _this33.SPHERE_SEGMENTS = _this33.config.resolution;
    _this33.SPHERE_HORIZONTAL_SEGMENTS = _this33.SPHERE_SEGMENTS / 2;
    return _this33;
  }
  _createClass(EquirectangularAdapter, [{
    key: "supportsTransition",
    value: function supportsTransition() {
      return true;
    }
  }, {
    key: "supportsPreload",
    value: function supportsPreload() {
      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$interpolationWo;
      (_this$interpolationWo = this.interpolationWorker) === null || _this$interpolationWo === void 0 ? void 0 : _this$interpolationWo.terminate();
      _get(_getPrototypeOf(EquirectangularAdapter.prototype), "destroy", this).call(this);
    }
  }, {
    key: "textureCoordsToSphericalCoords",
    value: function textureCoordsToSphericalCoords(point, data) {
      if (_isNil(point.textureX) || _isNil(point.textureY)) {
        throw new PSVError("Texture position is missing 'textureX' or 'textureY'");
      }
      var relativeX = (point.textureX + data.croppedX) / data.fullWidth * Math.PI * 2;
      var relativeY = (point.textureY + data.croppedY) / data.fullHeight * Math.PI;
      return {
        yaw: relativeX >= Math.PI ? relativeX - Math.PI : relativeX + Math.PI,
        pitch: Math.PI / 2 - relativeY
      };
    }
  }, {
    key: "sphericalCoordsToTextureCoords",
    value: function sphericalCoordsToTextureCoords(position, data) {
      var relativeLong = position.yaw / Math.PI / 2 * data.fullWidth;
      var relativeLat = position.pitch / Math.PI * data.fullHeight;
      return {
        textureX: Math.round(position.yaw < Math.PI ? relativeLong + data.fullWidth / 2 : relativeLong - data.fullWidth / 2) - data.croppedX,
        textureY: Math.round(data.fullHeight / 2 - relativeLat) - data.croppedY
      };
    }
  }, {
    key: "loadTexture",
    value: function () {
      var _loadTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(panorama) {
        var _this34 = this,
          _newPanoData,
          _newPanoData2,
          _newPanoData3,
          _newPanoData4,
          _newPanoData5,
          _newPanoData6,
          _newPanoData7,
          _newPanoData8,
          _newPanoData9;
        var loader,
          newPanoData,
          useXmpPanoData,
          blob,
          xmpPanoData,
          img,
          panoData,
          texture,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loader = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              newPanoData = _args.length > 2 ? _args[2] : undefined;
              useXmpPanoData = _args.length > 3 && _args[3] !== undefined ? _args[3] : this.config.useXmpData;
              if (!(typeof panorama !== "string")) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", Promise.reject(new PSVError("Invalid panorama url, are you using the right adapter?")));
            case 5:
              _context.next = 7;
              return this.viewer.textureLoader.loadFile(panorama, loader ? function (p) {
                return _this34.viewer.loader.setProgress(p);
              } : null, panorama);
            case 7:
              blob = _context.sent;
              if (!useXmpPanoData) {
                _context.next = 14;
                break;
              }
              _context.next = 11;
              return this.loadXMP(blob);
            case 11:
              _context.t0 = _context.sent;
              _context.next = 15;
              break;
            case 14:
              _context.t0 = null;
            case 15:
              xmpPanoData = _context.t0;
              _context.next = 18;
              return this.viewer.textureLoader.blobToImage(blob);
            case 18:
              img = _context.sent;
              if (typeof newPanoData === "function") {
                newPanoData = newPanoData(img, xmpPanoData);
              }
              if (!newPanoData && !xmpPanoData) {
                newPanoData = this.__defaultPanoData(img);
              }
              panoData = {
                isEquirectangular: true,
                fullWidth: _firstNonNull((_newPanoData = newPanoData) === null || _newPanoData === void 0 ? void 0 : _newPanoData.fullWidth, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.fullWidth, img.width),
                fullHeight: _firstNonNull((_newPanoData2 = newPanoData) === null || _newPanoData2 === void 0 ? void 0 : _newPanoData2.fullHeight, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.fullHeight, img.height),
                croppedWidth: _firstNonNull((_newPanoData3 = newPanoData) === null || _newPanoData3 === void 0 ? void 0 : _newPanoData3.croppedWidth, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.croppedWidth, img.width),
                croppedHeight: _firstNonNull((_newPanoData4 = newPanoData) === null || _newPanoData4 === void 0 ? void 0 : _newPanoData4.croppedHeight, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.croppedHeight, img.height),
                croppedX: _firstNonNull((_newPanoData5 = newPanoData) === null || _newPanoData5 === void 0 ? void 0 : _newPanoData5.croppedX, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.croppedX, 0),
                croppedY: _firstNonNull((_newPanoData6 = newPanoData) === null || _newPanoData6 === void 0 ? void 0 : _newPanoData6.croppedY, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.croppedY, 0),
                poseHeading: _firstNonNull((_newPanoData7 = newPanoData) === null || _newPanoData7 === void 0 ? void 0 : _newPanoData7.poseHeading, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.poseHeading, 0),
                posePitch: _firstNonNull((_newPanoData8 = newPanoData) === null || _newPanoData8 === void 0 ? void 0 : _newPanoData8.posePitch, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.posePitch, 0),
                poseRoll: _firstNonNull((_newPanoData9 = newPanoData) === null || _newPanoData9 === void 0 ? void 0 : _newPanoData9.poseRoll, xmpPanoData === null || xmpPanoData === void 0 ? void 0 : xmpPanoData.poseRoll, 0)
              };
              if (panoData.croppedWidth !== img.width || panoData.croppedHeight !== img.height) {
                _logWarn("Invalid panoData, croppedWidth/croppedHeight is not coherent with the loaded image.\n            panoData: ".concat(panoData.croppedWidth, "x").concat(panoData.croppedHeight, ", image: ").concat(img.width, "x").concat(img.height));
              }
              if (Math.abs(panoData.fullWidth - panoData.fullHeight * 2) > 1) {
                _logWarn("Invalid panoData, fullWidth should be twice fullHeight");
                panoData.fullWidth = panoData.fullHeight * 2;
              }
              if (panoData.croppedX + panoData.croppedWidth > panoData.fullWidth) {
                _logWarn("Invalid panoData, croppedX + croppedWidth > fullWidth");
                panoData.croppedX = panoData.fullWidth - panoData.croppedWidth;
              }
              if (panoData.croppedY + panoData.croppedHeight > panoData.fullHeight) {
                _logWarn("Invalid panoData, croppedY + croppedHeight > fullHeight");
                panoData.croppedY = panoData.fullHeight - panoData.croppedHeight;
              }
              texture = this.createEquirectangularTexture(img, panoData);
              return _context.abrupt("return", {
                panorama: panorama,
                texture: texture,
                panoData: panoData,
                cacheKey: panorama
              });
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadTexture(_x2) {
        return _loadTexture.apply(this, arguments);
      }
      return loadTexture;
    }()
    /**
     * Loads the XMP data of an image
     */
  }, {
    key: "loadXMP",
    value: function () {
      var _loadXMP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(blob) {
        var binary, a, b, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.loadBlobAsString(blob);
            case 2:
              binary = _context2.sent;
              a = binary.indexOf("<x:xmpmeta");
              b = binary.indexOf("</x:xmpmeta>");
              data = binary.substring(a, b);
              if (!(a !== -1 && b !== -1 && data.includes("GPano:"))) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", {
                isEquirectangular: true,
                fullWidth: _getXMPValue(data, "FullPanoWidthPixels"),
                fullHeight: _getXMPValue(data, "FullPanoHeightPixels"),
                croppedWidth: _getXMPValue(data, "CroppedAreaImageWidthPixels"),
                croppedHeight: _getXMPValue(data, "CroppedAreaImageHeightPixels"),
                croppedX: _getXMPValue(data, "CroppedAreaLeftPixels"),
                croppedY: _getXMPValue(data, "CroppedAreaTopPixels"),
                poseHeading: _getXMPValue(data, "PoseHeadingDegrees"),
                posePitch: _getXMPValue(data, "PosePitchDegrees"),
                poseRoll: _getXMPValue(data, "PoseRollDegrees")
              });
            case 8:
              return _context2.abrupt("return", null);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadXMP(_x3) {
        return _loadXMP.apply(this, arguments);
      }
      return loadXMP;
    }()
    /**
     * Reads a Blob as a string
     */
  }, {
    key: "loadBlobAsString",
    value: function loadBlobAsString(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
      });
    }
    /**
     * Creates the final texture from image and panorama data
     */
  }, {
    key: "createEquirectangularTexture",
    value: function createEquirectangularTexture(img, panoData) {
      var _this35 = this;
      if (this.config.blur || panoData.fullWidth > SYSTEM.maxTextureWidth || panoData.croppedWidth !== panoData.fullWidth || panoData.croppedHeight !== panoData.fullHeight) {
        var ratio = Math.min(1, SYSTEM.maxCanvasWidth / panoData.fullWidth);
        var resizedPanoData = {
          fullWidth: panoData.fullWidth * ratio,
          fullHeight: panoData.fullHeight * ratio,
          croppedWidth: panoData.croppedWidth * ratio,
          croppedHeight: panoData.croppedHeight * ratio,
          croppedX: panoData.croppedX * ratio,
          croppedY: panoData.croppedY * ratio
        };
        var buffer = document.createElement("canvas");
        buffer.width = resizedPanoData.fullWidth;
        buffer.height = resizedPanoData.fullHeight;
        var ctx = buffer.getContext("2d");
        if (this.config.backgroundColor) {
          ctx.fillStyle = this.config.backgroundColor;
          ctx.fillRect(0, 0, buffer.width, buffer.height);
        }
        if (this.config.blur) {
          ctx.filter = "blur(".concat(buffer.width / 2048, "px)");
        }
        ctx.drawImage(img, resizedPanoData.croppedX, resizedPanoData.croppedY, resizedPanoData.croppedWidth, resizedPanoData.croppedHeight);
        var t = _createTexture(buffer);
        if (this.config.interpolateBackground && (panoData.croppedWidth !== panoData.fullWidth || panoData.croppedHeight !== panoData.fullHeight)) {
          this.interpolationWorker.postMessage({
            image: ctx.getImageData(resizedPanoData.croppedX, resizedPanoData.croppedY, resizedPanoData.croppedWidth, resizedPanoData.croppedHeight),
            panoData: resizedPanoData
          });
          this.interpolationWorker.onmessage = function (e) {
            ctx.putImageData(e.data, 0, 0);
            t.needsUpdate = true;
            _this35.viewer.needsUpdate();
          };
        }
        return t;
      }
      return _createTexture(img);
    }
  }, {
    key: "createMesh",
    value: function createMesh() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var geometry = new SphereGeometry(_SPHERE_RADIUS * scale, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1);
      return new Mesh(geometry, new MeshBasicMaterial());
    }
  }, {
    key: "setTexture",
    value: function setTexture(mesh, textureData) {
      mesh.material.map = textureData.texture;
    }
  }, {
    key: "setTextureOpacity",
    value: function setTextureOpacity(mesh, opacity) {
      mesh.material.opacity = opacity;
      mesh.material.transparent = opacity < 1;
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(textureData) {
      var _textureData$texture;
      (_textureData$texture = textureData.texture) === null || _textureData$texture === void 0 ? void 0 : _textureData$texture.dispose();
    }
  }, {
    key: "__defaultPanoData",
    value: function __defaultPanoData(img) {
      var fullWidth = Math.max(img.width, img.height * 2);
      var fullHeight = Math.round(fullWidth / 2);
      var croppedX = Math.round((fullWidth - img.width) / 2);
      var croppedY = Math.round((fullHeight - img.height) / 2);
      return {
        isEquirectangular: true,
        fullWidth: fullWidth,
        fullHeight: fullHeight,
        croppedWidth: img.width,
        croppedHeight: img.height,
        croppedX: croppedX,
        croppedY: croppedY
      };
    }
  }]);
  return EquirectangularAdapter;
}(AbstractAdapter);
EquirectangularAdapter.id = "equirectangular";
EquirectangularAdapter.VERSION = "5.6.0";
EquirectangularAdapter.supportsDownload = true;

// src/components/AbstractComponent.ts
var AbstractComponent = /*#__PURE__*/function () {
  function _AbstractComponent(parent, config) {
    _classCallCheck(this, _AbstractComponent);
    this.parent = parent;
    /**
     * All child components
     * @internal
     */
    this.children = [];
    /**
     * Container element
     */
    this.container = document.createElement("div");
    /**
     * Internal properties
     * @internal
     */
    this.state = {
      visible: true
    };
    this.viewer = parent instanceof _AbstractComponent ? parent.viewer : parent;
    this.container.className = config.className || "";
    this.parent.children.push(this);
    this.parent.container.appendChild(this.container);
  }
  /**
   * Destroys the component
   */
  _createClass(_AbstractComponent, [{
    key: "destroy",
    value: function destroy() {
      this.parent.container.removeChild(this.container);
      var childIdx = this.parent.children.indexOf(this);
      if (childIdx !== -1) {
        this.parent.children.splice(childIdx, 1);
      }
      this.children.slice().forEach(function (child) {
        return child.destroy();
      });
      this.children.length = 0;
    }
    /**
     * Displays or hides the component
     */
  }, {
    key: "toggle",
    value: function toggle() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.isVisible();
      if (!visible) {
        this.hide();
      } else {
        this.show();
      }
    }
    /**
     * Hides the component
     */
    // @ts-ignore unused parameter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "hide",
    value: function hide(options) {
      this.container.style.display = "none";
      this.state.visible = false;
    }
    /**
     * Displays the component
     */
    // @ts-ignore unused parameter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "show",
    value: function show(options) {
      this.container.style.display = "";
      this.state.visible = true;
    }
    /**
     * Checks if the component is visible
     */
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.state.visible;
    }
  }]);
  return _AbstractComponent;
}();

// src/buttons/AbstractButton.ts
var getConfig2 = _getConfigParser({
  id: null,
  className: null,
  title: null,
  hoverScale: false,
  collapsable: false,
  tabbable: true,
  icon: null,
  iconActive: null
});
var AbstractButton = /*#__PURE__*/function (_AbstractComponent2) {
  _inherits(AbstractButton, _AbstractComponent2);
  var _super36 = _createSuper(AbstractButton);
  function AbstractButton(navbar, config) {
    var _this36;
    _classCallCheck(this, AbstractButton);
    _this36 = _super36.call(this, navbar, {
      className: "psv-button ".concat(config.hoverScale ? "psv-button--hover-scale" : "", " ").concat(config.className || "")
    });
    /**
     * Internal properties
     */
    _this36.state = {
      visible: true,
      enabled: true,
      supported: true,
      collapsed: false,
      active: false,
      width: 0
    };
    _this36.config = getConfig2(config);
    _this36.config.id = _this36.constructor.id;
    if (config.icon) {
      _this36.__setIcon(config.icon);
    }
    _this36.state.width = _this36.container.offsetWidth;
    if (_this36.config.title) {
      _this36.container.title = _this36.config.title;
    } else if (_this36.id && _this36.id in _this36.viewer.config.lang) {
      _this36.container.title = _this36.viewer.config.lang[_this36.id];
    }
    if (config.tabbable) {
      _this36.container.tabIndex = 0;
    }
    _this36.container.addEventListener("click", function (e) {
      if (_this36.state.enabled) {
        _this36.onClick();
      }
      e.stopPropagation();
    });
    _this36.container.addEventListener("keydown", function (e) {
      if (e.key === _KEY_CODES.Enter && _this36.state.enabled) {
        _this36.onClick();
        e.stopPropagation();
      }
    });
    return _this36;
  }
  _createClass(AbstractButton, [{
    key: "id",
    get: function get() {
      return this.config.id;
    }
  }, {
    key: "title",
    get: function get() {
      return this.container.title;
    }
  }, {
    key: "content",
    get: function get() {
      return this.container.innerHTML;
    }
  }, {
    key: "width",
    get: function get() {
      return this.state.width;
    }
  }, {
    key: "collapsable",
    get: function get() {
      return this.config.collapsable;
    }
  }, {
    key: "show",
    value: function show() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.isVisible()) {
        this.state.visible = true;
        if (!this.state.collapsed) {
          this.container.style.display = "";
        }
        if (refresh) {
          this.viewer.navbar.autoSize();
        }
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.isVisible()) {
        this.state.visible = false;
        this.container.style.display = "none";
        if (refresh) {
          this.viewer.navbar.autoSize();
        }
      }
    }
    /**
     * Hides/shows the button depending of the result of {@link isSupported}
     * @internal
     */
  }, {
    key: "checkSupported",
    value: function checkSupported() {
      var _this37 = this;
      _resolveBoolean(this.isSupported(), function (supported, init) {
        if (!_this37.state) {
          return;
        }
        _this37.state.supported = supported;
        if (!init) {
          _this37.toggle(supported);
        } else if (!supported) {
          _this37.hide();
        }
      });
    }
    /**
     * Perform action when the navbar size/content changes
     * @internal
     */
  }, {
    key: "autoSize",
    value: function autoSize() {}
    /**
     * Checks if the button can be displayed
     */
  }, {
    key: "isSupported",
    value: function isSupported() {
      return true;
    }
    /**
     * Changes the active state of the button
     */
  }, {
    key: "toggleActive",
    value: function toggleActive() {
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.active;
      if (active !== this.state.active) {
        this.state.active = active;
        _toggleClass(this.container, "psv-button--active", this.state.active);
        if (this.config.iconActive) {
          this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon);
        }
      }
    }
    /**
     * Disables the button
     */
  }, {
    key: "disable",
    value: function disable() {
      this.container.classList.add("psv-button--disabled");
      this.state.enabled = false;
    }
    /**
     * Enables the button
     */
  }, {
    key: "enable",
    value: function enable() {
      this.container.classList.remove("psv-button--disabled");
      this.state.enabled = true;
    }
    /**
     * Collapses the button in the navbar menu
     */
  }, {
    key: "collapse",
    value: function collapse() {
      this.state.collapsed = true;
      this.container.style.display = "none";
    }
    /**
     * Uncollapses the button from the navbar menu
     */
  }, {
    key: "uncollapse",
    value: function uncollapse() {
      this.state.collapsed = false;
      if (this.state.visible) {
        this.container.style.display = "";
      }
    }
  }, {
    key: "__setIcon",
    value: function __setIcon(icon) {
      this.container.innerHTML = icon;
      _addClasses(this.container.querySelector("svg"), "psv-button-svg");
    }
  }]);
  return AbstractButton;
}(AbstractComponent);

// src/buttons/CustomButton.ts
var CustomButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(CustomButton, _AbstractButton);
  var _super37 = _createSuper(CustomButton);
  function CustomButton(navbar, config) {
    var _this38;
    _classCallCheck(this, CustomButton);
    _this38 = _super37.call(this, navbar, {
      className: "psv-custom-button ".concat(config.className || ""),
      hoverScale: false,
      collapsable: config.collapsable !== false,
      tabbable: config.tabbable !== false,
      title: config.title
    });
    _this38.customOnClick = config.onClick;
    if (config.id) {
      _this38.config.id = config.id;
    } else {
      _this38.config.id = "psvButton-" + Math.random().toString(36).substring(2);
    }
    if (config.content) {
      if (typeof config.content === "string") {
        _this38.container.innerHTML = config.content;
      } else {
        var _config$content$attac, _config$content;
        _this38.container.classList.add("psv-custom-button--no-padding");
        config.content.style.height = "100%";
        (_config$content$attac = (_config$content = config.content).attachViewer) === null || _config$content$attac === void 0 ? void 0 : _config$content$attac.call(_config$content, _this38.viewer);
        _this38.container.appendChild(config.content);
      }
    }
    _this38.state.width = _this38.container.offsetWidth;
    if (config.disabled) {
      _this38.disable();
    }
    if (config.visible === false) {
      _this38.hide();
    }
    return _this38;
  }
  _createClass(CustomButton, [{
    key: "onClick",
    value: function onClick() {
      var _this$customOnClick;
      (_this$customOnClick = this.customOnClick) === null || _this$customOnClick === void 0 ? void 0 : _this$customOnClick.call(this, this.viewer);
    }
  }]);
  return CustomButton;
}(AbstractButton);

// src/buttons/DescriptionButton.ts
var DescriptionButton = /*#__PURE__*/function (_AbstractButton2) {
  _inherits(DescriptionButton, _AbstractButton2);
  var _super38 = _createSuper(DescriptionButton);
  function DescriptionButton(navbar) {
    var _this39;
    _classCallCheck(this, DescriptionButton);
    _this39 = _super38.call(this, navbar, {
      className: "psv-description-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: _ICONS.info
    });
    _this39.mode = 0 /* NONE */;
    _this39.viewer.addEventListener(_HideNotificationEvent2.type, _assertThisInitialized(_this39));
    _this39.viewer.addEventListener(_ShowNotificationEvent2.type, _assertThisInitialized(_this39));
    _this39.viewer.addEventListener(_HidePanelEvent2.type, _assertThisInitialized(_this39));
    _this39.viewer.addEventListener(_ShowPanelEvent2.type, _assertThisInitialized(_this39));
    _this39.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this39));
    return _this39;
  }
  _createClass(DescriptionButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_HideNotificationEvent2.type, this);
      this.viewer.removeEventListener(_ShowNotificationEvent2.type, this);
      this.viewer.removeEventListener(_HidePanelEvent2.type, this);
      this.viewer.removeEventListener(_ShowPanelEvent2.type, this);
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);
      _get(_getPrototypeOf(DescriptionButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ConfigChangedEvent2) {
        e.containsOptions("description") && this.autoSize(true);
        return;
      }
      if (!this.mode) {
        return;
      }
      var closed = false;
      if (e instanceof _HideNotificationEvent2) {
        closed = this.mode === 1 /* NOTIF */;
      } else if (e instanceof _ShowNotificationEvent2) {
        closed = this.mode === 1 /* NOTIF */ && e.notificationId !== _IDS.DESCRIPTION;
      } else if (e instanceof _HidePanelEvent2) {
        closed = this.mode === 2 /* PANEL */;
      } else if (e instanceof _ShowPanelEvent2) {
        closed = this.mode === 2 /* PANEL */ && e.panelId !== _IDS.DESCRIPTION;
      }
      if (closed) {
        this.toggleActive(false);
        this.mode = 0 /* NONE */;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (this.mode) {
        this.__close();
      } else {
        this.__open();
      }
    }
  }, {
    key: "hide",
    value: function hide(refresh) {
      _get(_getPrototypeOf(DescriptionButton.prototype), "hide", this).call(this, refresh);
      if (this.mode) {
        this.__close();
      }
    }
    /**
     * This button can only be refreshed from NavbarCaption
     * @internal
     */
  }, {
    key: "autoSize",
    value: function autoSize() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (refresh) {
        var caption = this.viewer.navbar.getButton("caption", false);
        var captionHidden = caption && !caption.isVisible();
        var hasDescription = !!this.viewer.config.description;
        if (captionHidden || hasDescription) {
          this.show(false);
        } else {
          this.hide(false);
        }
      }
    }
  }, {
    key: "__close",
    value: function __close() {
      switch (this.mode) {
        case 1 /* NOTIF */:
          this.viewer.notification.hide(_IDS.DESCRIPTION);
          break;
        case 2 /* PANEL */:
          this.viewer.panel.hide(_IDS.DESCRIPTION);
          break;
      }
    }
  }, {
    key: "__open",
    value: function __open() {
      this.toggleActive(true);
      if (this.viewer.config.description) {
        this.mode = 2 /* PANEL */;
        this.viewer.panel.show({
          id: _IDS.DESCRIPTION,
          content: (this.viewer.config.caption ? "<p>".concat(this.viewer.config.caption, "</p>") : "") + this.viewer.config.description
        });
      } else {
        this.mode = 1 /* NOTIF */;
        this.viewer.notification.show({
          id: _IDS.DESCRIPTION,
          content: this.viewer.config.caption
        });
      }
    }
  }]);
  return DescriptionButton;
}(AbstractButton);
DescriptionButton.id = "description";

// src/buttons/DownloadButton.ts
var DownloadButton = /*#__PURE__*/function (_AbstractButton3) {
  _inherits(DownloadButton, _AbstractButton3);
  var _super39 = _createSuper(DownloadButton);
  function DownloadButton(navbar) {
    var _this40;
    _classCallCheck(this, DownloadButton);
    _this40 = _super39.call(this, navbar, {
      className: "psv-download-button",
      hoverScale: true,
      collapsable: true,
      tabbable: true,
      icon: _ICONS.download
    });
    _this40.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this40));
    return _this40;
  }
  _createClass(DownloadButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);
      _get(_getPrototypeOf(DownloadButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ConfigChangedEvent2) {
        e.containsOptions("downloadUrl") && this.checkSupported();
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var _this41 = this;
      var link = document.createElement("a");
      link.href = this.viewer.config.downloadUrl || this.viewer.config.panorama;
      if (link.href.startsWith("data:") && !this.viewer.config.downloadName) {
        link.download = "panorama." + link.href.substring(0, link.href.indexOf(";")).split("/").pop();
      } else {
        link.download = this.viewer.config.downloadName || link.href.split("/").pop();
      }
      link.target = "_blank";
      this.viewer.container.appendChild(link);
      link.click();
      setTimeout(function () {
        _this41.viewer.container.removeChild(link);
      }, 100);
    }
  }, {
    key: "checkSupported",
    value: function checkSupported() {
      var supported = this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl;
      if (supported) {
        this.show();
      } else {
        this.hide();
      }
    }
  }]);
  return DownloadButton;
}(AbstractButton);
DownloadButton.id = "download";

// src/buttons/FullscreenButton.ts
var FullscreenButton = /*#__PURE__*/function (_AbstractButton4) {
  _inherits(FullscreenButton, _AbstractButton4);
  var _super40 = _createSuper(FullscreenButton);
  function FullscreenButton(navbar) {
    var _this42;
    _classCallCheck(this, FullscreenButton);
    _this42 = _super40.call(this, navbar, {
      className: "psv-fullscreen-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: _ICONS.fullscreenIn,
      iconActive: _ICONS.fullscreenOut
    });
    _this42.viewer.addEventListener(_FullscreenEvent2.type, _assertThisInitialized(_this42));
    return _this42;
  }
  _createClass(FullscreenButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_FullscreenEvent2.type, this);
      _get(_getPrototypeOf(FullscreenButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _FullscreenEvent2) {
        this.toggleActive(e.fullscreenEnabled);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.viewer.toggleFullscreen();
    }
  }]);
  return FullscreenButton;
}(AbstractButton);
FullscreenButton.id = "fullscreen";

// src/buttons/MenuButton.ts
var BUTTON_DATA = "psvButton";
var MENU_TEMPLATE = function MENU_TEMPLATE(buttons, title) {
  return "\n<div class=\"psv-panel-menu psv-panel-menu--stripped\">\n  <h1 class=\"psv-panel-menu-title\">".concat(_ICONS.menu, " ").concat(title, "</h1>\n  <ul class=\"psv-panel-menu-list\">\n    ").concat(buttons.map(function (button) {
    return "\n    <li data-psv-button=\"".concat(button.id, "\" class=\"psv-panel-menu-item\" tabindex=\"0\">\n      <span class=\"psv-panel-menu-item-icon\">").concat(button.content, "</span>\n      <span class=\"psv-panel-menu-item-label\">").concat(button.title, "</span>\n    </li>\n    ");
  }).join(""), "\n  </ul>\n</div>\n");
};
var MenuButton = /*#__PURE__*/function (_AbstractButton5) {
  _inherits(MenuButton, _AbstractButton5);
  var _super41 = _createSuper(MenuButton);
  function MenuButton(navbar) {
    var _thisSuper, _this43;
    _classCallCheck(this, MenuButton);
    _this43 = _super41.call(this, navbar, {
      className: "psv-menu-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: _ICONS.menu
    });
    _this43.viewer.addEventListener(_ShowPanelEvent2.type, _assertThisInitialized(_this43));
    _this43.viewer.addEventListener(_HidePanelEvent2.type, _assertThisInitialized(_this43));
    _get((_thisSuper = _assertThisInitialized(_this43), _getPrototypeOf(MenuButton.prototype)), "hide", _thisSuper).call(_thisSuper);
    return _this43;
  }
  _createClass(MenuButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ShowPanelEvent2.type, this);
      this.viewer.removeEventListener(_HidePanelEvent2.type, this);
      _get(_getPrototypeOf(MenuButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ShowPanelEvent2) {
        this.toggleActive(e.panelId === _IDS.MENU);
      } else if (e instanceof _HidePanelEvent2) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (this.state.active) {
        this.__hideMenu();
      } else {
        this.__showMenu();
      }
    }
  }, {
    key: "hide",
    value: function hide(refresh) {
      _get(_getPrototypeOf(MenuButton.prototype), "hide", this).call(this, refresh);
      this.__hideMenu();
    }
  }, {
    key: "show",
    value: function show(refresh) {
      _get(_getPrototypeOf(MenuButton.prototype), "show", this).call(this, refresh);
      if (this.state.active) {
        this.__showMenu();
      }
    }
  }, {
    key: "__showMenu",
    value: function __showMenu() {
      var _this44 = this;
      this.viewer.panel.show({
        id: _IDS.MENU,
        content: MENU_TEMPLATE(this.viewer.navbar.collapsed, this.viewer.config.lang.menu),
        noMargin: true,
        clickHandler: function clickHandler(target) {
          var li = target ? _getClosest(target, "li") : void 0;
          var buttonId = li ? li.dataset[BUTTON_DATA] : void 0;
          if (buttonId) {
            _this44.viewer.navbar.getButton(buttonId).onClick();
            _this44.__hideMenu();
          }
        }
      });
    }
  }, {
    key: "__hideMenu",
    value: function __hideMenu() {
      this.viewer.panel.hide(_IDS.MENU);
    }
  }]);
  return MenuButton;
}(AbstractButton);
MenuButton.id = "menu";

// src/buttons/AbstractMoveButton.ts
function getIcon(value) {
  var angle2 = 0;
  switch (value) {
    case 0 /* UP */:
      angle2 = 90;
      break;
    case 1 /* DOWN */:
      angle2 = -90;
      break;
    case 3 /* RIGHT */:
      angle2 = 180;
      break;
    default:
      angle2 = 0;
      break;
  }
  return _ICONS.arrow.replace("rotate(0", "rotate(".concat(angle2));
}
var AbstractMoveButton = /*#__PURE__*/function (_AbstractButton6) {
  _inherits(AbstractMoveButton, _AbstractButton6);
  var _super42 = _createSuper(AbstractMoveButton);
  function AbstractMoveButton(navbar, direction) {
    var _this45;
    _classCallCheck(this, AbstractMoveButton);
    _this45 = _super42.call(this, navbar, {
      className: "psv-move-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: getIcon(direction)
    });
    _this45.direction = direction;
    _this45.handler = new _PressHandler();
    _this45.container.addEventListener("mousedown", _assertThisInitialized(_this45));
    _this45.container.addEventListener("keydown", _assertThisInitialized(_this45));
    _this45.container.addEventListener("keyup", _assertThisInitialized(_this45));
    _this45.viewer.container.addEventListener("mouseup", _assertThisInitialized(_this45));
    _this45.viewer.container.addEventListener("touchend", _assertThisInitialized(_this45));
    return _this45;
  }
  _createClass(AbstractMoveButton, [{
    key: "destroy",
    value: function destroy() {
      this.__onMouseUp();
      this.viewer.container.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchend", this);
      _get(_getPrototypeOf(AbstractMoveButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.__onMouseDown();
          break;
        case "mouseup":
          this.__onMouseUp();
          break;
        case "touchend":
          this.__onMouseUp();
          break;
        case "keydown":
          e.key === _KEY_CODES.Enter && this.__onMouseDown();
          break;
        case "keyup":
          e.key === _KEY_CODES.Enter && this.__onMouseUp();
          break;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return _invertResolvableBoolean(SYSTEM.isTouchEnabled);
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown() {
      if (!this.state.enabled) {
        return;
      }
      var dynamicRoll = {};
      switch (this.direction) {
        case 0 /* UP */:
          dynamicRoll.pitch = false;
          break;
        case 1 /* DOWN */:
          dynamicRoll.pitch = true;
          break;
        case 3 /* RIGHT */:
          dynamicRoll.yaw = false;
          break;
        default:
          dynamicRoll.yaw = true;
          break;
      }
      this.viewer.stopAll();
      this.viewer.dynamics.position.roll(dynamicRoll);
      this.handler.down();
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp() {
      var _this46 = this;
      if (!this.state.enabled) {
        return;
      }
      this.handler.up(function () {
        _this46.viewer.dynamics.position.stop();
        _this46.viewer.resetIdleTimer();
      });
    }
  }]);
  return AbstractMoveButton;
}(AbstractButton);
AbstractMoveButton.groupId = "move";

// src/buttons/MoveDownButton.ts
var MoveDownButton = /*#__PURE__*/function (_AbstractMoveButton) {
  _inherits(MoveDownButton, _AbstractMoveButton);
  var _super43 = _createSuper(MoveDownButton);
  function MoveDownButton(navbar) {
    _classCallCheck(this, MoveDownButton);
    return _super43.call(this, navbar, 1 /* DOWN */);
  }
  return _createClass(MoveDownButton);
}(AbstractMoveButton);
MoveDownButton.id = "moveDown";

// src/buttons/MoveLeftButton.ts
var MoveLeftButton = /*#__PURE__*/function (_AbstractMoveButton2) {
  _inherits(MoveLeftButton, _AbstractMoveButton2);
  var _super44 = _createSuper(MoveLeftButton);
  function MoveLeftButton(navbar) {
    _classCallCheck(this, MoveLeftButton);
    return _super44.call(this, navbar, 2 /* LEFT */);
  }
  return _createClass(MoveLeftButton);
}(AbstractMoveButton);
MoveLeftButton.id = "moveLeft";

// src/buttons/MoveRightButton.ts
var MoveRightButton = /*#__PURE__*/function (_AbstractMoveButton3) {
  _inherits(MoveRightButton, _AbstractMoveButton3);
  var _super45 = _createSuper(MoveRightButton);
  function MoveRightButton(navbar) {
    _classCallCheck(this, MoveRightButton);
    return _super45.call(this, navbar, 3 /* RIGHT */);
  }
  return _createClass(MoveRightButton);
}(AbstractMoveButton);
MoveRightButton.id = "moveRight";

// src/buttons/MoveUpButton.ts
var MoveUpButton = /*#__PURE__*/function (_AbstractMoveButton4) {
  _inherits(MoveUpButton, _AbstractMoveButton4);
  var _super46 = _createSuper(MoveUpButton);
  function MoveUpButton(navbar) {
    _classCallCheck(this, MoveUpButton);
    return _super46.call(this, navbar, 0 /* UP */);
  }
  return _createClass(MoveUpButton);
}(AbstractMoveButton);
MoveUpButton.id = "moveUp";

// src/buttons/AbstractZoomButton.ts
var AbstractZoomButton = /*#__PURE__*/function (_AbstractButton7) {
  _inherits(AbstractZoomButton, _AbstractButton7);
  var _super47 = _createSuper(AbstractZoomButton);
  function AbstractZoomButton(navbar, icon, direction) {
    var _this47;
    _classCallCheck(this, AbstractZoomButton);
    _this47 = _super47.call(this, navbar, {
      className: "psv-zoom-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: icon
    });
    _this47.direction = direction;
    _this47.handler = new _PressHandler();
    _this47.container.addEventListener("mousedown", _assertThisInitialized(_this47));
    _this47.container.addEventListener("keydown", _assertThisInitialized(_this47));
    _this47.container.addEventListener("keyup", _assertThisInitialized(_this47));
    _this47.viewer.container.addEventListener("mouseup", _assertThisInitialized(_this47));
    _this47.viewer.container.addEventListener("touchend", _assertThisInitialized(_this47));
    return _this47;
  }
  _createClass(AbstractZoomButton, [{
    key: "destroy",
    value: function destroy() {
      this.__onMouseUp();
      this.viewer.container.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchend", this);
      _get(_getPrototypeOf(AbstractZoomButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.__onMouseDown();
          break;
        case "mouseup":
          this.__onMouseUp();
          break;
        case "touchend":
          this.__onMouseUp();
          break;
        case "keydown":
          e.key === _KEY_CODES.Enter && this.__onMouseDown();
          break;
        case "keyup":
          e.key === _KEY_CODES.Enter && this.__onMouseUp();
          break;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return _invertResolvableBoolean(SYSTEM.isTouchEnabled);
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown() {
      if (!this.state.enabled) {
        return;
      }
      this.viewer.dynamics.zoom.roll(this.direction === 1 /* OUT */);
      this.handler.down();
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp() {
      var _this48 = this;
      if (!this.state.enabled) {
        return;
      }
      this.handler.up(function () {
        return _this48.viewer.dynamics.zoom.stop();
      });
    }
  }]);
  return AbstractZoomButton;
}(AbstractButton);
AbstractZoomButton.groupId = "zoom";

// src/buttons/ZoomInButton.ts
var ZoomInButton = /*#__PURE__*/function (_AbstractZoomButton) {
  _inherits(ZoomInButton, _AbstractZoomButton);
  var _super48 = _createSuper(ZoomInButton);
  function ZoomInButton(navbar) {
    _classCallCheck(this, ZoomInButton);
    return _super48.call(this, navbar, _ICONS.zoomIn, 0 /* IN */);
  }
  return _createClass(ZoomInButton);
}(AbstractZoomButton);
ZoomInButton.id = "zoomIn";

// src/buttons/ZoomOutButton.ts
var ZoomOutButton = /*#__PURE__*/function (_AbstractZoomButton2) {
  _inherits(ZoomOutButton, _AbstractZoomButton2);
  var _super49 = _createSuper(ZoomOutButton);
  function ZoomOutButton(navbar) {
    _classCallCheck(this, ZoomOutButton);
    return _super49.call(this, navbar, _ICONS.zoomOut, 1 /* OUT */);
  }
  return _createClass(ZoomOutButton);
}(AbstractZoomButton);
ZoomOutButton.id = "zoomOut";

// src/buttons/ZoomRangeButton.ts
var ZoomRangeButton = /*#__PURE__*/function (_AbstractButton8) {
  _inherits(ZoomRangeButton, _AbstractButton8);
  var _super50 = _createSuper(ZoomRangeButton);
  function ZoomRangeButton(navbar) {
    var _this49;
    _classCallCheck(this, ZoomRangeButton);
    _this49 = _super50.call(this, navbar, {
      className: "psv-zoom-range",
      hoverScale: false,
      collapsable: false,
      tabbable: false
    });
    _this49.zoomRange = document.createElement("div");
    _this49.zoomRange.className = "psv-zoom-range-line";
    _this49.container.appendChild(_this49.zoomRange);
    _this49.zoomValue = document.createElement("div");
    _this49.zoomValue.className = "psv-zoom-range-handle";
    _this49.zoomRange.appendChild(_this49.zoomValue);
    _this49.slider = new _Slider(_this49.container, "HORIZONTAL" /* HORIZONTAL */, function (data) {
      return _this49.__onSliderUpdate(data);
    });
    _this49.mediaMinWidth = parseInt(_getStyleProperty(_this49.container, "max-width"), 10);
    _this49.viewer.addEventListener(_ZoomUpdatedEvent2.type, _assertThisInitialized(_this49));
    if (_this49.viewer.state.ready) {
      _this49.__moveZoomValue(_this49.viewer.getZoomLevel());
    } else {
      _this49.viewer.addEventListener(_ReadyEvent2.type, _assertThisInitialized(_this49));
    }
    return _this49;
  }
  _createClass(ZoomRangeButton, [{
    key: "destroy",
    value: function destroy() {
      this.slider.destroy();
      this.viewer.removeEventListener(_ZoomUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_ReadyEvent2.type, this);
      _get(_getPrototypeOf(ZoomRangeButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ZoomUpdatedEvent2) {
        this.__moveZoomValue(e.zoomLevel);
      } else if (e instanceof _ReadyEvent2) {
        this.__moveZoomValue(this.viewer.getZoomLevel());
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return _invertResolvableBoolean(SYSTEM.isTouchEnabled);
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      if (this.state.supported) {
        if (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible) {
          this.hide(false);
        } else if (this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible) {
          this.show(false);
        }
      }
    }
  }, {
    key: "__moveZoomValue",
    value: function __moveZoomValue(level) {
      this.zoomValue.style.left = level / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
    }
  }, {
    key: "__onSliderUpdate",
    value: function __onSliderUpdate(data) {
      if (data.mousedown) {
        this.viewer.zoom(data.value * 100);
      }
    }
  }]);
  return ZoomRangeButton;
}(AbstractButton);
ZoomRangeButton.id = "zoomRange";
ZoomRangeButton.groupId = "zoom";

// src/plugins/AbstractPlugin.ts
var AbstractPlugin = /*#__PURE__*/function (_TypedEventTarget) {
  _inherits(AbstractPlugin, _TypedEventTarget);
  var _super51 = _createSuper(AbstractPlugin);
  function AbstractPlugin(viewer) {
    var _this50;
    _classCallCheck(this, AbstractPlugin);
    _this50 = _super51.call(this);
    _this50.viewer = viewer;
    return _this50;
  }
  /**
   * Initializes the plugin
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  _createClass(AbstractPlugin, [{
    key: "init",
    value: function init() {}
    /**
     * Destroys the plugin
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return AbstractPlugin;
}(TypedEventTarget);
var AbstractConfigurablePlugin = /*#__PURE__*/function (_AbstractPlugin) {
  _inherits(AbstractConfigurablePlugin, _AbstractPlugin);
  var _super52 = _createSuper(AbstractConfigurablePlugin);
  function AbstractConfigurablePlugin(viewer, config) {
    var _this51;
    _classCallCheck(this, AbstractConfigurablePlugin);
    _this51 = _super52.call(this, viewer);
    _this51.config = _this51.constructor.configParser(config);
    return _this51;
  }
  /**
   * Update options
   */
  _createClass(AbstractConfigurablePlugin, [{
    key: "setOption",
    value: function setOption(option, value) {
      this.setOptions(_defineProperty({}, option, value));
    }
    /**
     * Update options
     */
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var rawConfig = _objectSpread(_objectSpread({}, this.config), options);
      var ctor = this.constructor;
      var parser = ctor.configParser;
      var readonly = ctor.readonlyOptions;
      var id = ctor.id;
      for (var _i15 = 0, _Object$entries8 = Object.entries(options); _i15 < _Object$entries8.length; _i15++) {
        var _Object$entries8$_i = _slicedToArray(_Object$entries8[_i15], 2),
          key = _Object$entries8$_i[0],
          value = _Object$entries8$_i[1];
        if (!(key in parser.defaults)) {
          _logWarn("".concat(id, ": Unknown option \"").concat(key, "\""));
          continue;
        }
        if (readonly.includes(key)) {
          _logWarn("".concat(id, ": Option \"").concat(key, "\" cannot be updated"));
          continue;
        }
        if (key in parser.parsers) {
          value = parser.parsers[key](value, {
            rawConfig: rawConfig,
            defValue: parser.defaults[key]
          });
        }
        this.config[key] = value;
      }
    }
  }]);
  return AbstractConfigurablePlugin;
}(AbstractPlugin);
AbstractConfigurablePlugin.readonlyOptions = [];
function pluginInterop(plugin) {
  if (plugin) {
    for (var _i16 = 0, _arr3 = [["_", plugin]].concat(_toConsumableArray(Object.entries(plugin))); _i16 < _arr3.length; _i16++) {
      var _arr3$_i = _slicedToArray(_arr3[_i16], 2),
        p = _arr3$_i[1];
      if (p.prototype instanceof AbstractPlugin) {
        _checkVersion(p.id, p.VERSION, "5.6.0");
        return p;
      }
    }
  }
  return null;
}

// src/data/config.ts
var DEFAULTS = {
  panorama: null,
  container: null,
  adapter: [EquirectangularAdapter, null],
  plugins: [],
  caption: null,
  description: null,
  downloadUrl: null,
  downloadName: null,
  loadingImg: null,
  loadingTxt: "Loading...",
  size: null,
  fisheye: 0,
  minFov: 30,
  maxFov: 90,
  defaultZoomLvl: 50,
  defaultYaw: 0,
  defaultPitch: 0,
  sphereCorrection: null,
  moveSpeed: 1,
  zoomSpeed: 1,
  moveInertia: true,
  mousewheel: true,
  mousemove: true,
  mousewheelCtrlKey: false,
  touchmoveTwoFingers: false,
  panoData: null,
  requestHeaders: null,
  rendererParameters: {
    alpha: true,
    antialias: true
  },
  withCredentials: false,
  // prettier-ignore
  navbar: ["zoom", "move", "download", "description", "caption", "fullscreen"],
  lang: {
    zoom: "Zoom",
    zoomOut: "Zoom out",
    zoomIn: "Zoom in",
    moveUp: "Move up",
    moveDown: "Move down",
    moveLeft: "Move left",
    moveRight: "Move right",
    download: "Download",
    fullscreen: "Fullscreen",
    menu: "Menu",
    close: "Close",
    twoFingers: "Use two fingers to navigate",
    ctrlZoom: "Use ctrl + scroll to zoom the image",
    loadError: "The panorama can't be loaded"
  },
  keyboard: "fullscreen",
  keyboardActions: (_keyboardActions = {}, _defineProperty(_keyboardActions, _KEY_CODES.ArrowUp, "ROTATE_UP"), _defineProperty(_keyboardActions, _KEY_CODES.ArrowDown, "ROTATE_DOWN"), _defineProperty(_keyboardActions, _KEY_CODES.ArrowRight, "ROTATE_RIGHT"), _defineProperty(_keyboardActions, _KEY_CODES.ArrowLeft, "ROTATE_LEFT"), _defineProperty(_keyboardActions, _KEY_CODES.PageUp, "ZOOM_IN"), _defineProperty(_keyboardActions, _KEY_CODES.PageDown, "ZOOM_OUT"), _defineProperty(_keyboardActions, _KEY_CODES.Plus, "ZOOM_IN"), _defineProperty(_keyboardActions, _KEY_CODES.Minus, "ZOOM_OUT"), _keyboardActions)
};
var READONLY_OPTIONS = {
  panorama: "Use setPanorama method to change the panorama",
  panoData: "Use setPanorama method to change the panorama",
  container: "Cannot change viewer container",
  adapter: "Cannot change adapter",
  plugins: "Cannot change plugins"
};
var CONFIG_PARSERS = {
  container: function container(_container) {
    if (!_container) {
      throw new PSVError("No value given for container.");
    }
    return _container;
  },
  adapter: function adapter(_adapter, _ref10) {
    var defValue = _ref10.defValue;
    if (!_adapter) {
      _adapter = defValue;
    } else if (Array.isArray(_adapter)) {
      _adapter = [adapterInterop(_adapter[0]), _adapter[1]];
    } else {
      _adapter = [adapterInterop(_adapter), null];
    }
    if (!_adapter[0]) {
      throw new PSVError("An undefined value was given for adapter.");
    }
    if (!_adapter[0].id) {
      throw new PSVError("Adapter has no id.");
    }
    return _adapter;
  },
  defaultYaw: function defaultYaw(_defaultYaw) {
    return _parseAngle(_defaultYaw);
  },
  defaultPitch: function defaultPitch(_defaultPitch) {
    return _parseAngle(_defaultPitch, true);
  },
  defaultZoomLvl: function defaultZoomLvl(_defaultZoomLvl) {
    return MathUtils.clamp(_defaultZoomLvl, 0, 100);
  },
  minFov: function minFov(_minFov, _ref11) {
    var rawConfig = _ref11.rawConfig;
    if (rawConfig.maxFov < _minFov) {
      _logWarn("maxFov cannot be lower than minFov");
      _minFov = rawConfig.maxFov;
    }
    return MathUtils.clamp(_minFov, 1, 179);
  },
  maxFov: function maxFov(_maxFov, _ref12) {
    var rawConfig = _ref12.rawConfig;
    if (_maxFov < rawConfig.minFov) {
      _maxFov = rawConfig.minFov;
    }
    return MathUtils.clamp(_maxFov, 1, 179);
  },
  lang: function lang(_lang) {
    if (Array.isArray(_lang.twoFingers)) {
      _logWarn("lang.twoFingers must not be an array");
      _lang.twoFingers = _lang.twoFingers[0];
    }
    return _objectSpread(_objectSpread({}, DEFAULTS.lang), _lang);
  },
  keyboard: function keyboard(_keyboard) {
    if (!_keyboard) {
      return false;
    }
    if (_typeof(_keyboard) === "object") {
      _logWarn("Use keyboardActions to configure the keyboard actions, keyboard option must be either true, false, 'fullscreen' or 'always'");
      return "fullscreen";
    }
    return _keyboard === "always" ? "always" : "fullscreen";
  },
  keyboardActions: function keyboardActions(_keyboardActions2, _ref13) {
    var rawConfig = _ref13.rawConfig;
    if (rawConfig.keyboard && _typeof(rawConfig.keyboard) === "object") {
      return rawConfig.keyboard;
    }
    return _keyboardActions2;
  },
  fisheye: function fisheye(_fisheye) {
    if (_fisheye === true) {
      return 1;
    } else if (_fisheye === false) {
      return 0;
    }
    return _fisheye;
  },
  requestHeaders: function requestHeaders(_requestHeaders) {
    if (_requestHeaders && _typeof(_requestHeaders) === "object") {
      return function () {
        return _requestHeaders;
      };
    }
    if (typeof _requestHeaders === "function") {
      return _requestHeaders;
    }
    return null;
  },
  rendererParameters: function rendererParameters(_rendererParameters, _ref14) {
    var defValue = _ref14.defValue;
    return _objectSpread(_objectSpread({}, _rendererParameters), defValue);
  },
  plugins: function plugins(_plugins) {
    return _plugins.map(function (plugin, i) {
      if (Array.isArray(plugin)) {
        plugin = [pluginInterop(plugin[0]), plugin[1]];
      } else {
        plugin = [pluginInterop(plugin), null];
      }
      if (!plugin[0]) {
        throw new PSVError("An undefined value was given for plugin ".concat(i, "."));
      }
      if (!plugin[0].id) {
        throw new PSVError("Plugin ".concat(i, " has no id."));
      }
      return plugin;
    });
  },
  navbar: function navbar(_navbar) {
    if (_navbar === false) {
      return null;
    }
    if (_navbar === true) {
      return _clone(DEFAULTS.navbar);
    }
    if (typeof _navbar === "string") {
      return _navbar.split(/[ ,]/);
    }
    return _navbar;
  }
};
var getViewerConfig = _getConfigParser(DEFAULTS, CONFIG_PARSERS);

// src/components/NavbarCaption.ts
var NavbarCaption = /*#__PURE__*/function (_AbstractButton9) {
  _inherits(NavbarCaption, _AbstractButton9);
  var _super53 = _createSuper(NavbarCaption);
  function NavbarCaption(navbar) {
    var _this52;
    _classCallCheck(this, NavbarCaption);
    _this52 = _super53.call(this, navbar, {
      className: "psv-caption",
      hoverScale: false,
      collapsable: false,
      tabbable: true
    });
    _this52.contentWidth = 0;
    _this52.state.width = 0;
    _this52.contentElt = document.createElement("div");
    _this52.contentElt.className = "psv-caption-content";
    _this52.container.appendChild(_this52.contentElt);
    _this52.setCaption(_this52.viewer.config.caption);
    return _this52;
  }
  _createClass(NavbarCaption, [{
    key: "hide",
    value: function hide() {
      this.contentElt.style.display = "none";
      this.state.visible = false;
    }
  }, {
    key: "show",
    value: function show() {
      this.contentElt.style.display = "";
      this.state.visible = true;
    }
  }, {
    key: "onClick",
    value: function onClick() {}
    /**
     * Changes the caption
     */
  }, {
    key: "setCaption",
    value: function setCaption(html) {
      this.show();
      this.contentElt.innerHTML = html !== null && html !== void 0 ? html : "";
      if (this.contentElt.innerHTML) {
        this.contentWidth = this.contentElt.offsetWidth;
      } else {
        this.contentWidth = 0;
      }
      this.autoSize();
    }
    /**
     * Toggles content and icon depending on available space
     */
  }, {
    key: "autoSize",
    value: function autoSize() {
      this.toggle(this.container.offsetWidth >= this.contentWidth);
      this.__refreshButton();
    }
  }, {
    key: "__refreshButton",
    value: function __refreshButton() {
      var _this$viewer$navbar$g;
      (_this$viewer$navbar$g = this.viewer.navbar.getButton(DescriptionButton.id, false)) === null || _this$viewer$navbar$g === void 0 ? void 0 : _this$viewer$navbar$g.autoSize(true);
    }
  }]);
  return NavbarCaption;
}(AbstractButton);
NavbarCaption.id = "caption";

// src/components/Navbar.ts
var AVAILABLE_BUTTONS = {};
var AVAILABLE_GROUPS = {};
function registerButton(button, defaultPosition) {
  if (!button.id) {
    throw new PSVError("Button id is required");
  }
  AVAILABLE_BUTTONS[button.id] = button;
  if (button.groupId) {
    (AVAILABLE_GROUPS[button.groupId] = AVAILABLE_GROUPS[button.groupId] || []).push(button);
  }
  if (defaultPosition) {
    var navbar = DEFAULTS.navbar;
    switch (defaultPosition) {
      case "start":
        navbar.unshift(button.id);
        break;
      case "end":
        navbar.push(button.id);
        break;
      default:
        {
          var _defaultPosition$spli = defaultPosition.split(":"),
            _defaultPosition$spli2 = _slicedToArray(_defaultPosition$spli, 2),
            id = _defaultPosition$spli2[0],
            pos = _defaultPosition$spli2[1];
          var idx = navbar.indexOf(id);
          if (!id || !pos || idx === -1) {
            throw new PSVError("Invalid defaultPosition ".concat(defaultPosition));
          }
          navbar.splice(idx + (pos === "right" ? 1 : 0), 0, button.id);
        }
    }
  }
}
[ZoomOutButton, ZoomRangeButton, ZoomInButton, DescriptionButton, NavbarCaption, DownloadButton, FullscreenButton, MoveLeftButton, MoveRightButton, MoveUpButton, MoveDownButton].forEach(function (btn) {
  return registerButton(btn);
});
var Navbar = /*#__PURE__*/function (_AbstractComponent3) {
  _inherits(Navbar, _AbstractComponent3);
  var _super54 = _createSuper(Navbar);
  /**
   * @internal
   */
  function Navbar(viewer) {
    var _this53;
    _classCallCheck(this, Navbar);
    _this53 = _super54.call(this, viewer, {
      className: "psv-navbar ".concat(_CAPTURE_EVENTS_CLASS)
    });
    /**
     * @internal
     */
    _this53.collapsed = [];
    _this53.state.visible = false;
    return _this53;
  }
  /**
   * Shows the navbar
   */
  _createClass(Navbar, [{
    key: "show",
    value: function show() {
      this.viewer.container.classList.add("psv--has-navbar");
      this.container.classList.add("psv-navbar--open");
      this.state.visible = true;
    }
    /**
     * Hides the navbar
     */
  }, {
    key: "hide",
    value: function hide() {
      this.viewer.container.classList.remove("psv--has-navbar");
      this.container.classList.remove("psv-navbar--open");
      this.state.visible = false;
    }
    /**
     * Change the buttons visible on the navbar
     */
  }, {
    key: "setButtons",
    value: function setButtons(buttons) {
      var _this54 = this;
      this.children.slice().forEach(function (item) {
        return item.destroy();
      });
      this.children.length = 0;
      if (buttons.indexOf(NavbarCaption.id) !== -1 && buttons.indexOf(DescriptionButton.id) === -1) {
        buttons.splice(buttons.indexOf(NavbarCaption.id), 0, DescriptionButton.id);
      }
      buttons.forEach(function (button) {
        if (_typeof(button) === "object") {
          new CustomButton(_this54, button);
        } else if (AVAILABLE_BUTTONS[button]) {
          new AVAILABLE_BUTTONS[button](_this54);
        } else if (AVAILABLE_GROUPS[button]) {
          AVAILABLE_GROUPS[button].forEach(function (buttonCtor) {
            new buttonCtor(_this54);
          });
        } else {
          _logWarn("Unknown button ".concat(button));
        }
      });
      new MenuButton(this);
      this.children.forEach(function (item) {
        if (item instanceof AbstractButton) {
          item.checkSupported();
        }
      });
      this.autoSize();
    }
    /**
     * Changes the navbar caption
     */
  }, {
    key: "setCaption",
    value: function setCaption(html) {
      this.children.some(function (item) {
        if (item instanceof NavbarCaption) {
          item.setCaption(html);
          return true;
        } else {
          return false;
        }
      });
    }
    /**
     * Returns a button by its identifier
     */
  }, {
    key: "getButton",
    value: function getButton(id) {
      var warnNotFound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var button = this.children.find(function (item) {
        return item instanceof AbstractButton && item.id === id;
      });
      if (!button && warnNotFound) {
        _logWarn("button \"".concat(id, "\" not found in the navbar"));
      }
      return button;
    }
    /**
     * Automatically collapses buttons
     * @internal
     */
  }, {
    key: "autoSize",
    value: function autoSize() {
      var _this$getButton;
      this.children.forEach(function (child) {
        if (child instanceof AbstractButton) {
          child.autoSize();
        }
      });
      var availableWidth = this.container.offsetWidth;
      var totalWidth = 0;
      var collapsableButtons = [];
      this.children.forEach(function (item) {
        if (item.isVisible() && item instanceof AbstractButton) {
          totalWidth += item.width;
          if (item.collapsable) {
            collapsableButtons.push(item);
          }
        }
      });
      if (totalWidth === 0) {
        return;
      }
      if (availableWidth < totalWidth && collapsableButtons.length > 0) {
        collapsableButtons.forEach(function (item) {
          return item.collapse();
        });
        this.collapsed = collapsableButtons;
        this.getButton(MenuButton.id).show(false);
      } else if (availableWidth >= totalWidth && this.collapsed.length > 0) {
        this.collapsed.forEach(function (item) {
          return item.uncollapse();
        });
        this.collapsed = [];
        this.getButton(MenuButton.id).hide(false);
      }
      (_this$getButton = this.getButton(NavbarCaption.id, false)) === null || _this$getButton === void 0 ? void 0 : _this$getButton.autoSize();
    }
  }]);
  return Navbar;
}(AbstractComponent);

// src/components/Loader.ts
var Loader = /*#__PURE__*/function (_AbstractComponent4) {
  _inherits(Loader, _AbstractComponent4);
  var _super55 = _createSuper(Loader);
  /**
   * @internal
   */
  function Loader(viewer) {
    var _this55;
    _classCallCheck(this, Loader);
    _this55 = _super55.call(this, viewer, {
      className: "psv-loader-container"
    });
    _this55.loader = document.createElement("div");
    _this55.loader.className = "psv-loader";
    _this55.container.appendChild(_this55.loader);
    _this55.size = _this55.loader.offsetWidth;
    _this55.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    _this55.canvas.setAttribute("class", "psv-loader-canvas");
    _this55.canvas.setAttribute("viewBox", "0 0 ".concat(_this55.size, " ").concat(_this55.size));
    _this55.loader.appendChild(_this55.canvas);
    _this55.textColor = _getStyleProperty(_this55.loader, "color");
    _this55.color = _getStyleProperty(_this55.canvas, "color");
    _this55.border = parseInt(_getStyleProperty(_this55.loader, "--psv-loader-border"), 10);
    _this55.thickness = parseInt(_getStyleProperty(_this55.loader, "--psv-loader-tickness"), 10);
    _this55.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this55));
    _this55.__updateContent();
    _this55.hide();
    return _this55;
  }
  /**
   * @internal
   */
  _createClass(Loader, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);
      _get(_getPrototypeOf(Loader.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ConfigChangedEvent2) {
        e.containsOptions("loadingImg", "loadingTxt") && this.__updateContent();
      }
    }
    /**
     * Sets the loader progression
     */
  }, {
    key: "setProgress",
    value: function setProgress(value) {
      var angle2 = Math.min(value, 99.999) / 100 * Math.PI * 2;
      var halfSize = this.size / 2;
      var startX = halfSize;
      var startY = this.thickness / 2 + this.border;
      var radius = (this.size - this.thickness) / 2 - this.border;
      var endX = Math.sin(angle2) * radius + halfSize;
      var endY = -Math.cos(angle2) * radius + halfSize;
      var largeArc = value > 50 ? "1" : "0";
      this.canvas.innerHTML = "\n            <circle cx=\"".concat(halfSize, "\" cy=\"").concat(halfSize, "\" r=\"").concat(halfSize, "\" fill=\"").concat(this.color, "\"/>\n            <path d=\"M ").concat(startX, " ").concat(startY, " A ").concat(radius, " ").concat(radius, " 0 ").concat(largeArc, " 1 ").concat(endX, " ").concat(endY, "\" \n                  fill=\"none\" stroke=\"").concat(this.textColor, "\" stroke-width=\"").concat(this.thickness, "\" stroke-linecap=\"round\"/>\n        ");
      this.viewer.dispatchEvent(new _LoadProgressEvent2(Math.round(value)));
    }
  }, {
    key: "__updateContent",
    value: function __updateContent() {
      var current = this.loader.querySelector(".psv-loader-image, .psv-loader-text");
      if (current) {
        this.loader.removeChild(current);
      }
      var inner;
      if (this.viewer.config.loadingImg) {
        inner = document.createElement("img");
        inner.className = "psv-loader-image";
        inner.src = this.viewer.config.loadingImg;
      } else if (this.viewer.config.loadingTxt) {
        inner = document.createElement("div");
        inner.className = "psv-loader-text";
        inner.innerHTML = this.viewer.config.loadingTxt;
      }
      if (inner) {
        var size = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
        inner.style.maxWidth = size + "px";
        inner.style.maxHeight = size + "px";
        this.loader.appendChild(inner);
      }
    }
  }]);
  return Loader;
}(AbstractComponent);

// src/components/Notification.ts
var Notification = /*#__PURE__*/function (_AbstractComponent5) {
  _inherits(Notification, _AbstractComponent5);
  var _super56 = _createSuper(Notification);
  /**
   * @internal
   */
  function Notification(viewer) {
    var _this56;
    _classCallCheck(this, Notification);
    _this56 = _super56.call(this, viewer, {
      className: "psv-notification"
    });
    /**
     * @internal
     */
    _this56.state = {
      visible: false,
      contentId: null,
      timeout: null
    };
    _this56.content = document.createElement("div");
    _this56.content.className = "psv-notification-content";
    _this56.container.appendChild(_this56.content);
    _this56.content.addEventListener("click", function () {
      return _this56.hide();
    });
    return _this56;
  }
  /**
   * Checks if the notification is visible
   */
  _createClass(Notification, [{
    key: "isVisible",
    value: function isVisible(id) {
      return this.state.visible && (!id || !this.state.contentId || this.state.contentId === id);
    }
    /**
     * @throws {@link PSVError} always
     * @internal
     */
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Notification cannot be toggled");
    }
    /**
     * Displays a notification on the viewer
     *
     * @example
     * viewer.showNotification({ content: 'Hello world', timeout: 5000 })
     * @example
     * viewer.showNotification('Hello world')
     */
  }, {
    key: "show",
    value: function show(config) {
      var _this57 = this;
      if (this.state.timeout) {
        clearTimeout(this.state.timeout);
        this.state.timeout = null;
      }
      if (typeof config === "string") {
        config = {
          content: config
        };
      }
      this.state.contentId = config.id || null;
      this.content.innerHTML = config.content;
      this.container.classList.add("psv-notification--visible");
      this.state.visible = true;
      this.viewer.dispatchEvent(new _ShowNotificationEvent2(config.id));
      if (config.timeout) {
        this.state.timeout = setTimeout(function () {
          return _this57.hide(_this57.state.contentId);
        }, config.timeout);
      }
    }
    /**
     * Hides the notification
     */
  }, {
    key: "hide",
    value: function hide(id) {
      if (this.isVisible(id)) {
        var contentId = this.state.contentId;
        this.container.classList.remove("psv-notification--visible");
        this.state.visible = false;
        this.state.contentId = null;
        this.viewer.dispatchEvent(new _HideNotificationEvent2(contentId));
      }
    }
  }]);
  return Notification;
}(AbstractComponent);

// src/components/Overlay.ts
var Overlay = /*#__PURE__*/function (_AbstractComponent6) {
  _inherits(Overlay, _AbstractComponent6);
  var _super57 = _createSuper(Overlay);
  /**
   * @internal
   */
  function Overlay(viewer) {
    var _thisSuper2, _this58;
    _classCallCheck(this, Overlay);
    _this58 = _super57.call(this, viewer, {
      className: "psv-overlay ".concat(_CAPTURE_EVENTS_CLASS)
    });
    /**
     * @internal
     */
    _this58.state = {
      visible: false,
      contentId: null,
      dissmisable: true
    };
    _this58.image = document.createElement("div");
    _this58.image.className = "psv-overlay-image";
    _this58.container.appendChild(_this58.image);
    _this58.title = document.createElement("div");
    _this58.title.className = "psv-overlay-title";
    _this58.container.appendChild(_this58.title);
    _this58.text = document.createElement("div");
    _this58.text.className = "psv-overlay-text";
    _this58.container.appendChild(_this58.text);
    _this58.container.addEventListener("click", _assertThisInitialized(_this58));
    _this58.viewer.addEventListener(_KeypressEvent2.type, _assertThisInitialized(_this58));
    _get((_thisSuper2 = _assertThisInitialized(_this58), _getPrototypeOf(Overlay.prototype)), "hide", _thisSuper2).call(_thisSuper2);
    return _this58;
  }
  /**
   * @internal
   */
  _createClass(Overlay, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_KeypressEvent2.type, this);
      _get(_getPrototypeOf(Overlay.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e.type === "click") {
        if (this.isVisible() && this.state.dissmisable) {
          this.hide();
          e.stopPropagation();
        }
      } else if (e instanceof _KeypressEvent2) {
        if (this.isVisible() && this.state.dissmisable && e.key === _KEY_CODES.Escape) {
          this.hide();
          e.preventDefault();
        }
      }
    }
    /**
     * Checks if the overlay is visible
     */
  }, {
    key: "isVisible",
    value: function isVisible(id) {
      return this.state.visible && (!id || !this.state.contentId || this.state.contentId === id);
    }
    /**
     * @throws {@link PSVError} always
     * @internal
     */
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Overlay cannot be toggled");
    }
    /**
     * Displays an overlay on the viewer
     */
  }, {
    key: "show",
    value: function show(config) {
      if (typeof config === "string") {
        config = {
          title: config
        };
      }
      this.state.contentId = config.id || null;
      this.state.dissmisable = config.dissmisable !== false;
      this.image.innerHTML = config.image || "";
      this.title.innerHTML = config.title || "";
      this.text.innerHTML = config.text || "";
      _get(_getPrototypeOf(Overlay.prototype), "show", this).call(this);
      this.viewer.dispatchEvent(new _ShowOverlayEvent2(config.id));
    }
    /**
     * Hides the overlay
     */
  }, {
    key: "hide",
    value: function hide(id) {
      if (this.isVisible(id)) {
        var contentId = this.state.contentId;
        _get(_getPrototypeOf(Overlay.prototype), "hide", this).call(this);
        this.state.contentId = null;
        this.viewer.dispatchEvent(new _HideOverlayEvent2(contentId));
      }
    }
  }]);
  return Overlay;
}(AbstractComponent);

// src/components/Panel.ts
var PANEL_MIN_WIDTH = 200;
var PANEL_CLASS_NO_INTERACTION = "psv-panel-content--no-interaction";
var Panel = /*#__PURE__*/function (_AbstractComponent7) {
  _inherits(Panel, _AbstractComponent7);
  var _super58 = _createSuper(Panel);
  /**
   * @internal
   */
  function Panel(viewer) {
    var _this59;
    _classCallCheck(this, Panel);
    _this59 = _super58.call(this, viewer, {
      className: "psv-panel ".concat(_CAPTURE_EVENTS_CLASS)
    });
    /**
     * @internal
     */
    _this59.state = {
      visible: false,
      contentId: null,
      mouseX: 0,
      mouseY: 0,
      mousedown: false,
      clickHandler: null,
      keyHandler: null,
      width: {}
    };
    var resizer = document.createElement("div");
    resizer.className = "psv-panel-resizer";
    _this59.container.appendChild(resizer);
    var closeBtn = document.createElement("div");
    closeBtn.className = "psv-panel-close-button";
    closeBtn.innerHTML = _ICONS.close;
    closeBtn.title = viewer.config.lang.close;
    _this59.container.appendChild(closeBtn);
    _this59.content = document.createElement("div");
    _this59.content.className = "psv-panel-content";
    _this59.container.appendChild(_this59.content);
    _this59.container.addEventListener("wheel", function (e) {
      return e.stopPropagation();
    });
    closeBtn.addEventListener("click", function () {
      return _this59.hide();
    });
    resizer.addEventListener("mousedown", _assertThisInitialized(_this59));
    resizer.addEventListener("touchstart", _assertThisInitialized(_this59));
    _this59.viewer.container.addEventListener("mouseup", _assertThisInitialized(_this59));
    _this59.viewer.container.addEventListener("touchend", _assertThisInitialized(_this59));
    _this59.viewer.container.addEventListener("mousemove", _assertThisInitialized(_this59));
    _this59.viewer.container.addEventListener("touchmove", _assertThisInitialized(_this59));
    _this59.viewer.addEventListener(_KeypressEvent2.type, _assertThisInitialized(_this59));
    return _this59;
  }
  /**
   * @internal
   */
  _createClass(Panel, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_KeypressEvent2.type, this);
      this.viewer.container.removeEventListener("mousemove", this);
      this.viewer.container.removeEventListener("touchmove", this);
      this.viewer.container.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchend", this);
      _get(_getPrototypeOf(Panel.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.__onMouseDown(e);
          break;
        case "touchstart":
          this.__onTouchStart(e);
          break;
        case "mousemove":
          this.__onMouseMove(e);
          break;
        case "touchmove":
          this.__onTouchMove(e);
          break;
        case "mouseup":
          this.__onMouseUp(e);
          break;
        case "touchend":
          this.__onTouchEnd(e);
          break;
        case _KeypressEvent2.type:
          this.__onKeyPress(e);
          break;
      }
    }
    /**
     * Checks if the panel is visible
     */
  }, {
    key: "isVisible",
    value: function isVisible(id) {
      return this.state.visible && (!id || !this.state.contentId || this.state.contentId === id);
    }
    /**
     * @throws {@link PSVError} always
     * @internal
     */
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Panel cannot be toggled");
    }
    /**
     * Shows the panel
     */
  }, {
    key: "show",
    value: function show(config) {
      var _this60 = this;
      if (typeof config === "string") {
        config = {
          content: config
        };
      }
      var wasVisible = this.isVisible(config.id);
      this.state.contentId = config.id || null;
      this.state.visible = true;
      if (this.state.clickHandler) {
        this.content.removeEventListener("click", this.state.clickHandler);
        this.content.removeEventListener("keydown", this.state.keyHandler);
        this.state.clickHandler = null;
        this.state.keyHandler = null;
      }
      if (config.id && this.state.width[config.id]) {
        this.container.style.width = this.state.width[config.id];
      } else if (config.width) {
        this.container.style.width = config.width;
      } else {
        this.container.style.width = null;
      }
      this.content.innerHTML = config.content;
      this.content.scrollTop = 0;
      this.container.classList.add("psv-panel--open");
      _toggleClass(this.content, "psv-panel-content--no-margin", config.noMargin === true);
      if (config.clickHandler) {
        this.state.clickHandler = function (e) {
          config.clickHandler(e.target);
        };
        this.state.keyHandler = function (e) {
          if (e.key === _KEY_CODES.Enter) {
            config.clickHandler(e.target);
          }
        };
        this.content.addEventListener("click", this.state.clickHandler);
        this.content.addEventListener("keydown", this.state.keyHandler);
        if (!wasVisible) {
          setTimeout(function () {
            var _this60$content$query;
            (_this60$content$query = _this60.content.querySelector("a,button,[tabindex]")) === null || _this60$content$query === void 0 ? void 0 : _this60$content$query.focus();
          }, 300);
        }
      }
      this.viewer.dispatchEvent(new _ShowPanelEvent2(config.id));
    }
    /**
     * Hides the panel
     */
  }, {
    key: "hide",
    value: function hide(id) {
      if (this.isVisible(id)) {
        var contentId = this.state.contentId;
        this.state.visible = false;
        this.state.contentId = null;
        this.content.innerHTML = null;
        this.container.classList.remove("psv-panel--open");
        if (this.state.clickHandler) {
          this.content.removeEventListener("click", this.state.clickHandler);
          this.state.clickHandler = null;
        }
        this.viewer.dispatchEvent(new _HidePanelEvent2(contentId));
      }
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown(evt) {
      evt.stopPropagation();
      this.__startResize(evt.clientX, evt.clientY);
    }
  }, {
    key: "__onTouchStart",
    value: function __onTouchStart(evt) {
      evt.stopPropagation();
      if (evt.touches.length === 1) {
        var touch = evt.touches[0];
        this.__startResize(touch.clientX, touch.clientY);
      }
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp(evt) {
      if (this.state.mousedown) {
        evt.stopPropagation();
        this.state.mousedown = false;
        this.content.classList.remove(PANEL_CLASS_NO_INTERACTION);
      }
    }
  }, {
    key: "__onTouchEnd",
    value: function __onTouchEnd(evt) {
      if (this.state.mousedown) {
        evt.stopPropagation();
        if (evt.touches.length === 0) {
          this.state.mousedown = false;
          this.content.classList.remove(PANEL_CLASS_NO_INTERACTION);
        }
      }
    }
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(evt) {
      if (this.state.mousedown) {
        evt.stopPropagation();
        this.__resize(evt.clientX, evt.clientY);
      }
    }
  }, {
    key: "__onTouchMove",
    value: function __onTouchMove(evt) {
      if (this.state.mousedown) {
        var touch = evt.touches[0];
        this.__resize(touch.clientX, touch.clientY);
      }
    }
  }, {
    key: "__onKeyPress",
    value: function __onKeyPress(evt) {
      if (this.isVisible() && evt.key === _KEY_CODES.Escape) {
        this.hide();
        evt.preventDefault();
      }
    }
  }, {
    key: "__startResize",
    value: function __startResize(clientX, clientY) {
      this.state.mouseX = clientX;
      this.state.mouseY = clientY;
      this.state.mousedown = true;
      this.content.classList.add(PANEL_CLASS_NO_INTERACTION);
    }
  }, {
    key: "__resize",
    value: function __resize(clientX, clientY) {
      var x = clientX;
      var y = clientY;
      var width = Math.max(PANEL_MIN_WIDTH, this.container.offsetWidth - (x - this.state.mouseX)) + "px";
      if (this.state.contentId) {
        this.state.width[this.state.contentId] = width;
      }
      this.container.style.width = width;
      this.state.mouseX = x;
      this.state.mouseY = y;
    }
  }]);
  return Panel;
}(AbstractComponent);

// src/components/Tooltip.ts
var Tooltip = /*#__PURE__*/function (_AbstractComponent8) {
  _inherits(Tooltip, _AbstractComponent8);
  var _super59 = _createSuper(Tooltip);
  /**
   * @internal
   */
  function Tooltip(viewer, config) {
    var _this61;
    _classCallCheck(this, Tooltip);
    _this61 = _super59.call(this, viewer, {
      className: "psv-tooltip"
    });
    /**
     * @internal
     */
    _this61.state = {
      visible: true,
      arrow: 0,
      border: 0,
      state: 0 /* NONE */,
      width: 0,
      height: 0,
      pos: "",
      config: null,
      data: null
    };
    _this61.content = document.createElement("div");
    _this61.content.className = "psv-tooltip-content";
    _this61.container.appendChild(_this61.content);
    _this61.arrow = document.createElement("div");
    _this61.arrow.className = "psv-tooltip-arrow";
    _this61.container.appendChild(_this61.arrow);
    _this61.container.addEventListener("transitionend", _assertThisInitialized(_this61));
    _this61.container.addEventListener("touchdown", function (e) {
      return e.stopPropagation();
    });
    _this61.container.addEventListener("mousedown", function (e) {
      return e.stopPropagation();
    });
    _this61.container.style.top = "-1000px";
    _this61.container.style.left = "-1000px";
    _this61.show(config);
    return _this61;
  }
  /**
   * @internal
   */
  _createClass(Tooltip, [{
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e.type === "transitionend") {
        this.__onTransitionEnd(e);
      }
    }
    /**
     * @internal
     */
  }, {
    key: "destroy",
    value: function destroy() {
      delete this.state.data;
      _get(_getPrototypeOf(Tooltip.prototype), "destroy", this).call(this);
    }
    /**
     * @throws {@link PSVError} always
     * @internal
     */
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Tooltip cannot be toggled");
    }
    /**
     * Displays the tooltip on the viewer
     * @internal
     */
  }, {
    key: "show",
    value: function show(config) {
      if (this.state.state !== 0 /* NONE */) {
        throw new PSVError("Initialized tooltip cannot be re-initialized");
      }
      if (config.className) {
        _addClasses(this.container, config.className);
      }
      if (config.style) {
        Object.assign(this.container.style, config.style);
      }
      this.state.state = 3 /* READY */;
      this.update(config.content, config);
      this.state.data = config.data;
      this.state.state = 1 /* SHOWING */;
      this.viewer.dispatchEvent(new _ShowTooltipEvent2(this, this.state.data));
      this.__waitImages();
    }
    /**
     * Updates the content of the tooltip, optionally with a new position
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "update",
    value: function update(content, config) {
      this.content.innerHTML = content;
      var rect = this.container.getBoundingClientRect();
      this.state.width = rect.right - rect.left;
      this.state.height = rect.bottom - rect.top;
      this.state.arrow = parseInt(_getStyleProperty(this.arrow, "border-top-width"), 10);
      this.state.border = parseInt(_getStyleProperty(this.container, "border-top-left-radius"), 10);
      this.move(config !== null && config !== void 0 ? config : this.state.config);
      this.__waitImages();
    }
    /**
     * Moves the tooltip to a new position
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "move",
    value: function move(config) {
      var _ref15, _config$box, _this$state$config;
      if (this.state.state !== 1 /* SHOWING */ && this.state.state !== 3 /* READY */) {
        throw new PSVError("Uninitialized tooltip cannot be moved");
      }
      config.box = (_ref15 = (_config$box = config.box) !== null && _config$box !== void 0 ? _config$box : (_this$state$config = this.state.config) === null || _this$state$config === void 0 ? void 0 : _this$state$config.box) !== null && _ref15 !== void 0 ? _ref15 : {
        width: 0,
        height: 0
      };
      this.state.config = config;
      var t = this.container;
      var a = this.arrow;
      var style = {
        posClass: _cleanCssPosition(config.position, {
          allowCenter: false,
          cssOrder: false
        }) || ["top", "center"],
        width: this.state.width,
        height: this.state.height,
        top: 0,
        left: 0,
        arrowTop: 0,
        arrowLeft: 0
      };
      this.__computeTooltipPosition(style, config);
      var swapY = null;
      var swapX = null;
      if (style.top < 0) {
        swapY = "bottom";
      } else if (style.top + style.height > this.viewer.state.size.height) {
        swapY = "top";
      }
      if (style.left < 0) {
        swapX = "right";
      } else if (style.left + style.width > this.viewer.state.size.width) {
        swapX = "left";
      }
      if (swapX || swapY) {
        var ordered = _cssPositionIsOrdered(style.posClass);
        if (swapY) {
          style.posClass[ordered ? 0 : 1] = swapY;
        }
        if (swapX) {
          style.posClass[ordered ? 1 : 0] = swapX;
        }
        this.__computeTooltipPosition(style, config);
      }
      t.style.top = style.top + "px";
      t.style.left = style.left + "px";
      a.style.top = style.arrowTop + "px";
      a.style.left = style.arrowLeft + "px";
      var newPos = style.posClass.join("-");
      if (newPos !== this.state.pos) {
        t.classList.remove("psv-tooltip--".concat(this.state.pos));
        this.state.pos = newPos;
        t.classList.add("psv-tooltip--".concat(this.state.pos));
      }
    }
    /**
     * Hides the tooltip
     */
  }, {
    key: "hide",
    value: function hide() {
      this.container.classList.remove("psv-tooltip--visible");
      this.state.state = 2 /* HIDING */;
      this.viewer.dispatchEvent(new _HideTooltipEvent2(this.state.data));
    }
    /**
     * Finalize transition
     */
  }, {
    key: "__onTransitionEnd",
    value: function __onTransitionEnd(e) {
      if (e.propertyName === "transform") {
        switch (this.state.state) {
          case 1 /* SHOWING */:
            this.container.classList.add("psv-tooltip--visible");
            this.state.state = 3 /* READY */;
            break;
          case 2 /* HIDING */:
            this.state.state = 0 /* NONE */;
            this.destroy();
            break;
        }
      }
    }
    /**
     * Computes the position of the tooltip and its arrow
     */
  }, {
    key: "__computeTooltipPosition",
    value: function __computeTooltipPosition(style, config) {
      var arrow = this.state.arrow;
      var top = config.top;
      var height = style.height;
      var left = config.left;
      var width = style.width;
      var offsetSide = arrow + this.state.border;
      var offsetX = config.box.width / 2 + arrow * 2;
      var offsetY = config.box.height / 2 + arrow * 2;
      switch (style.posClass.join("-")) {
        case "top-left":
          style.top = top - offsetY - height;
          style.left = left + offsetSide - width;
          style.arrowTop = height;
          style.arrowLeft = width - offsetSide - arrow;
          break;
        case "top-center":
          style.top = top - offsetY - height;
          style.left = left - width / 2;
          style.arrowTop = height;
          style.arrowLeft = width / 2 - arrow;
          break;
        case "top-right":
          style.top = top - offsetY - height;
          style.left = left - offsetSide;
          style.arrowTop = height;
          style.arrowLeft = arrow;
          break;
        case "bottom-left":
          style.top = top + offsetY;
          style.left = left + offsetSide - width;
          style.arrowTop = -arrow * 2;
          style.arrowLeft = width - offsetSide - arrow;
          break;
        case "bottom-center":
          style.top = top + offsetY;
          style.left = left - width / 2;
          style.arrowTop = -arrow * 2;
          style.arrowLeft = width / 2 - arrow;
          break;
        case "bottom-right":
          style.top = top + offsetY;
          style.left = left - offsetSide;
          style.arrowTop = -arrow * 2;
          style.arrowLeft = arrow;
          break;
        case "left-top":
          style.top = top + offsetSide - height;
          style.left = left - offsetX - width;
          style.arrowTop = height - offsetSide - arrow;
          style.arrowLeft = width;
          break;
        case "center-left":
          style.top = top - height / 2;
          style.left = left - offsetX - width;
          style.arrowTop = height / 2 - arrow;
          style.arrowLeft = width;
          break;
        case "left-bottom":
          style.top = top - offsetSide;
          style.left = left - offsetX - width;
          style.arrowTop = arrow;
          style.arrowLeft = width;
          break;
        case "right-top":
          style.top = top + offsetSide - height;
          style.left = left + offsetX;
          style.arrowTop = height - offsetSide - arrow;
          style.arrowLeft = -arrow * 2;
          break;
        case "center-right":
          style.top = top - height / 2;
          style.left = left + offsetX;
          style.arrowTop = height / 2 - arrow;
          style.arrowLeft = -arrow * 2;
          break;
        case "right-bottom":
          style.top = top - offsetSide;
          style.left = left + offsetX;
          style.arrowTop = arrow;
          style.arrowLeft = -arrow * 2;
          break;
      }
    }
    /**
     * If the tooltip contains images, recompute its size once they are loaded
     */
  }, {
    key: "__waitImages",
    value: function __waitImages() {
      var _this62 = this;
      var images = this.content.querySelectorAll("img");
      if (images.length > 0) {
        var promises = [];
        images.forEach(function (image) {
          if (!image.complete) {
            promises.push(new Promise(function (resolve) {
              image.onload = resolve;
              image.onerror = resolve;
            }));
          }
        });
        if (promises.length) {
          Promise.all(promises).then(function () {
            if (_this62.state.state === 1 /* SHOWING */ || _this62.state.state === 3 /* READY */) {
              var rect = _this62.container.getBoundingClientRect();
              _this62.state.width = rect.right - rect.left;
              _this62.state.height = rect.bottom - rect.top;
              _this62.move(_this62.state.config);
            }
          });
        }
      }
    }
  }]);
  return Tooltip;
}(AbstractComponent);
var Cache = {
  enabled: true,
  maxItems: 10,
  ttl: 10 * 60,
  items: {},
  purgeInterval: null,
  init: function init() {
    var _this63 = this;
    if (Cache$1.enabled) {
      _logWarn("ThreeJS cache should be disabled");
      Cache$1.enabled = false;
    }
    if (!this.purgeInterval && this.enabled) {
      this.purgeInterval = setInterval(function () {
        return _this63.purge();
      }, 60 * 1e3);
    }
  },
  add: function add(url, key, data) {
    if (this.enabled && key) {
      var _this$items$key;
      this.items[key] = (_this$items$key = this.items[key]) !== null && _this$items$key !== void 0 ? _this$items$key : {
        files: {},
        lastAccess: null
      };
      this.items[key].files[url] = data;
      this.items[key].lastAccess = Date.now();
    }
  },
  get: function get(url, key) {
    if (this.enabled && key && this.items[key]) {
      this.items[key].lastAccess = Date.now();
      return this.items[key].files[url];
    }
  },
  remove: function remove(url, key) {
    if (this.enabled && key && this.items[key]) {
      delete this.items[key].files[url];
      if (Object.keys(this.items[key].files).length === 0) {
        delete this.items[key];
      }
    }
  },
  purge: function purge() {
    var _this64 = this;
    Object.entries(this.items).sort(function (_ref16, _ref17) {
      var _ref18 = _slicedToArray(_ref16, 2),
        a = _ref18[1];
      var _ref19 = _slicedToArray(_ref17, 2),
        b = _ref19[1];
      return b.lastAccess - a.lastAccess;
    }).forEach(function (_ref20, index) {
      var _ref21 = _slicedToArray(_ref20, 2),
        key = _ref21[0],
        lastAccess = _ref21[1].lastAccess;
      if (index > 0 && (Date.now() - lastAccess >= _this64.ttl * 1e3 || index >= _this64.maxItems)) {
        delete _this64.items[key];
      }
    });
  }
};

// src/icons/error.svg
var error_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/><!--Created by Shastry from the Noun Project--></svg>\n';

// src/services/AbstractService.ts
var AbstractService = /*#__PURE__*/function () {
  /**
   * @internal
   */
  function AbstractService(viewer) {
    _classCallCheck(this, AbstractService);
    this.viewer = viewer;
    this.config = viewer.config;
    this.state = viewer.state;
  }
  /**
   * Destroys the service
   * @internal
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  _createClass(AbstractService, [{
    key: "destroy",
    value: function destroy() {}
  }]);
  return AbstractService;
}();

// src/services/DataHelper.ts
var vector3 = new Vector3();
var EULER_ZERO = new Euler(0, 0, 0, "ZXY");
var DataHelper = /*#__PURE__*/function (_AbstractService) {
  _inherits(DataHelper, _AbstractService);
  var _super60 = _createSuper(DataHelper);
  /**
   * @internal
   */
  function DataHelper(viewer) {
    _classCallCheck(this, DataHelper);
    return _super60.call(this, viewer);
  }
  /**
   * Converts vertical FOV to zoom level
   */
  _createClass(DataHelper, [{
    key: "fovToZoomLevel",
    value: function fovToZoomLevel(fov) {
      var temp = Math.round((fov - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
      return temp - 2 * (temp - 50);
    }
    /**
     * Converts zoom level to vertical FOV
     */
  }, {
    key: "zoomLevelToFov",
    value: function zoomLevelToFov(level) {
      return this.config.maxFov + level / 100 * (this.config.minFov - this.config.maxFov);
    }
    /**
     * Converts vertical FOV to horizontal FOV
     */
  }, {
    key: "vFovToHFov",
    value: function vFovToHFov(vFov) {
      return MathUtils.radToDeg(2 * Math.atan(Math.tan(MathUtils.degToRad(vFov) / 2) * this.state.aspect));
    }
    /**
     * @internal
     */
  }, {
    key: "getAnimationProperties",
    value: function getAnimationProperties(speed, targetPosition, targetZoom) {
      var positionProvided = !_isNil(targetPosition);
      var zoomProvided = !_isNil(targetZoom);
      var properties = {};
      var duration = null;
      if (positionProvided) {
        var currentPosition = this.viewer.getPosition();
        var dYaw = _getShortestArc(currentPosition.yaw, targetPosition.yaw);
        properties.yaw = {
          start: currentPosition.yaw,
          end: currentPosition.yaw + dYaw
        };
        properties.pitch = {
          start: currentPosition.pitch,
          end: targetPosition.pitch
        };
        duration = _speedToDuration(speed, _getAngle(currentPosition, targetPosition));
      }
      if (zoomProvided) {
        var currentZoom = this.viewer.getZoomLevel();
        var dZoom = Math.abs(targetZoom - currentZoom);
        properties.zoom = {
          start: currentZoom,
          end: targetZoom
        };
        if (duration === null) {
          duration = _speedToDuration(speed, Math.PI / 4 * dZoom / 100);
        }
      }
      if (duration === null) {
        if (typeof speed === "number") {
          duration = speed;
        } else {
          duration = _ANIMATION_MIN_DURATION;
        }
      } else {
        duration = Math.max(_ANIMATION_MIN_DURATION, duration);
      }
      return {
        duration: duration,
        properties: properties
      };
    }
    /**
     * Converts pixel texture coordinates to spherical radians coordinates
     * @throws {@link PSVError} when the current adapter does not support texture coordinates
     */
  }, {
    key: "textureCoordsToSphericalCoords",
    value: function textureCoordsToSphericalCoords(point) {
      var _this$state$textureDa;
      if (!((_this$state$textureDa = this.state.textureData) !== null && _this$state$textureDa !== void 0 && _this$state$textureDa.panoData)) {
        throw new PSVError("Current adapter does not support texture coordinates or no texture has been loaded");
      }
      var result = this.viewer.adapter.textureCoordsToSphericalCoords(point, this.state.textureData.panoData);
      if (!EULER_ZERO.equals(this.viewer.renderer.panoramaPose) || !EULER_ZERO.equals(this.viewer.renderer.sphereCorrection)) {
        this.sphericalCoordsToVector3(result, vector3);
        vector3.applyEuler(this.viewer.renderer.panoramaPose);
        vector3.applyEuler(this.viewer.renderer.sphereCorrection);
        return this.vector3ToSphericalCoords(vector3);
      } else {
        return result;
      }
    }
    /**
     * Converts spherical radians coordinates to pixel texture coordinates
     * @throws {@link PSVError} when the current adapter does not support texture coordinates
     */
  }, {
    key: "sphericalCoordsToTextureCoords",
    value: function sphericalCoordsToTextureCoords(position) {
      var _this$state$textureDa2;
      if (!((_this$state$textureDa2 = this.state.textureData) !== null && _this$state$textureDa2 !== void 0 && _this$state$textureDa2.panoData)) {
        throw new PSVError("Current adapter does not support texture coordinates or no texture has been loaded");
      }
      if (!EULER_ZERO.equals(this.viewer.renderer.panoramaPose) || !EULER_ZERO.equals(this.viewer.renderer.sphereCorrection)) {
        this.sphericalCoordsToVector3(position, vector3);
        _applyEulerInverse(vector3, this.viewer.renderer.sphereCorrection);
        _applyEulerInverse(vector3, this.viewer.renderer.panoramaPose);
        position = this.vector3ToSphericalCoords(vector3);
      }
      return this.viewer.adapter.sphericalCoordsToTextureCoords(position, this.state.textureData.panoData);
    }
    /**
     * Converts spherical radians coordinates to a Vector3
     */
  }, {
    key: "sphericalCoordsToVector3",
    value: function sphericalCoordsToVector3(position, vector) {
      var distance2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _SPHERE_RADIUS;
      if (!vector) {
        vector = new Vector3();
      }
      vector.x = distance2 * -Math.cos(position.pitch) * Math.sin(position.yaw);
      vector.y = distance2 * Math.sin(position.pitch);
      vector.z = distance2 * Math.cos(position.pitch) * Math.cos(position.yaw);
      return vector;
    }
    /**
     * Converts a Vector3 to spherical radians coordinates
     */
  }, {
    key: "vector3ToSphericalCoords",
    value: function vector3ToSphericalCoords(vector) {
      var phi = Math.acos(vector.y / Math.sqrt(vector.x * vector.x + vector.y * vector.y + vector.z * vector.z));
      var theta = Math.atan2(vector.x, vector.z);
      return {
        yaw: theta < 0 ? -theta : Math.PI * 2 - theta,
        pitch: Math.PI / 2 - phi
      };
    }
    /**
     * Converts position on the viewer to a THREE.Vector3
     */
  }, {
    key: "viewerCoordsToVector3",
    value: function viewerCoordsToVector3(viewerPoint) {
      var sphereIntersect = this.viewer.renderer.getIntersections(viewerPoint).filter(function (i) {
        return i.object.userData[_VIEWER_DATA];
      });
      if (sphereIntersect.length) {
        return sphereIntersect[0].point;
      } else {
        return null;
      }
    }
    /**
     * Converts position on the viewer to spherical radians coordinates
     */
  }, {
    key: "viewerCoordsToSphericalCoords",
    value: function viewerCoordsToSphericalCoords(viewerPoint) {
      var vector = this.viewerCoordsToVector3(viewerPoint);
      return vector ? this.vector3ToSphericalCoords(vector) : null;
    }
    /**
     * Converts a Vector3 to position on the viewer
     */
  }, {
    key: "vector3ToViewerCoords",
    value: function vector3ToViewerCoords(vector) {
      var vectorClone = vector.clone();
      vectorClone.project(this.viewer.renderer.camera);
      return {
        x: Math.round((vectorClone.x + 1) / 2 * this.state.size.width),
        y: Math.round((1 - vectorClone.y) / 2 * this.state.size.height)
      };
    }
    /**
     * Converts spherical radians coordinates to position on the viewer
     */
  }, {
    key: "sphericalCoordsToViewerCoords",
    value: function sphericalCoordsToViewerCoords(position) {
      this.sphericalCoordsToVector3(position, vector3);
      return this.vector3ToViewerCoords(vector3);
    }
    /**
     * @internal
     */
  }, {
    key: "isPointVisible",
    value: function isPointVisible(point) {
      var vector;
      var viewerPoint;
      if (point instanceof Vector3) {
        vector = point;
        viewerPoint = this.vector3ToViewerCoords(point);
      } else if (_isExtendedPosition(point)) {
        vector = this.sphericalCoordsToVector3(point, vector3);
        viewerPoint = this.vector3ToViewerCoords(vector);
      } else {
        return false;
      }
      return vector.dot(this.viewer.state.direction) > 0 && viewerPoint.x >= 0 && viewerPoint.x <= this.viewer.state.size.width && viewerPoint.y >= 0 && viewerPoint.y <= this.viewer.state.size.height;
    }
    /**
     * Converts pixel position to angles if present and ensure boundaries
     */
  }, {
    key: "cleanPosition",
    value: function cleanPosition(position) {
      if ("yaw" in position && "pitch" in position) {
        return {
          yaw: _parseAngle(position.yaw),
          pitch: _parseAngle(position.pitch, !this.state.littlePlanet)
        };
      } else {
        return this.textureCoordsToSphericalCoords(position);
      }
    }
    /**
     * Ensure a SphereCorrection object is valid
     */
  }, {
    key: "cleanSphereCorrection",
    value: function cleanSphereCorrection(sphereCorrection) {
      return {
        pan: _parseAngle((sphereCorrection === null || sphereCorrection === void 0 ? void 0 : sphereCorrection.pan) || 0),
        tilt: _parseAngle((sphereCorrection === null || sphereCorrection === void 0 ? void 0 : sphereCorrection.tilt) || 0, true),
        roll: _parseAngle((sphereCorrection === null || sphereCorrection === void 0 ? void 0 : sphereCorrection.roll) || 0, true, false)
      };
    }
    /**
     * Parse the pose angles of the pano data
     */
  }, {
    key: "cleanPanoramaPose",
    value: function cleanPanoramaPose(panoData) {
      return {
        pan: MathUtils.degToRad((panoData === null || panoData === void 0 ? void 0 : panoData.poseHeading) || 0),
        tilt: MathUtils.degToRad((panoData === null || panoData === void 0 ? void 0 : panoData.posePitch) || 0),
        roll: MathUtils.degToRad((panoData === null || panoData === void 0 ? void 0 : panoData.poseRoll) || 0)
      };
    }
  }]);
  return DataHelper;
}(AbstractService);

// src/icons/gesture.svg
var gesture_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/><!--Created by AomAm from the Noun Project--></svg>\n';

// src/icons/mousewheel.svg
var mousewheel_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/><!-- Created by Icon Island from the Noun Project --></svg>\n';

// src/services/EventsHandler.ts
var _Step = /*#__PURE__*/function () {
  function _Step() {
    _classCallCheck(this, _Step);
    this.$ = _Step.IDLE;
  }
  _createClass(_Step, [{
    key: "is",
    value: function is() {
      var _this65 = this;
      for (var _len4 = arguments.length, steps = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        steps[_key4] = arguments[_key4];
      }
      return steps.some(function (step) {
        return _this65.$ & step;
      });
    }
  }, {
    key: "set",
    value: function set(step) {
      this.$ = step;
    }
  }, {
    key: "add",
    value: function add(step) {
      this.$ |= step;
    }
  }, {
    key: "remove",
    value: function remove(step) {
      this.$ &= ~step;
    }
  }]);
  return _Step;
}();
_Step.IDLE = 0;
_Step.CLICK = 1;
_Step.MOVING = 2;
_Step.INERTIA = 4;
var Step = _Step;
var EventsHandler = /*#__PURE__*/function (_AbstractService2) {
  _inherits(EventsHandler, _AbstractService2);
  var _super61 = _createSuper(EventsHandler);
  function EventsHandler(viewer) {
    var _this66;
    _classCallCheck(this, EventsHandler);
    _this66 = _super61.call(this, viewer);
    _this66.data = {
      /** start x position of the click/touch */
      startMouseX: 0,
      /** start y position of the click/touch */
      startMouseY: 0,
      /** current x position of the cursor */
      mouseX: 0,
      /** current y position of the cursor */
      mouseY: 0,
      /** list of latest positions of the cursor, [time, x, y] */
      mouseHistory: [],
      /** distance between fingers when zooming */
      pinchDist: 0,
      /** when the Ctrl key is pressed */
      ctrlKeyDown: false,
      /** temporary storage of click data between two clicks */
      dblclickData: null,
      dblclickTimeout: null,
      longtouchTimeout: null,
      twofingersTimeout: null,
      ctrlZoomTimeout: null
    };
    _this66.step = new Step();
    _this66.keyHandler = new _PressHandler();
    _this66.resizeObserver = new ResizeObserver(_throttle(function () {
      return _this66.viewer.autoSize();
    }, 50));
    _this66.moveThreshold = _MOVE_THRESHOLD * SYSTEM.pixelRatio;
    return _this66;
  }
  /**
   * @internal
   */
  _createClass(EventsHandler, [{
    key: "init",
    value: function init() {
      window.addEventListener("keydown", this, {
        passive: false
      });
      window.addEventListener("keyup", this);
      this.viewer.container.addEventListener("mousedown", this);
      window.addEventListener("mousemove", this, {
        passive: false
      });
      window.addEventListener("mouseup", this);
      this.viewer.container.addEventListener("touchstart", this, {
        passive: false
      });
      window.addEventListener("touchmove", this, {
        passive: false
      });
      window.addEventListener("touchend", this, {
        passive: false
      });
      this.viewer.container.addEventListener("wheel", this, {
        passive: false
      });
      document.addEventListener(SYSTEM.fullscreenEvent, this);
      this.resizeObserver.observe(this.viewer.container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("keydown", this);
      window.removeEventListener("keyup", this);
      this.viewer.container.removeEventListener("mousedown", this);
      window.removeEventListener("mousemove", this);
      window.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchstart", this);
      window.removeEventListener("touchmove", this);
      window.removeEventListener("touchend", this);
      this.viewer.container.removeEventListener("wheel", this);
      document.removeEventListener(SYSTEM.fullscreenEvent, this);
      this.resizeObserver.disconnect();
      clearTimeout(this.data.dblclickTimeout);
      clearTimeout(this.data.longtouchTimeout);
      clearTimeout(this.data.twofingersTimeout);
      clearTimeout(this.data.ctrlZoomTimeout);
      _get(_getPrototypeOf(EventsHandler.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(evt) {
      switch (evt.type) {
        case "keydown":
          this.__onKeyDown(evt);
          break;
        case "keyup":
          this.__onKeyUp();
          break;
        case "mousemove":
          this.__onMouseMove(evt);
          break;
        case "mouseup":
          this.__onMouseUp(evt);
          break;
        case "touchmove":
          this.__onTouchMove(evt);
          break;
        case "touchend":
          this.__onTouchEnd(evt);
          break;
        case SYSTEM.fullscreenEvent:
          this.__onFullscreenChange();
          break;
      }
      if (!_getClosest(evt.target, "." + _CAPTURE_EVENTS_CLASS)) {
        switch (evt.type) {
          case "mousedown":
            this.__onMouseDown(evt);
            break;
          case "touchstart":
            this.__onTouchStart(evt);
            break;
          case "wheel":
            this.__onMouseWheel(evt);
            break;
        }
      }
    }
    /**
     * Handles keyboard events
     */
  }, {
    key: "__onKeyDown",
    value: function __onKeyDown(e) {
      var _this$config$keyboard;
      if (this.config.mousewheelCtrlKey) {
        this.data.ctrlKeyDown = e.key === _KEY_CODES.Control;
        if (this.data.ctrlKeyDown) {
          clearTimeout(this.data.ctrlZoomTimeout);
          this.viewer.overlay.hide(_IDS.CTRL_ZOOM);
        }
      }
      if (!this.viewer.dispatchEvent(new _KeypressEvent2(e.key))) {
        return;
      }
      if (!this.state.keyboardEnabled) {
        return;
      }
      var action = (_this$config$keyboard = this.config.keyboardActions) === null || _this$config$keyboard === void 0 ? void 0 : _this$config$keyboard[e.key];
      if (typeof action === "function") {
        action(this.viewer);
        e.preventDefault();
      } else if (action && !this.keyHandler.pending) {
        if (action !== "ZOOM_IN" /* ZOOM_IN */ && action !== "ZOOM_OUT" /* ZOOM_OUT */) {
          this.viewer.stopAll();
        }
        switch (action) {
          case "ROTATE_UP" /* ROTATE_UP */:
            this.viewer.dynamics.position.roll({
              pitch: false
            });
            break;
          case "ROTATE_DOWN" /* ROTATE_DOWN */:
            this.viewer.dynamics.position.roll({
              pitch: true
            });
            break;
          case "ROTATE_RIGHT" /* ROTATE_RIGHT */:
            this.viewer.dynamics.position.roll({
              yaw: false
            });
            break;
          case "ROTATE_LEFT" /* ROTATE_LEFT */:
            this.viewer.dynamics.position.roll({
              yaw: true
            });
            break;
          case "ZOOM_IN" /* ZOOM_IN */:
            this.viewer.dynamics.zoom.roll(false);
            break;
          case "ZOOM_OUT" /* ZOOM_OUT */:
            this.viewer.dynamics.zoom.roll(true);
            break;
        }
        this.keyHandler.down();
        e.preventDefault();
      }
    }
    /**
     * Handles keyboard events
     */
  }, {
    key: "__onKeyUp",
    value: function __onKeyUp() {
      var _this67 = this;
      this.data.ctrlKeyDown = false;
      if (!this.state.keyboardEnabled) {
        return;
      }
      this.keyHandler.up(function () {
        _this67.viewer.dynamics.position.stop();
        _this67.viewer.dynamics.zoom.stop();
        _this67.viewer.resetIdleTimer();
      });
    }
    /**
     * Handles mouse down events
     */
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown(evt) {
      this.step.add(Step.CLICK);
      this.data.startMouseX = evt.clientX;
      this.data.startMouseY = evt.clientY;
    }
    /**
     *Handles mouse up events
     */
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp(evt) {
      if (this.step.is(Step.CLICK, Step.MOVING)) {
        this.__stopMove(evt.clientX, evt.clientY, evt.target, evt.button === 2);
      }
    }
    /**
     * Handles mouse move events
     */
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(evt) {
      if (this.config.mousemove && this.step.is(Step.CLICK, Step.MOVING)) {
        evt.preventDefault();
        this.__doMove(evt.clientX, evt.clientY);
      }
      this.__handleObjectsEvents(evt);
    }
    /**
     * Handles touch events
     */
  }, {
    key: "__onTouchStart",
    value: function __onTouchStart(evt) {
      var _this68 = this;
      if (evt.touches.length === 1) {
        this.step.add(Step.CLICK);
        this.data.startMouseX = evt.touches[0].clientX;
        this.data.startMouseY = evt.touches[0].clientY;
        if (!this.data.longtouchTimeout) {
          this.data.longtouchTimeout = setTimeout(function () {
            var touch = evt.touches[0];
            _this68.__stopMove(touch.clientX, touch.clientY, touch.target, true);
            _this68.data.longtouchTimeout = null;
          }, _LONGTOUCH_DELAY);
        }
      } else if (evt.touches.length === 2) {
        this.step.set(Step.IDLE);
        this.__cancelLongTouch();
        if (this.config.mousemove) {
          this.__cancelTwoFingersOverlay();
          this.__startMoveZoom(evt);
          evt.preventDefault();
        }
      }
    }
    /**
     * Handles touch events
     */
  }, {
    key: "__onTouchEnd",
    value: function __onTouchEnd(evt) {
      this.__cancelLongTouch();
      if (this.step.is(Step.CLICK, Step.MOVING)) {
        evt.preventDefault();
        this.__cancelTwoFingersOverlay();
        if (evt.touches.length === 1) {
          this.__stopMove(this.data.mouseX, this.data.mouseY);
        } else if (evt.touches.length === 0) {
          var touch = evt.changedTouches[0];
          this.__stopMove(touch.clientX, touch.clientY, touch.target);
        }
      }
    }
    /**
     * Handles touch move events
     */
  }, {
    key: "__onTouchMove",
    value: function __onTouchMove(evt) {
      var _this69 = this;
      this.__cancelLongTouch();
      if (!this.config.mousemove) {
        return;
      }
      if (evt.touches.length === 1) {
        if (this.config.touchmoveTwoFingers) {
          if (this.step.is(Step.CLICK) && !this.data.twofingersTimeout) {
            this.data.twofingersTimeout = setTimeout(function () {
              _this69.viewer.overlay.show({
                id: _IDS.TWO_FINGERS,
                image: gesture_default,
                title: _this69.config.lang.twoFingers
              });
            }, _TWOFINGERSOVERLAY_DELAY);
          }
        } else if (this.step.is(Step.CLICK, Step.MOVING)) {
          evt.preventDefault();
          var touch = evt.touches[0];
          this.__doMove(touch.clientX, touch.clientY);
        }
      } else {
        this.__doMoveZoom(evt);
        this.__cancelTwoFingersOverlay();
      }
    }
    /**
     * Cancel the long touch timer if any
     */
  }, {
    key: "__cancelLongTouch",
    value: function __cancelLongTouch() {
      if (this.data.longtouchTimeout) {
        clearTimeout(this.data.longtouchTimeout);
        this.data.longtouchTimeout = null;
      }
    }
    /**
     * Cancel the two fingers overlay timer if any
     */
  }, {
    key: "__cancelTwoFingersOverlay",
    value: function __cancelTwoFingersOverlay() {
      if (this.config.touchmoveTwoFingers) {
        if (this.data.twofingersTimeout) {
          clearTimeout(this.data.twofingersTimeout);
          this.data.twofingersTimeout = null;
        }
        this.viewer.overlay.hide(_IDS.TWO_FINGERS);
      }
    }
    /**
     * Handles mouse wheel events
     */
  }, {
    key: "__onMouseWheel",
    value: function __onMouseWheel(evt) {
      var _this70 = this;
      if (!this.config.mousewheel || !evt.deltaY) {
        return;
      }
      if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) {
        this.viewer.overlay.show({
          id: _IDS.CTRL_ZOOM,
          image: mousewheel_default,
          title: this.config.lang.ctrlZoom
        });
        clearTimeout(this.data.ctrlZoomTimeout);
        this.data.ctrlZoomTimeout = setTimeout(function () {
          return _this70.viewer.overlay.hide(_IDS.CTRL_ZOOM);
        }, _CTRLZOOM_TIMEOUT);
        return;
      }
      evt.preventDefault();
      evt.stopPropagation();
      var delta = evt.deltaY / Math.abs(evt.deltaY) * 5 * this.config.zoomSpeed;
      if (delta !== 0) {
        this.viewer.dynamics.zoom.step(-delta, 5);
      }
    }
    /**
     * Handles fullscreen events
     */
  }, {
    key: "__onFullscreenChange",
    value: function __onFullscreenChange() {
      var fullscreen = this.viewer.isFullscreenEnabled();
      if (this.config.keyboard === "fullscreen") {
        if (fullscreen) {
          this.viewer.startKeyboardControl();
        } else {
          this.viewer.stopKeyboardControl();
        }
      }
      this.viewer.dispatchEvent(new _FullscreenEvent2(fullscreen));
    }
    /**
     * Resets all state variables
     */
  }, {
    key: "__resetMove",
    value: function __resetMove() {
      this.step.set(Step.IDLE);
      this.data.mouseX = 0;
      this.data.mouseY = 0;
      this.data.startMouseX = 0;
      this.data.startMouseY = 0;
      this.data.mouseHistory.length = 0;
    }
    /**
     * Initializes the combines move and zoom
     */
  }, {
    key: "__startMoveZoom",
    value: function __startMoveZoom(evt) {
      this.viewer.stopAll();
      this.__resetMove();
      var touchData = _getTouchData(evt);
      this.step.set(Step.MOVING);
      this.data.pinchDist = touchData.distance;
      var _touchData$center = touchData.center;
      this.data.mouseX = _touchData$center.x;
      this.data.mouseY = _touchData$center.y;
      this.__logMouseMove(this.data.mouseX, this.data.mouseY);
    }
    /**
     * Stops the movement
     * @description If the move threshold was not reached a click event is triggered, otherwise an animation is launched to simulate inertia
     */
  }, {
    key: "__stopMove",
    value: function __stopMove(clientX, clientY, target) {
      var rightclick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (this.step.is(Step.MOVING)) {
        if (this.config.moveInertia) {
          this.__logMouseMove(clientX, clientY);
          this.__stopMoveInertia(clientX, clientY);
        } else {
          this.__resetMove();
          this.viewer.resetIdleTimer();
        }
      } else {
        if (this.step.is(Step.CLICK) && !this.__moveThresholdReached(clientX, clientY)) {
          this.__doClick(clientX, clientY, target, rightclick);
        }
        this.step.remove(Step.CLICK);
        if (!this.step.is(Step.INERTIA)) {
          this.__resetMove();
          this.viewer.resetIdleTimer();
        }
      }
    }
    /**
     * Performs an animation to simulate inertia when the movement stops
     */
  }, {
    key: "__stopMoveInertia",
    value: function __stopMoveInertia(clientX, clientY) {
      var _this71 = this;
      var curve = new SplineCurve(this.data.mouseHistory.map(function (_ref22) {
        var _ref23 = _slicedToArray(_ref22, 3),
          x = _ref23[1],
          y = _ref23[2];
        return new Vector2(x, y);
      }));
      var direction = curve.getTangent(1);
      var speed = this.data.mouseHistory.reduce(function (_ref24, curr) {
        var total = _ref24.total,
          prev = _ref24.prev;
        return {
          total: !prev ? 0 : total + _distance({
            x: prev[1],
            y: prev[2]
          }, {
            x: curr[1],
            y: curr[2]
          }) / (curr[0] - prev[0]),
          prev: curr
        };
      }, {
        total: 0,
        prev: null
      }).total / this.data.mouseHistory.length;
      if (!speed) {
        this.__resetMove();
        this.viewer.resetIdleTimer();
        return;
      }
      this.step.set(Step.INERTIA);
      var currentClientX = clientX;
      var currentClientY = clientY;
      this.state.animation = new _Animation({
        properties: {
          speed: {
            start: speed,
            end: 0
          }
        },
        duration: 1e3,
        easing: "outQuad",
        onTick: function onTick(properties) {
          currentClientX += properties.speed * direction.x * 3 * SYSTEM.pixelRatio;
          currentClientY += properties.speed * direction.y * 3 * SYSTEM.pixelRatio;
          _this71.__applyMove(currentClientX, currentClientY);
        }
      });
      this.state.animation.then(function (done) {
        _this71.state.animation = null;
        if (done) {
          _this71.__resetMove();
          _this71.viewer.resetIdleTimer();
        }
      });
    }
    /**
     * Triggers an event with all coordinates when a simple click is performed
     */
  }, {
    key: "__doClick",
    value: function __doClick(clientX, clientY, target) {
      var _this72 = this;
      var rightclick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var boundingRect = this.viewer.container.getBoundingClientRect();
      var viewerX = clientX - boundingRect.left;
      var viewerY = clientY - boundingRect.top;
      var intersections = this.viewer.renderer.getIntersections({
        x: viewerX,
        y: viewerY
      });
      var sphereIntersection = intersections.find(function (i) {
        return i.object.userData[_VIEWER_DATA];
      });
      if (sphereIntersection) {
        var sphericalCoords = this.viewer.dataHelper.vector3ToSphericalCoords(sphereIntersection.point);
        var data = {
          rightclick: rightclick,
          target: target,
          clientX: clientX,
          clientY: clientY,
          viewerX: viewerX,
          viewerY: viewerY,
          yaw: sphericalCoords.yaw,
          pitch: sphericalCoords.pitch,
          objects: intersections.map(function (i) {
            return i.object;
          }).filter(function (o) {
            return !o.userData[_VIEWER_DATA];
          })
        };
        try {
          var textureCoords = this.viewer.dataHelper.sphericalCoordsToTextureCoords(data);
          Object.assign(data, textureCoords);
        } catch (e) {}
        if (!this.data.dblclickTimeout) {
          this.viewer.dispatchEvent(new _ClickEvent2(data));
          this.data.dblclickData = _clone(data);
          this.data.dblclickTimeout = setTimeout(function () {
            _this72.data.dblclickTimeout = null;
            _this72.data.dblclickData = null;
          }, _DBLCLICK_DELAY);
        } else {
          if (Math.abs(this.data.dblclickData.clientX - data.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - data.clientY) < this.moveThreshold) {
            this.viewer.dispatchEvent(new _DoubleClickEvent2(this.data.dblclickData));
          }
          clearTimeout(this.data.dblclickTimeout);
          this.data.dblclickTimeout = null;
          this.data.dblclickData = null;
        }
      }
    }
    /**
     * Trigger events for observed THREE objects
     */
  }, {
    key: "__handleObjectsEvents",
    value: function __handleObjectsEvents(evt) {
      var _this73 = this;
      if (!_isEmpty(this.state.objectsObservers) && _hasParent(evt.target, this.viewer.container)) {
        var viewerPos = _getPosition(this.viewer.container);
        var viewerPoint = {
          x: evt.clientX - viewerPos.x,
          y: evt.clientY - viewerPos.y
        };
        var intersections = this.viewer.renderer.getIntersections(viewerPoint);
        var emit = function emit(object, key, evtCtor) {
          _this73.viewer.dispatchEvent(new evtCtor(evt, object, viewerPoint, key));
        };
        var _loop = function _loop() {
          var _Object$entries9$_i = _slicedToArray(_Object$entries9[_i17], 2),
            key = _Object$entries9$_i[0],
            object = _Object$entries9$_i[1];
          var intersection = intersections.find(function (i) {
            return i.object.userData[key];
          });
          if (intersection) {
            if (object && intersection.object !== object) {
              emit(object, key, _ObjectLeaveEvent2);
              _this73.state.objectsObservers[key] = null;
            }
            if (!object) {
              _this73.state.objectsObservers[key] = intersection.object;
              emit(intersection.object, key, _ObjectEnterEvent2);
            } else {
              emit(intersection.object, key, _ObjectHoverEvent2);
            }
          } else if (object) {
            emit(object, key, _ObjectLeaveEvent2);
            _this73.state.objectsObservers[key] = null;
          }
        };
        for (var _i17 = 0, _Object$entries9 = Object.entries(this.state.objectsObservers); _i17 < _Object$entries9.length; _i17++) {
          _loop();
        }
      }
    }
    /**
     * Starts moving when crossing moveThreshold and performs movement
     */
  }, {
    key: "__doMove",
    value: function __doMove(clientX, clientY) {
      if (this.step.is(Step.CLICK) && this.__moveThresholdReached(clientX, clientY)) {
        this.viewer.stopAll();
        this.__resetMove();
        this.step.set(Step.MOVING);
        this.data.mouseX = clientX;
        this.data.mouseY = clientY;
        this.__logMouseMove(clientX, clientY);
      } else if (this.step.is(Step.MOVING)) {
        this.__applyMove(clientX, clientY);
        this.__logMouseMove(clientX, clientY);
      }
    }
    /**
     * Checks if the cursor was move beyond the move threshold
     */
  }, {
    key: "__moveThresholdReached",
    value: function __moveThresholdReached(clientX, clientY) {
      return Math.abs(clientX - this.data.startMouseX) >= this.moveThreshold || Math.abs(clientY - this.data.startMouseY) >= this.moveThreshold;
    }
    /**
     * Raw method for movement, called from mouse event and move inertia
     */
  }, {
    key: "__applyMove",
    value: function __applyMove(clientX, clientY) {
      var rotation = {
        yaw: this.config.moveSpeed * ((clientX - this.data.mouseX) / this.state.size.width) * MathUtils.degToRad(this.state.littlePlanet ? 90 : this.state.hFov),
        pitch: this.config.moveSpeed * ((clientY - this.data.mouseY) / this.state.size.height) * MathUtils.degToRad(this.state.littlePlanet ? 90 : this.state.vFov)
      };
      var currentPosition = this.viewer.getPosition();
      this.viewer.rotate({
        yaw: currentPosition.yaw - rotation.yaw,
        pitch: currentPosition.pitch + rotation.pitch
      });
      this.data.mouseX = clientX;
      this.data.mouseY = clientY;
    }
    /**
     * Perfoms combined move and zoom
     */
  }, {
    key: "__doMoveZoom",
    value: function __doMoveZoom(evt) {
      if (this.step.is(Step.MOVING)) {
        evt.preventDefault();
        var touchData = _getTouchData(evt);
        var delta = (touchData.distance - this.data.pinchDist) / SYSTEM.pixelRatio * this.config.zoomSpeed;
        this.viewer.zoom(this.viewer.getZoomLevel() + delta);
        this.__doMove(touchData.center.x, touchData.center.y);
        this.data.pinchDist = touchData.distance;
      }
    }
    /**
     * Stores each mouse position during a mouse move
     * @description Positions older than "INERTIA_WINDOW" are removed<br>
     * Positions before a pause of "INERTIA_WINDOW" / 10 are removed
     */
  }, {
    key: "__logMouseMove",
    value: function __logMouseMove(clientX, clientY) {
      var now = Date.now();
      var last = this.data.mouseHistory.length ? this.data.mouseHistory[this.data.mouseHistory.length - 1] : [0, -1, -1];
      if (last[1] === clientX && last[2] === clientY) {
        last[0] = now;
      } else if (now === last[0]) {
        last[1] = clientX;
        last[2] = clientY;
      } else {
        this.data.mouseHistory.push([now, clientX, clientY]);
      }
      var previous = null;
      for (var i = 0; i < this.data.mouseHistory.length;) {
        if (this.data.mouseHistory[i][0] < now - _INERTIA_WINDOW) {
          this.data.mouseHistory.splice(i, 1);
        } else if (previous && this.data.mouseHistory[i][0] - previous > _INERTIA_WINDOW / 10) {
          this.data.mouseHistory.splice(0, i);
          i = 0;
          previous = this.data.mouseHistory[i][0];
        } else {
          previous = this.data.mouseHistory[i][0];
          i++;
        }
      }
    }
  }]);
  return EventsHandler;
}(AbstractService);
var vector2 = new Vector2();
var matrix4 = new Matrix4();
var box3 = new Box3();
var Renderer = /*#__PURE__*/function (_AbstractService3) {
  _inherits(Renderer, _AbstractService3);
  var _super62 = _createSuper(Renderer);
  /**
   * @internal
   */
  function Renderer(viewer) {
    var _this74;
    _classCallCheck(this, Renderer);
    _this74 = _super62.call(this, viewer);
    _this74.frustumNeedsUpdate = true;
    _this74.renderer = new WebGLRenderer(_this74.config.rendererParameters);
    _this74.renderer.setPixelRatio(SYSTEM.pixelRatio);
    _this74.renderer.outputColorSpace = LinearSRGBColorSpace;
    _this74.renderer.domElement.className = "psv-canvas";
    _this74.scene = new Scene();
    _this74.camera = new PerspectiveCamera(50, 16 / 9, 0.1, 2 * _SPHERE_RADIUS);
    _this74.camera.matrixWorldAutoUpdate = false;
    _this74.mesh = _this74.viewer.adapter.createMesh();
    _this74.mesh.userData = _defineProperty({}, _VIEWER_DATA, true);
    _this74.meshContainer = new Group();
    _this74.meshContainer.add(_this74.mesh);
    _this74.scene.add(_this74.meshContainer);
    _this74.raycaster = new Raycaster();
    _this74.frustum = new Frustum();
    _this74.container = document.createElement("div");
    _this74.container.className = "psv-canvas-container";
    _this74.container.appendChild(_this74.renderer.domElement);
    _this74.viewer.container.appendChild(_this74.container);
    _this74.viewer.addEventListener(_SizeUpdatedEvent2.type, _assertThisInitialized(_this74));
    _this74.viewer.addEventListener(_ZoomUpdatedEvent2.type, _assertThisInitialized(_this74));
    _this74.viewer.addEventListener(_PositionUpdatedEvent2.type, _assertThisInitialized(_this74));
    _this74.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this74));
    _this74.hide();
    return _this74;
  }
  _createClass(Renderer, [{
    key: "panoramaPose",
    get: function get() {
      return this.mesh.rotation;
    }
  }, {
    key: "sphereCorrection",
    get: function get() {
      return this.meshContainer.rotation;
    }
    /**
     * @internal
     */
  }, {
    key: "init",
    value: function init() {
      var _this75 = this;
      this.show();
      this.renderer.setAnimationLoop(function (t) {
        return _this75.__renderLoop(t);
      });
    }
    /**
     * @internal
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer.setAnimationLoop(null);
      this.cleanScene(this.scene);
      this.viewer.container.removeChild(this.container);
      this.viewer.removeEventListener(_SizeUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_ZoomUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_PositionUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);
      _get(_getPrototypeOf(Renderer.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case _SizeUpdatedEvent2.type:
          this.__onSizeUpdated();
          break;
        case _ZoomUpdatedEvent2.type:
          this.__onZoomUpdated();
          break;
        case _PositionUpdatedEvent2.type:
          this.__onPositionUpdated();
          break;
        case _ConfigChangedEvent2.type:
          if (e.containsOptions("fisheye")) {
            this.__onPositionUpdated();
          }
          break;
      }
    }
    /**
     * Hides the viewer
     */
  }, {
    key: "hide",
    value: function hide() {
      this.container.style.opacity = "0";
    }
    /**
     * Shows the viewer
     */
  }, {
    key: "show",
    value: function show() {
      this.container.style.opacity = "1";
    }
    /**
     * Resets or replaces the THREE renderer by a custom one
     */
  }, {
    key: "setCustomRenderer",
    value: function setCustomRenderer(factory) {
      if (factory) {
        this.customRenderer = factory(this.renderer);
      } else {
        this.customRenderer = null;
      }
      this.viewer.needsUpdate();
    }
    /**
     * Updates the size of the renderer and the aspect of the camera
     */
  }, {
    key: "__onSizeUpdated",
    value: function __onSizeUpdated() {
      this.renderer.setSize(this.state.size.width, this.state.size.height);
      this.camera.aspect = this.state.aspect;
      this.camera.updateProjectionMatrix();
      this.viewer.needsUpdate();
      this.frustumNeedsUpdate = true;
    }
    /**
     * Updates the fov of the camera
     */
  }, {
    key: "__onZoomUpdated",
    value: function __onZoomUpdated() {
      this.camera.fov = this.state.vFov;
      this.camera.updateProjectionMatrix();
      this.viewer.needsUpdate();
      this.frustumNeedsUpdate = true;
    }
    /**
     * Updates the position of the camera
     */
  }, {
    key: "__onPositionUpdated",
    value: function __onPositionUpdated() {
      this.camera.position.set(0, 0, 0);
      this.camera.lookAt(this.state.direction);
      if (this.config.fisheye) {
        this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate();
      }
      this.camera.updateMatrixWorld();
      this.viewer.needsUpdate();
      this.frustumNeedsUpdate = true;
    }
    /**
     * Main event loop, performs a render if `state.needsUpdate` is true
     */
  }, {
    key: "__renderLoop",
    value: function __renderLoop(timestamp) {
      var elapsed = !this.timestamp ? 0 : timestamp - this.timestamp;
      this.timestamp = timestamp;
      this.viewer.dispatchEvent(new _BeforeRenderEvent2(timestamp, elapsed));
      this.viewer.dynamics.update(elapsed);
      if (this.state.needsUpdate || this.state.continuousUpdateCount > 0) {
        (this.customRenderer || this.renderer).render(this.scene, this.camera);
        this.viewer.dispatchEvent(new _RenderEvent2());
        this.state.needsUpdate = false;
      }
    }
    /**
     * Applies the texture to the scene, creates the scene if needed
     * @internal
     */
  }, {
    key: "setTexture",
    value: function setTexture(textureData) {
      if (this.state.textureData) {
        this.viewer.adapter.disposeTexture(this.state.textureData);
      }
      this.state.textureData = textureData;
      this.viewer.adapter.setTexture(this.mesh, textureData);
      this.viewer.needsUpdate();
    }
    /**
     * Applies a panorama data pose to a Mesh
     * @internal
     */
  }, {
    key: "setPanoramaPose",
    value: function setPanoramaPose(panoData) {
      var mesh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mesh;
      var cleanCorrection = this.viewer.dataHelper.cleanPanoramaPose(panoData);
      mesh.rotation.set(-cleanCorrection.tilt, -cleanCorrection.pan, -cleanCorrection.roll, "ZXY");
    }
    /**
     * Applies a SphereCorrection to a Group
     * @internal
     */
  }, {
    key: "setSphereCorrection",
    value: function setSphereCorrection(sphereCorrection) {
      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.meshContainer;
      var cleanCorrection = this.viewer.dataHelper.cleanSphereCorrection(sphereCorrection);
      group.rotation.set(cleanCorrection.tilt, cleanCorrection.pan, cleanCorrection.roll, "ZXY");
    }
    /**
     * Performs transition between the current and a new texture
     * @internal
     */
  }, {
    key: "transition",
    value: function transition(textureData, options) {
      var _this76 = this;
      var positionProvided = !_isNil(options.position);
      var zoomProvided = !_isNil(options.zoom);
      var e = new _BeforeAnimateEvent2(positionProvided ? this.viewer.dataHelper.cleanPosition(options.position) : void 0, options.zoom);
      this.viewer.dispatchEvent(e);
      var group = new Group();
      var mesh = this.viewer.adapter.createMesh(0.5);
      this.viewer.adapter.setTexture(mesh, textureData, true);
      this.viewer.adapter.setTextureOpacity(mesh, 0);
      this.setPanoramaPose(textureData.panoData, mesh);
      this.setSphereCorrection(options.sphereCorrection, group);
      if (positionProvided && options.transition === "fade-only") {
        var currentPosition = this.viewer.getPosition();
        var verticalAxis = new Vector3(0, 1, 0);
        group.rotateOnWorldAxis(verticalAxis, e.position.yaw - currentPosition.yaw);
        var horizontalAxis = new Vector3(0, 1, 0).cross(this.camera.getWorldDirection(new Vector3())).normalize();
        group.rotateOnWorldAxis(horizontalAxis, e.position.pitch - currentPosition.pitch);
      }
      group.add(mesh);
      this.scene.add(group);
      this.renderer.setRenderTarget(new WebGLRenderTarget());
      this.renderer.render(this.scene, this.camera);
      this.renderer.setRenderTarget(null);
      var _this$viewer$dataHelp = this.viewer.dataHelper.getAnimationProperties(options.speed, options.transition === true ? e.position : null, e.zoomLevel),
        duration = _this$viewer$dataHelp.duration,
        properties = _this$viewer$dataHelp.properties;
      var animation = new _Animation({
        properties: _objectSpread(_objectSpread({}, properties), {}, {
          opacity: {
            start: 0,
            end: 1
          }
        }),
        duration: duration,
        easing: "inOutCubic",
        onTick: function onTick(props) {
          _this76.viewer.adapter.setTextureOpacity(mesh, props.opacity);
          if (positionProvided && options.transition === true) {
            _this76.viewer.dynamics.position.setValue({
              yaw: props.yaw,
              pitch: props.pitch
            });
          }
          if (zoomProvided) {
            _this76.viewer.dynamics.zoom.setValue(props.zoom);
          }
          _this76.viewer.needsUpdate();
        }
      });
      animation.then(function (completed) {
        if (completed) {
          _this76.setTexture(textureData);
          _this76.viewer.adapter.setTextureOpacity(_this76.mesh, 1);
          _this76.setPanoramaPose(textureData.panoData);
          _this76.setSphereCorrection(options.sphereCorrection);
          if (positionProvided && options.transition === "fade-only") {
            _this76.viewer.rotate(options.position);
          }
        } else {
          _this76.viewer.adapter.disposeTexture(textureData);
        }
        _this76.scene.remove(group);
        mesh.geometry.dispose();
        mesh.geometry = null;
      });
      return animation;
    }
    /**
     * Returns intersections with objects in the scene
     */
  }, {
    key: "getIntersections",
    value: function getIntersections(viewerPoint) {
      var _this$customRenderer;
      vector2.x = 2 * viewerPoint.x / this.state.size.width - 1;
      vector2.y = -2 * viewerPoint.y / this.state.size.height + 1;
      this.raycaster.setFromCamera(vector2, this.camera);
      var intersections = this.raycaster.intersectObjects(this.scene.children, true).filter(function (i) {
        return i.object.isMesh && !!i.object.userData;
      });
      if ((_this$customRenderer = this.customRenderer) !== null && _this$customRenderer !== void 0 && _this$customRenderer.getIntersections) {
        intersections.push.apply(intersections, _toConsumableArray(this.customRenderer.getIntersections(this.raycaster, vector2)));
      }
      return intersections;
    }
    /**
     * Checks if an object/point is currently visible
     */
  }, {
    key: "isObjectVisible",
    value: function isObjectVisible(value) {
      if (!value) {
        return false;
      }
      if (this.frustumNeedsUpdate) {
        matrix4.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse);
        this.frustum.setFromProjectionMatrix(matrix4);
        this.frustumNeedsUpdate = false;
      }
      if (value.isVector3) {
        return this.frustum.containsPoint(value);
      } else if (value.isMesh && value.geometry) {
        var mesh = value;
        if (!mesh.geometry.boundingBox) {
          mesh.geometry.computeBoundingBox();
        }
        box3.copy(mesh.geometry.boundingBox).applyMatrix4(mesh.matrixWorld);
        return this.frustum.intersectsBox(box3);
      } else if (value.isObject3D) {
        return this.frustum.intersectsObject(value);
      } else {
        return false;
      }
    }
    /**
     * Adds an object to the THREE scene
     */
  }, {
    key: "addObject",
    value: function addObject(object) {
      this.scene.add(object);
    }
    /**
     * Removes an object from the THREE scene
     */
  }, {
    key: "removeObject",
    value: function removeObject(object) {
      this.scene.remove(object);
    }
    /**
     * Calls `dispose` on all objects and textures
     * @internal
     */
  }, {
    key: "cleanScene",
    value: function cleanScene(object) {
      var _this77 = this;
      var disposeMaterial = function disposeMaterial(material) {
        var _material$map;
        (_material$map = material.map) === null || _material$map === void 0 ? void 0 : _material$map.dispose();
        if (material.uniforms) {
          Object.values(material.uniforms).forEach(function (uniform) {
            var _uniform$value, _uniform$value$dispos;
            (_uniform$value = uniform.value) === null || _uniform$value === void 0 ? void 0 : (_uniform$value$dispos = _uniform$value.dispose) === null || _uniform$value$dispos === void 0 ? void 0 : _uniform$value$dispos.call(_uniform$value);
          });
        }
        material.dispose();
      };
      object.traverse(function (item) {
        var _item$geometry;
        (_item$geometry = item.geometry) === null || _item$geometry === void 0 ? void 0 : _item$geometry.dispose();
        if (item.material) {
          if (Array.isArray(item.material)) {
            item.material.forEach(function (material) {
              disposeMaterial(material);
            });
          } else {
            disposeMaterial(item.material);
          }
        }
        if (!(item instanceof Scene)) {
          var _item$dispose;
          (_item$dispose = item.dispose) === null || _item$dispose === void 0 ? void 0 : _item$dispose.call(item);
        }
        if (item !== object) {
          _this77.cleanScene(item);
        }
      });
    }
  }]);
  return Renderer;
}(AbstractService);
var TextureLoader = /*#__PURE__*/function (_AbstractService4) {
  _inherits(TextureLoader, _AbstractService4);
  var _super63 = _createSuper(TextureLoader);
  /**
   * @internal
   */
  function TextureLoader(viewer) {
    var _this78;
    _classCallCheck(this, TextureLoader);
    _this78 = _super63.call(this, viewer);
    _this78.fileLoader = new FileLoader();
    _this78.fileLoader.setResponseType("blob");
    _this78.imageLoader = new ImageLoader();
    if (_this78.config.withCredentials) {
      _this78.fileLoader.setWithCredentials(true);
      _this78.imageLoader.setCrossOrigin("use-credentials");
    }
    return _this78;
  }
  /**
   * @internal
   */
  _createClass(TextureLoader, [{
    key: "destroy",
    value: function destroy() {
      this.abortLoading();
      _get(_getPrototypeOf(TextureLoader.prototype), "destroy", this).call(this);
    }
    /**
     * Cancels current HTTP requests
     * @internal
     */
  }, {
    key: "abortLoading",
    value: function abortLoading() {}
    /**
     * Loads a Blob with FileLoader
     */
  }, {
    key: "loadFile",
    value: function loadFile(url, onProgress, cacheKey) {
      var _this79 = this;
      var cached = Cache.get(url, cacheKey);
      if (cached) {
        if (cached instanceof Blob) {
          onProgress === null || onProgress === void 0 ? void 0 : onProgress(100);
          return Promise.resolve(cached);
        } else {
          Cache.remove(url, cacheKey);
        }
      }
      if (this.config.requestHeaders) {
        this.fileLoader.setRequestHeader(this.config.requestHeaders(url));
      }
      return new Promise(function (resolve, reject) {
        var progress = 0;
        onProgress === null || onProgress === void 0 ? void 0 : onProgress(progress);
        _this79.fileLoader.load(url, function (result) {
          progress = 100;
          onProgress === null || onProgress === void 0 ? void 0 : onProgress(progress);
          Cache.add(url, cacheKey, result);
          resolve(result);
        }, function (e) {
          if (e.lengthComputable) {
            var newProgress = e.loaded / e.total * 100;
            if (newProgress > progress) {
              progress = newProgress;
              onProgress === null || onProgress === void 0 ? void 0 : onProgress(progress);
            }
          }
        }, function (err) {
          reject(err);
        });
      });
    }
    /**
     * Loads an image with ImageLoader or with FileLoader if progress is tracked or if request headers are configured
     */
  }, {
    key: "loadImage",
    value: function loadImage(url, onProgress, cacheKey) {
      var _this80 = this;
      var cached = Cache.get(url, cacheKey);
      if (cached) {
        onProgress === null || onProgress === void 0 ? void 0 : onProgress(100);
        if (cached instanceof Blob) {
          return this.blobToImage(cached);
        } else {
          return Promise.resolve(cached);
        }
      }
      if (!onProgress && !this.config.requestHeaders) {
        return this.imageLoader.loadAsync(url).then(function (result) {
          Cache.add(url, cacheKey, result);
          return result;
        });
      } else {
        return this.loadFile(url, onProgress, cacheKey).then(function (blob) {
          return _this80.blobToImage(blob);
        });
      }
    }
    /**
     * Converts a file loaded with {@link loadFile} into an image
     */
  }, {
    key: "blobToImage",
    value: function blobToImage(blob) {
      return new Promise(function (resolve, reject) {
        var img = document.createElement("img");
        img.onload = function () {
          URL.revokeObjectURL(img.src);
          resolve(img);
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(blob);
      });
    }
    /**
     * Preload a panorama file without displaying it
     */
  }, {
    key: "preloadPanorama",
    value: function preloadPanorama(panorama) {
      if (this.viewer.adapter.supportsPreload(panorama)) {
        return this.viewer.adapter.loadTexture(panorama);
      } else {
        return Promise.reject(new PSVError("Current adapter does not support preload"));
      }
    }
  }]);
  return TextureLoader;
}(AbstractService);
var ViewerDynamics = /*#__PURE__*/function (_AbstractService5) {
  _inherits(ViewerDynamics, _AbstractService5);
  var _super64 = _createSuper(ViewerDynamics);
  /**
   * @internal
   */
  function ViewerDynamics(viewer) {
    var _this81;
    _classCallCheck(this, ViewerDynamics);
    _this81 = _super64.call(this, viewer);
    _this81.zoom = new _Dynamic(function (zoomLevel) {
      _this81.viewer.state.vFov = _this81.viewer.dataHelper.zoomLevelToFov(zoomLevel);
      _this81.viewer.state.hFov = _this81.viewer.dataHelper.vFovToHFov(_this81.viewer.state.vFov);
      _this81.viewer.dispatchEvent(new _ZoomUpdatedEvent2(zoomLevel));
    }, {
      defaultValue: _this81.viewer.config.defaultZoomLvl,
      min: 0,
      max: 100,
      wrap: false
    });
    _this81.position = new _MultiDynamic(function (position) {
      _this81.viewer.dataHelper.sphericalCoordsToVector3(position, _this81.viewer.state.direction);
      _this81.viewer.dispatchEvent(new _PositionUpdatedEvent2(position));
    }, {
      yaw: new _Dynamic(null, {
        defaultValue: _this81.config.defaultYaw,
        min: 0,
        max: 2 * Math.PI,
        wrap: true
      }),
      pitch: new _Dynamic(null, {
        defaultValue: _this81.config.defaultPitch,
        min: !_this81.viewer.state.littlePlanet ? -Math.PI / 2 : 0,
        max: !_this81.viewer.state.littlePlanet ? Math.PI / 2 : Math.PI * 2,
        wrap: _this81.viewer.state.littlePlanet
      })
    });
    _this81.updateSpeeds();
    return _this81;
  }
  /**
   * @internal
   */
  _createClass(ViewerDynamics, [{
    key: "updateSpeeds",
    value: function updateSpeeds() {
      this.zoom.setSpeed(this.config.zoomSpeed * 50);
      this.position.setSpeed(MathUtils.degToRad(this.config.moveSpeed * 50));
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function update(elapsed) {
      this.zoom.update(elapsed);
      this.position.update(elapsed);
    }
  }]);
  return ViewerDynamics;
}(AbstractService);
var ViewerState = /*#__PURE__*/_createClass(
/**
 * @internal
 */
// eslint-disable-next-line  @typescript-eslint/no-empty-function
function ViewerState() {
  _classCallCheck(this, ViewerState);
  /**
   * when all components are loaded
   */
  this.ready = false;
  /**
   * if the view needs to be renderer
   */
  this.needsUpdate = false;
  /**
   * number of plugins requesting to continuously render the scene
   */
  this.continuousUpdateCount = 0;
  /**
   * if the keyboard events are currently listened to
   */
  this.keyboardEnabled = false;
  /**
   * direction of the camera
   */
  this.direction = new Vector3(0, 0, _SPHERE_RADIUS);
  /**
   * vertical FOV
   */
  this.vFov = 60;
  /**
   * horizontal FOV
   */
  this.hFov = 60;
  /**
   * renderer aspect ratio
   */
  this.aspect = 1;
  /**
   * currently running animation
   */
  this.animation = null;
  /**
   * currently running transition
   */
  this.transitionAnimation = null;
  /**
   * promise of the last "setPanorama()" call
   */
  this.loadingPromise = null;
  /**
   * special tweaks for LittlePlanetAdapter
   */
  this.littlePlanet = false;
  /**
   * time of the last user action
   */
  this.idleTime = -1;
  /**
   * registered THREE objects observer
   */
  this.objectsObservers = {};
  /**
   * size of the container
   */
  this.size = {
    width: 0,
    height: 0
  };
});

// src/Viewer.ts
var Viewer = /*#__PURE__*/function (_TypedEventTarget2) {
  _inherits(Viewer, _TypedEventTarget2);
  var _super65 = _createSuper(Viewer);
  function Viewer(config) {
    var _this82$adapter$init, _this82$adapter;
    var _this82;
    _classCallCheck(this, Viewer);
    _this82 = _super65.call(this);
    /** @internal */
    _this82.plugins = {};
    /** @internal */
    _this82.children = [];
    _this82.onResize = _throttle(function () {
      return _this82.navbar.autoSize();
    }, 500);
    Cache.init();
    SYSTEM.load();
    _this82.state = new ViewerState();
    _this82.config = getViewerConfig(config);
    _this82.parent = _getElement(config.container);
    _this82.parent[_VIEWER_DATA] = _assertThisInitialized(_this82);
    _this82.container = document.createElement("div");
    _this82.container.classList.add("psv-container");
    _this82.parent.appendChild(_this82.container);
    _checkStylesheet(_this82.container, "core");
    _this82.adapter = new _this82.config.adapter[0](_assertThisInitialized(_this82), _this82.config.adapter[1]);
    _this82.renderer = new Renderer(_assertThisInitialized(_this82));
    _this82.textureLoader = new TextureLoader(_assertThisInitialized(_this82));
    _this82.eventsHandler = new EventsHandler(_assertThisInitialized(_this82));
    _this82.dataHelper = new DataHelper(_assertThisInitialized(_this82));
    _this82.dynamics = new ViewerDynamics(_assertThisInitialized(_this82));
    (_this82$adapter$init = (_this82$adapter = _this82.adapter).init) === null || _this82$adapter$init === void 0 ? void 0 : _this82$adapter$init.call(_this82$adapter);
    _this82.loader = new Loader(_assertThisInitialized(_this82));
    _this82.navbar = new Navbar(_assertThisInitialized(_this82));
    _this82.panel = new Panel(_assertThisInitialized(_this82));
    _this82.notification = new Notification(_assertThisInitialized(_this82));
    _this82.overlay = new Overlay(_assertThisInitialized(_this82));
    _this82.resize(_this82.config.size);
    _this82.setCursor(null);
    _resolveBoolean(SYSTEM.isTouchEnabled, function (enabled) {
      _toggleClass(_this82.container, "psv--is-touch", enabled);
    });
    _this82.config.plugins.forEach(function (_ref25) {
      var _ref26 = _slicedToArray(_ref25, 2),
        plugin = _ref26[0],
        opts = _ref26[1];
      _this82.plugins[plugin.id] = new plugin(_assertThisInitialized(_this82), opts);
    });
    for (var _i18 = 0, _Object$values4 = Object.values(_this82.plugins); _i18 < _Object$values4.length; _i18++) {
      var _plugin$init;
      var plugin = _Object$values4[_i18];
      (_plugin$init = plugin.init) === null || _plugin$init === void 0 ? void 0 : _plugin$init.call(plugin);
    }
    if (_this82.config.navbar) {
      _this82.navbar.setButtons(_this82.config.navbar);
    }
    if (!_this82.state.loadingPromise) {
      if (_this82.config.panorama) {
        _this82.setPanorama(_this82.config.panorama);
      } else {
        _this82.loader.show();
      }
    }
    return _this82;
  }
  /**
   * Destroys the viewer
   */
  _createClass(Viewer, [{
    key: "destroy",
    value: function destroy() {
      this.stopAll();
      this.stopKeyboardControl();
      this.exitFullscreen();
      for (var _i19 = 0, _Object$entries10 = Object.entries(this.plugins); _i19 < _Object$entries10.length; _i19++) {
        var _Object$entries10$_i = _slicedToArray(_Object$entries10[_i19], 2),
          id = _Object$entries10$_i[0],
          plugin = _Object$entries10$_i[1];
        plugin.destroy();
        delete this.plugins[id];
      }
      this.children.slice().forEach(function (child) {
        return child.destroy();
      });
      this.children.length = 0;
      this.eventsHandler.destroy();
      this.renderer.destroy();
      this.textureLoader.destroy();
      this.dataHelper.destroy();
      this.adapter.destroy();
      this.dynamics.destroy();
      this.parent.removeChild(this.container);
      delete this.parent[_VIEWER_DATA];
    }
  }, {
    key: "init",
    value: function init() {
      this.eventsHandler.init();
      this.renderer.init();
      if (this.config.navbar) {
        this.navbar.show();
      }
      if (this.config.keyboard === "always") {
        this.startKeyboardControl();
      }
      this.resetIdleTimer();
      this.state.ready = true;
      this.dispatchEvent(new _ReadyEvent2());
    }
    /**
     * Restarts the idle timer
     * @internal
     */
  }, {
    key: "resetIdleTimer",
    value: function resetIdleTimer() {
      this.state.idleTime = performance.now();
    }
    /**
     * Stops the idle timer
     * @internal
     */
  }, {
    key: "disableIdleTimer",
    value: function disableIdleTimer() {
      this.state.idleTime = -1;
    }
    /**
     * Returns the instance of a plugin if it exists
     * @example By plugin identifier
     * ```js
     * viewer.getPlugin('markers')
     * ```
     * @example By plugin class with TypeScript support
     * ```ts
     * viewer.getPlugin<MarkersPlugin>(MarkersPlugin)
     * ```
     */
  }, {
    key: "getPlugin",
    value: function getPlugin(pluginId) {
      if (typeof pluginId === "string") {
        return this.plugins[pluginId];
      } else {
        var pluginCtor = pluginInterop(pluginId);
        return pluginCtor ? this.plugins[pluginCtor.id] : null;
      }
    }
    /**
     * Returns the current position of the camera
     */
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this.dataHelper.cleanPosition(this.dynamics.position.current);
    }
    /**
     * Returns the current zoom level
     */
  }, {
    key: "getZoomLevel",
    value: function getZoomLevel() {
      return this.dynamics.zoom.current;
    }
    /**
     * Returns the current viewer size
     */
  }, {
    key: "getSize",
    value: function getSize() {
      return _objectSpread({}, this.state.size);
    }
    /**
     * Checks if the viewer is in fullscreen
     */
  }, {
    key: "isFullscreenEnabled",
    value: function isFullscreenEnabled() {
      return _isFullscreenEnabled(this.parent);
    }
    /**
     * Request a new render of the scene
     */
  }, {
    key: "needsUpdate",
    value: function needsUpdate() {
      this.state.needsUpdate = true;
    }
    /**
     * Request the scene to be continuously renderer (when using videos)
     */
  }, {
    key: "needsContinuousUpdate",
    value: function needsContinuousUpdate(enabled) {
      if (enabled) {
        this.state.continuousUpdateCount++;
      } else if (this.state.continuousUpdateCount > 0) {
        this.state.continuousUpdateCount--;
      }
    }
    /**
     * Resizes the scene if the viewer is resized
     */
  }, {
    key: "autoSize",
    value: function autoSize() {
      if (this.container.clientWidth !== this.state.size.width || this.container.clientHeight !== this.state.size.height) {
        this.state.size.width = Math.round(this.container.clientWidth);
        this.state.size.height = Math.round(this.container.clientHeight);
        this.state.aspect = this.state.size.width / this.state.size.height;
        this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov);
        this.dispatchEvent(new _SizeUpdatedEvent2(this.getSize()));
        this.onResize();
      }
    }
    /**
     * Loads a new panorama file
     * @description Loads a new panorama file, optionally changing the camera position/zoom and activating the transition animation.<br>
     * If the "options" parameter is not defined, the camera will not move and the ongoing animation will continue.<br>
     * If another loading is already in progress it will be aborted.
     * @returns promise resolved with false if the loading was aborted by another call
     */
  }, {
    key: "setPanorama",
    value: function setPanorama(path) {
      var _this$state$transitio,
        _this83 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.textureLoader.abortLoading();
      (_this$state$transitio = this.state.transitionAnimation) === null || _this$state$transitio === void 0 ? void 0 : _this$state$transitio.cancel();
      if (!this.state.ready) {
        ["sphereCorrection", "panoData"].forEach(function (opt) {
          if (!(opt in options)) {
            options[opt] = _this83.config[opt];
          }
        });
      }
      if (options.transition === void 0) {
        options.transition = true;
      }
      if (options.speed === void 0) {
        options.speed = _DEFAULT_TRANSITION;
      }
      if (options.showLoader === void 0) {
        options.showLoader = true;
      }
      if (options.caption === void 0) {
        options.caption = this.config.caption;
      }
      if (options.description === void 0) {
        options.description = this.config.description;
      }
      if (!options.panoData && typeof this.config.panoData === "function") {
        options.panoData = this.config.panoData;
      }
      var positionProvided = !_isNil(options.position);
      var zoomProvided = !_isNil(options.zoom);
      if (positionProvided || zoomProvided) {
        this.stopAll();
      }
      this.hideError();
      this.resetIdleTimer();
      this.config.panorama = path;
      this.config.caption = options.caption;
      this.config.description = options.description;
      var done = function done(err) {
        _this83.loader.hide();
        _this83.state.loadingPromise = null;
        if (_isAbortError(err)) {
          return false;
        } else if (err) {
          _this83.navbar.setCaption("");
          _this83.showError(_this83.config.lang.loadError);
          console.error(err);
          _this83.dispatchEvent(new _PanoramaErrorEvent2(path, err));
          throw err;
        } else {
          _this83.navbar.setCaption(_this83.config.caption);
          return true;
        }
      };
      this.navbar.setCaption("<em>".concat(this.config.loadingTxt || "", "</em>"));
      if (options.showLoader || !this.state.ready) {
        this.loader.show();
      }
      this.dispatchEvent(new _PanoramaLoadEvent2(path));
      var loadingPromise = this.adapter.loadTexture(this.config.panorama, true, options.panoData).then(function (textureData) {
        if (textureData.panorama !== _this83.config.panorama) {
          _this83.adapter.disposeTexture(textureData);
          throw _getAbortError();
        }
        return textureData;
      });
      if (!options.transition || !this.state.ready || !this.adapter.supportsTransition(this.config.panorama)) {
        this.state.loadingPromise = loadingPromise.then(function (textureData) {
          _this83.renderer.show();
          _this83.renderer.setTexture(textureData);
          _this83.renderer.setPanoramaPose(textureData.panoData);
          _this83.renderer.setSphereCorrection(options.sphereCorrection);
          if (!_this83.state.ready) {
            _this83.init();
          }
          _this83.dispatchEvent(new _PanoramaLoadedEvent2(textureData));
          if (zoomProvided) {
            _this83.zoom(options.zoom);
          }
          if (positionProvided) {
            _this83.rotate(options.position);
          }
        }).then(function () {
          return done();
        }, function (err) {
          return done(err);
        });
      } else {
        this.state.loadingPromise = loadingPromise.then(function (textureData) {
          _this83.loader.hide();
          _this83.dispatchEvent(new _PanoramaLoadedEvent2(textureData));
          _this83.state.transitionAnimation = _this83.renderer.transition(textureData, options);
          return _this83.state.transitionAnimation;
        }).then(function (completed) {
          _this83.state.transitionAnimation = null;
          if (!completed) {
            throw _getAbortError();
          }
        }).then(function () {
          return done();
        }, function (err) {
          return done(err);
        });
      }
      return this.state.loadingPromise;
    }
    /**
     * Update options
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var rawConfig = _objectSpread(_objectSpread({}, this.config), options);
      for (var _i20 = 0, _Object$entries11 = Object.entries(options); _i20 < _Object$entries11.length; _i20++) {
        var _Object$entries11$_i = _slicedToArray(_Object$entries11[_i20], 2),
          key = _Object$entries11$_i[0],
          value = _Object$entries11$_i[1];
        if (!(key in DEFAULTS)) {
          _logWarn("Unknown option ".concat(key));
          continue;
        }
        if (key in READONLY_OPTIONS) {
          _logWarn(READONLY_OPTIONS[key]);
          continue;
        }
        if (key in CONFIG_PARSERS) {
          value = CONFIG_PARSERS[key](value, {
            rawConfig: rawConfig,
            defValue: DEFAULTS[key]
          });
        }
        this.config[key] = value;
        switch (key) {
          case "mousemove":
            if (!this.state.cursorOverride) {
              this.setCursor(null);
            }
            break;
          case "caption":
            this.navbar.setCaption(this.config.caption);
            break;
          case "size":
            this.resize(this.config.size);
            break;
          case "sphereCorrection":
            this.renderer.setSphereCorrection(this.config.sphereCorrection);
            break;
          case "navbar":
          case "lang":
            this.navbar.setButtons(this.config.navbar);
            break;
          case "moveSpeed":
          case "zoomSpeed":
            this.dynamics.updateSpeeds();
            break;
          case "minFov":
          case "maxFov":
            this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov));
            this.dispatchEvent(new _ZoomUpdatedEvent2(this.getZoomLevel()));
            break;
          case "keyboard":
            if (this.config.keyboard === "always") {
              this.startKeyboardControl();
            } else {
              this.stopKeyboardControl();
            }
            break;
        }
      }
      this.needsUpdate();
      this.dispatchEvent(new _ConfigChangedEvent2(Object.keys(options)));
    }
    /**
     * Update options
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "setOption",
    value: function setOption(option, value) {
      this.setOptions(_defineProperty({}, option, value));
    }
    /**
     * Displays an error message over the viewer
     */
  }, {
    key: "showError",
    value: function showError(message) {
      this.overlay.show({
        id: _IDS.ERROR,
        image: error_default,
        title: message,
        dissmisable: false
      });
    }
    /**
     *  Hides the error message
     */
  }, {
    key: "hideError",
    value: function hideError() {
      this.overlay.hide(_IDS.ERROR);
    }
    /**
     * Rotates the view to specific position
     */
  }, {
    key: "rotate",
    value: function rotate(position) {
      var e = new _BeforeRotateEvent2(this.dataHelper.cleanPosition(position));
      this.dispatchEvent(e);
      if (e.defaultPrevented) {
        return;
      }
      this.dynamics.position.setValue(e.position);
    }
    /**
     * Zooms to a specific level between `maxFov` and `minFov`
     */
  }, {
    key: "zoom",
    value: function zoom(level) {
      this.dynamics.zoom.setValue(level);
    }
    /**
     * Increases the zoom level
     */
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.dynamics.zoom.step(step);
    }
    /**
     * Decreases the zoom level
     */
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.dynamics.zoom.step(-step);
    }
    /**
     * Rotates and zooms the view with a smooth animation
     */
  }, {
    key: "animate",
    value: function animate(options) {
      var _this84 = this;
      var positionProvided = _isExtendedPosition(options);
      var zoomProvided = !_isNil(options.zoom);
      var e = new _BeforeAnimateEvent2(positionProvided ? this.dataHelper.cleanPosition(options) : void 0, options.zoom);
      this.dispatchEvent(e);
      if (e.defaultPrevented) {
        return;
      }
      this.stopAll();
      var _this$dataHelper$getA = this.dataHelper.getAnimationProperties(options.speed, e.position, e.zoomLevel),
        duration = _this$dataHelper$getA.duration,
        properties = _this$dataHelper$getA.properties;
      if (!duration) {
        if (positionProvided) {
          this.rotate(e.position);
        }
        if (zoomProvided) {
          this.zoom(e.zoomLevel);
        }
        return new _Animation(null);
      }
      this.state.animation = new _Animation({
        properties: properties,
        duration: duration,
        easing: "inOutSine",
        onTick: function onTick(props) {
          if (positionProvided) {
            _this84.dynamics.position.setValue({
              yaw: props.yaw,
              pitch: props.pitch
            });
          }
          if (zoomProvided) {
            _this84.dynamics.zoom.setValue(props.zoom);
          }
        }
      });
      this.state.animation.then(function () {
        _this84.state.animation = null;
        _this84.resetIdleTimer();
      });
      return this.state.animation;
    }
    /**
     * Stops the ongoing animation
     * @description The return value is a Promise because the is no guaranty the animation can be stopped synchronously.
     */
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      if (this.state.animation) {
        this.state.animation.cancel();
        return this.state.animation;
      } else {
        return Promise.resolve();
      }
    }
    /**
     * Resizes the viewer
     */
  }, {
    key: "resize",
    value: function resize(size) {
      var _this85 = this;
      var s = size;
      ["width", "height"].forEach(function (dim) {
        if (size && s[dim]) {
          if (/^[0-9.]+$/.test(s[dim])) {
            s[dim] += "px";
          }
          _this85.parent.style[dim] = s[dim];
        }
      });
      this.autoSize();
    }
    /**
     * Enters the fullscreen mode
     */
  }, {
    key: "enterFullscreen",
    value: function enterFullscreen() {
      if (!this.isFullscreenEnabled()) {
        _requestFullscreen(this.parent);
      }
    }
    /**
     * Exits the fullscreen mode
     */
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (this.isFullscreenEnabled()) {
        _exitFullscreen();
      }
    }
    /**
     * Enters or exits the fullscreen mode
     */
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      if (!this.isFullscreenEnabled()) {
        this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    }
    /**
     * Enables the keyboard controls
     */
  }, {
    key: "startKeyboardControl",
    value: function startKeyboardControl() {
      this.state.keyboardEnabled = true;
    }
    /**
     * Disables the keyboard controls
     */
  }, {
    key: "stopKeyboardControl",
    value: function stopKeyboardControl() {
      this.state.keyboardEnabled = false;
    }
    /**
     * Creates a new tooltip
     * @description Use {@link Tooltip.move} to update the tooltip without re-create
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "createTooltip",
    value: function createTooltip(config) {
      return new Tooltip(this, config);
    }
    /**
     * Changes the global mouse cursor
     */
  }, {
    key: "setCursor",
    value: function setCursor(cursor) {
      this.state.cursorOverride = cursor;
      if (!cursor) {
        this.container.style.cursor = this.config.mousemove ? "move" : "default";
      } else {
        this.container.style.cursor = cursor;
      }
    }
    /**
     * Subscribes to events on objects in the three.js scene
     * @param userDataKey - only objects with the following `userData` will be observed
     */
  }, {
    key: "observeObjects",
    value: function observeObjects(userDataKey) {
      if (!this.state.objectsObservers[userDataKey]) {
        this.state.objectsObservers[userDataKey] = null;
      }
    }
    /**
     * Unsubscribes to events on objects
     */
  }, {
    key: "unobserveObjects",
    value: function unobserveObjects(userDataKey) {
      delete this.state.objectsObservers[userDataKey];
    }
    /**
     * Stops all current animations
     * @internal
     */
  }, {
    key: "stopAll",
    value: function stopAll() {
      this.dispatchEvent(new _StopAllEvent2());
      this.disableIdleTimer();
      return this.stopAnimation();
    }
  }]);
  return Viewer;
}(TypedEventTarget);

// src/index.ts
Cache$1.enabled = false;
ColorManagement.enabled = false;
export { AbstractAdapter, AbstractButton, AbstractComponent, AbstractConfigurablePlugin, AbstractPlugin, constants_exports as CONSTANTS, DEFAULTS, EquirectangularAdapter, PSVError, SYSTEM, TypedEvent, Viewer, events_exports as events, registerButton, utils_exports as utils };
//# sourceMappingURL=index.module.js.map
